// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@-moz-keyframes shake {
  59% {
    margin-left: 0;
  }
  60%, 80% {
    margin-left: 2px;
  }
  70%, 90% {
    margin-left: -2px;
  }
}
@-webkit-keyframes shake {
  59% {
    margin-left: 0;
  }
  60%, 80% {
    margin-left: 2px;
  }
  70%, 90% {
    margin-left: -2px;
  }
}
@-o-keyframes shake {
  59% {
    margin-left: 0;
  }
  60%, 80% {
    margin-left: 2px;
  }
  70%, 90% {
    margin-left: -2px;
  }
}
@keyframes shake {
  59% {
    margin-left: 0;
  }
  60%, 80% {
    margin-left: 2px;
  }
  70%, 90% {
    margin-left: -2px;
  }
}
.black {
  background-color: #000 !important;
  border-color: #000 !important;
}
.black--text {
  color: #000 !important;
  caret-color: #000 !important;
}
.white {
  background-color: #fff !important;
  border-color: #fff !important;
}
.white--text {
  color: #fff !important;
  caret-color: #fff !important;
}
.transparent {
  background-color: transparent !important;
  border-color: transparent !important;
}
.transparent--text {
  color: transparent !important;
  caret-color: transparent !important;
}
.red {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}
.red--text {
  color: #f44336 !important;
  caret-color: #f44336 !important;
}
.red.lighten-5 {
  background-color: #ffebee !important;
  border-color: #ffebee !important;
}
.red--text.text--lighten-5 {
  color: #ffebee !important;
  caret-color: #ffebee !important;
}
.red.lighten-4 {
  background-color: #ffcdd2 !important;
  border-color: #ffcdd2 !important;
}
.red--text.text--lighten-4 {
  color: #ffcdd2 !important;
  caret-color: #ffcdd2 !important;
}
.red.lighten-3 {
  background-color: #ef9a9a !important;
  border-color: #ef9a9a !important;
}
.red--text.text--lighten-3 {
  color: #ef9a9a !important;
  caret-color: #ef9a9a !important;
}
.red.lighten-2 {
  background-color: #e57373 !important;
  border-color: #e57373 !important;
}
.red--text.text--lighten-2 {
  color: #e57373 !important;
  caret-color: #e57373 !important;
}
.red.lighten-1 {
  background-color: #ef5350 !important;
  border-color: #ef5350 !important;
}
.red--text.text--lighten-1 {
  color: #ef5350 !important;
  caret-color: #ef5350 !important;
}
.red.darken-1 {
  background-color: #e53935 !important;
  border-color: #e53935 !important;
}
.red--text.text--darken-1 {
  color: #e53935 !important;
  caret-color: #e53935 !important;
}
.red.darken-2 {
  background-color: #d32f2f !important;
  border-color: #d32f2f !important;
}
.red--text.text--darken-2 {
  color: #d32f2f !important;
  caret-color: #d32f2f !important;
}
.red.darken-3 {
  background-color: #c62828 !important;
  border-color: #c62828 !important;
}
.red--text.text--darken-3 {
  color: #c62828 !important;
  caret-color: #c62828 !important;
}
.red.darken-4 {
  background-color: #b71c1c !important;
  border-color: #b71c1c !important;
}
.red--text.text--darken-4 {
  color: #b71c1c !important;
  caret-color: #b71c1c !important;
}
.red.accent-1 {
  background-color: #ff8a80 !important;
  border-color: #ff8a80 !important;
}
.red--text.text--accent-1 {
  color: #ff8a80 !important;
  caret-color: #ff8a80 !important;
}
.red.accent-2 {
  background-color: #ff5252 !important;
  border-color: #ff5252 !important;
}
.red--text.text--accent-2 {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}
.red.accent-3 {
  background-color: #ff1744 !important;
  border-color: #ff1744 !important;
}
.red--text.text--accent-3 {
  color: #ff1744 !important;
  caret-color: #ff1744 !important;
}
.red.accent-4 {
  background-color: #d50000 !important;
  border-color: #d50000 !important;
}
.red--text.text--accent-4 {
  color: #d50000 !important;
  caret-color: #d50000 !important;
}
.pink {
  background-color: #e91e63 !important;
  border-color: #e91e63 !important;
}
.pink--text {
  color: #e91e63 !important;
  caret-color: #e91e63 !important;
}
.pink.lighten-5 {
  background-color: #fce4ec !important;
  border-color: #fce4ec !important;
}
.pink--text.text--lighten-5 {
  color: #fce4ec !important;
  caret-color: #fce4ec !important;
}
.pink.lighten-4 {
  background-color: #f8bbd0 !important;
  border-color: #f8bbd0 !important;
}
.pink--text.text--lighten-4 {
  color: #f8bbd0 !important;
  caret-color: #f8bbd0 !important;
}
.pink.lighten-3 {
  background-color: #f48fb1 !important;
  border-color: #f48fb1 !important;
}
.pink--text.text--lighten-3 {
  color: #f48fb1 !important;
  caret-color: #f48fb1 !important;
}
.pink.lighten-2 {
  background-color: #f06292 !important;
  border-color: #f06292 !important;
}
.pink--text.text--lighten-2 {
  color: #f06292 !important;
  caret-color: #f06292 !important;
}
.pink.lighten-1 {
  background-color: #ec407a !important;
  border-color: #ec407a !important;
}
.pink--text.text--lighten-1 {
  color: #ec407a !important;
  caret-color: #ec407a !important;
}
.pink.darken-1 {
  background-color: #d81b60 !important;
  border-color: #d81b60 !important;
}
.pink--text.text--darken-1 {
  color: #d81b60 !important;
  caret-color: #d81b60 !important;
}
.pink.darken-2 {
  background-color: #c2185b !important;
  border-color: #c2185b !important;
}
.pink--text.text--darken-2 {
  color: #c2185b !important;
  caret-color: #c2185b !important;
}
.pink.darken-3 {
  background-color: #ad1457 !important;
  border-color: #ad1457 !important;
}
.pink--text.text--darken-3 {
  color: #ad1457 !important;
  caret-color: #ad1457 !important;
}
.pink.darken-4 {
  background-color: #880e4f !important;
  border-color: #880e4f !important;
}
.pink--text.text--darken-4 {
  color: #880e4f !important;
  caret-color: #880e4f !important;
}
.pink.accent-1 {
  background-color: #ff80ab !important;
  border-color: #ff80ab !important;
}
.pink--text.text--accent-1 {
  color: #ff80ab !important;
  caret-color: #ff80ab !important;
}
.pink.accent-2 {
  background-color: #ff4081 !important;
  border-color: #ff4081 !important;
}
.pink--text.text--accent-2 {
  color: #ff4081 !important;
  caret-color: #ff4081 !important;
}
.pink.accent-3 {
  background-color: #f50057 !important;
  border-color: #f50057 !important;
}
.pink--text.text--accent-3 {
  color: #f50057 !important;
  caret-color: #f50057 !important;
}
.pink.accent-4 {
  background-color: #c51162 !important;
  border-color: #c51162 !important;
}
.pink--text.text--accent-4 {
  color: #c51162 !important;
  caret-color: #c51162 !important;
}
.purple {
  background-color: #9c27b0 !important;
  border-color: #9c27b0 !important;
}
.purple--text {
  color: #9c27b0 !important;
  caret-color: #9c27b0 !important;
}
.purple.lighten-5 {
  background-color: #f3e5f5 !important;
  border-color: #f3e5f5 !important;
}
.purple--text.text--lighten-5 {
  color: #f3e5f5 !important;
  caret-color: #f3e5f5 !important;
}
.purple.lighten-4 {
  background-color: #e1bee7 !important;
  border-color: #e1bee7 !important;
}
.purple--text.text--lighten-4 {
  color: #e1bee7 !important;
  caret-color: #e1bee7 !important;
}
.purple.lighten-3 {
  background-color: #ce93d8 !important;
  border-color: #ce93d8 !important;
}
.purple--text.text--lighten-3 {
  color: #ce93d8 !important;
  caret-color: #ce93d8 !important;
}
.purple.lighten-2 {
  background-color: #ba68c8 !important;
  border-color: #ba68c8 !important;
}
.purple--text.text--lighten-2 {
  color: #ba68c8 !important;
  caret-color: #ba68c8 !important;
}
.purple.lighten-1 {
  background-color: #ab47bc !important;
  border-color: #ab47bc !important;
}
.purple--text.text--lighten-1 {
  color: #ab47bc !important;
  caret-color: #ab47bc !important;
}
.purple.darken-1 {
  background-color: #8e24aa !important;
  border-color: #8e24aa !important;
}
.purple--text.text--darken-1 {
  color: #8e24aa !important;
  caret-color: #8e24aa !important;
}
.purple.darken-2 {
  background-color: #7b1fa2 !important;
  border-color: #7b1fa2 !important;
}
.purple--text.text--darken-2 {
  color: #7b1fa2 !important;
  caret-color: #7b1fa2 !important;
}
.purple.darken-3 {
  background-color: #6a1b9a !important;
  border-color: #6a1b9a !important;
}
.purple--text.text--darken-3 {
  color: #6a1b9a !important;
  caret-color: #6a1b9a !important;
}
.purple.darken-4 {
  background-color: #4a148c !important;
  border-color: #4a148c !important;
}
.purple--text.text--darken-4 {
  color: #4a148c !important;
  caret-color: #4a148c !important;
}
.purple.accent-1 {
  background-color: #ea80fc !important;
  border-color: #ea80fc !important;
}
.purple--text.text--accent-1 {
  color: #ea80fc !important;
  caret-color: #ea80fc !important;
}
.purple.accent-2 {
  background-color: #e040fb !important;
  border-color: #e040fb !important;
}
.purple--text.text--accent-2 {
  color: #e040fb !important;
  caret-color: #e040fb !important;
}
.purple.accent-3 {
  background-color: #d500f9 !important;
  border-color: #d500f9 !important;
}
.purple--text.text--accent-3 {
  color: #d500f9 !important;
  caret-color: #d500f9 !important;
}
.purple.accent-4 {
  background-color: #a0f !important;
  border-color: #a0f !important;
}
.purple--text.text--accent-4 {
  color: #a0f !important;
  caret-color: #a0f !important;
}
.deep-purple {
  background-color: #673ab7 !important;
  border-color: #673ab7 !important;
}
.deep-purple--text {
  color: #673ab7 !important;
  caret-color: #673ab7 !important;
}
.deep-purple.lighten-5 {
  background-color: #ede7f6 !important;
  border-color: #ede7f6 !important;
}
.deep-purple--text.text--lighten-5 {
  color: #ede7f6 !important;
  caret-color: #ede7f6 !important;
}
.deep-purple.lighten-4 {
  background-color: #d1c4e9 !important;
  border-color: #d1c4e9 !important;
}
.deep-purple--text.text--lighten-4 {
  color: #d1c4e9 !important;
  caret-color: #d1c4e9 !important;
}
.deep-purple.lighten-3 {
  background-color: #b39ddb !important;
  border-color: #b39ddb !important;
}
.deep-purple--text.text--lighten-3 {
  color: #b39ddb !important;
  caret-color: #b39ddb !important;
}
.deep-purple.lighten-2 {
  background-color: #9575cd !important;
  border-color: #9575cd !important;
}
.deep-purple--text.text--lighten-2 {
  color: #9575cd !important;
  caret-color: #9575cd !important;
}
.deep-purple.lighten-1 {
  background-color: #7e57c2 !important;
  border-color: #7e57c2 !important;
}
.deep-purple--text.text--lighten-1 {
  color: #7e57c2 !important;
  caret-color: #7e57c2 !important;
}
.deep-purple.darken-1 {
  background-color: #5e35b1 !important;
  border-color: #5e35b1 !important;
}
.deep-purple--text.text--darken-1 {
  color: #5e35b1 !important;
  caret-color: #5e35b1 !important;
}
.deep-purple.darken-2 {
  background-color: #512da8 !important;
  border-color: #512da8 !important;
}
.deep-purple--text.text--darken-2 {
  color: #512da8 !important;
  caret-color: #512da8 !important;
}
.deep-purple.darken-3 {
  background-color: #4527a0 !important;
  border-color: #4527a0 !important;
}
.deep-purple--text.text--darken-3 {
  color: #4527a0 !important;
  caret-color: #4527a0 !important;
}
.deep-purple.darken-4 {
  background-color: #311b92 !important;
  border-color: #311b92 !important;
}
.deep-purple--text.text--darken-4 {
  color: #311b92 !important;
  caret-color: #311b92 !important;
}
.deep-purple.accent-1 {
  background-color: #b388ff !important;
  border-color: #b388ff !important;
}
.deep-purple--text.text--accent-1 {
  color: #b388ff !important;
  caret-color: #b388ff !important;
}
.deep-purple.accent-2 {
  background-color: #7c4dff !important;
  border-color: #7c4dff !important;
}
.deep-purple--text.text--accent-2 {
  color: #7c4dff !important;
  caret-color: #7c4dff !important;
}
.deep-purple.accent-3 {
  background-color: #651fff !important;
  border-color: #651fff !important;
}
.deep-purple--text.text--accent-3 {
  color: #651fff !important;
  caret-color: #651fff !important;
}
.deep-purple.accent-4 {
  background-color: #6200ea !important;
  border-color: #6200ea !important;
}
.deep-purple--text.text--accent-4 {
  color: #6200ea !important;
  caret-color: #6200ea !important;
}
.indigo {
  background-color: #3f51b5 !important;
  border-color: #3f51b5 !important;
}
.indigo--text {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}
.indigo.lighten-5 {
  background-color: #e8eaf6 !important;
  border-color: #e8eaf6 !important;
}
.indigo--text.text--lighten-5 {
  color: #e8eaf6 !important;
  caret-color: #e8eaf6 !important;
}
.indigo.lighten-4 {
  background-color: #c5cae9 !important;
  border-color: #c5cae9 !important;
}
.indigo--text.text--lighten-4 {
  color: #c5cae9 !important;
  caret-color: #c5cae9 !important;
}
.indigo.lighten-3 {
  background-color: #9fa8da !important;
  border-color: #9fa8da !important;
}
.indigo--text.text--lighten-3 {
  color: #9fa8da !important;
  caret-color: #9fa8da !important;
}
.indigo.lighten-2 {
  background-color: #7986cb !important;
  border-color: #7986cb !important;
}
.indigo--text.text--lighten-2 {
  color: #7986cb !important;
  caret-color: #7986cb !important;
}
.indigo.lighten-1 {
  background-color: #5c6bc0 !important;
  border-color: #5c6bc0 !important;
}
.indigo--text.text--lighten-1 {
  color: #5c6bc0 !important;
  caret-color: #5c6bc0 !important;
}
.indigo.darken-1 {
  background-color: #3949ab !important;
  border-color: #3949ab !important;
}
.indigo--text.text--darken-1 {
  color: #3949ab !important;
  caret-color: #3949ab !important;
}
.indigo.darken-2 {
  background-color: #303f9f !important;
  border-color: #303f9f !important;
}
.indigo--text.text--darken-2 {
  color: #303f9f !important;
  caret-color: #303f9f !important;
}
.indigo.darken-3 {
  background-color: #283593 !important;
  border-color: #283593 !important;
}
.indigo--text.text--darken-3 {
  color: #283593 !important;
  caret-color: #283593 !important;
}
.indigo.darken-4 {
  background-color: #1a237e !important;
  border-color: #1a237e !important;
}
.indigo--text.text--darken-4 {
  color: #1a237e !important;
  caret-color: #1a237e !important;
}
.indigo.accent-1 {
  background-color: #8c9eff !important;
  border-color: #8c9eff !important;
}
.indigo--text.text--accent-1 {
  color: #8c9eff !important;
  caret-color: #8c9eff !important;
}
.indigo.accent-2 {
  background-color: #536dfe !important;
  border-color: #536dfe !important;
}
.indigo--text.text--accent-2 {
  color: #536dfe !important;
  caret-color: #536dfe !important;
}
.indigo.accent-3 {
  background-color: #3d5afe !important;
  border-color: #3d5afe !important;
}
.indigo--text.text--accent-3 {
  color: #3d5afe !important;
  caret-color: #3d5afe !important;
}
.indigo.accent-4 {
  background-color: #304ffe !important;
  border-color: #304ffe !important;
}
.indigo--text.text--accent-4 {
  color: #304ffe !important;
  caret-color: #304ffe !important;
}
.blue {
  background-color: #2196f3 !important;
  border-color: #2196f3 !important;
}
.blue--text {
  color: #2196f3 !important;
  caret-color: #2196f3 !important;
}
.blue.lighten-5 {
  background-color: #e3f2fd !important;
  border-color: #e3f2fd !important;
}
.blue--text.text--lighten-5 {
  color: #e3f2fd !important;
  caret-color: #e3f2fd !important;
}
.blue.lighten-4 {
  background-color: #bbdefb !important;
  border-color: #bbdefb !important;
}
.blue--text.text--lighten-4 {
  color: #bbdefb !important;
  caret-color: #bbdefb !important;
}
.blue.lighten-3 {
  background-color: #90caf9 !important;
  border-color: #90caf9 !important;
}
.blue--text.text--lighten-3 {
  color: #90caf9 !important;
  caret-color: #90caf9 !important;
}
.blue.lighten-2 {
  background-color: #64b5f6 !important;
  border-color: #64b5f6 !important;
}
.blue--text.text--lighten-2 {
  color: #64b5f6 !important;
  caret-color: #64b5f6 !important;
}
.blue.lighten-1 {
  background-color: #42a5f5 !important;
  border-color: #42a5f5 !important;
}
.blue--text.text--lighten-1 {
  color: #42a5f5 !important;
  caret-color: #42a5f5 !important;
}
.blue.darken-1 {
  background-color: #1e88e5 !important;
  border-color: #1e88e5 !important;
}
.blue--text.text--darken-1 {
  color: #1e88e5 !important;
  caret-color: #1e88e5 !important;
}
.blue.darken-2 {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
}
.blue--text.text--darken-2 {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
}
.blue.darken-3 {
  background-color: #1565c0 !important;
  border-color: #1565c0 !important;
}
.blue--text.text--darken-3 {
  color: #1565c0 !important;
  caret-color: #1565c0 !important;
}
.blue.darken-4 {
  background-color: #0d47a1 !important;
  border-color: #0d47a1 !important;
}
.blue--text.text--darken-4 {
  color: #0d47a1 !important;
  caret-color: #0d47a1 !important;
}
.blue.accent-1 {
  background-color: #82b1ff !important;
  border-color: #82b1ff !important;
}
.blue--text.text--accent-1 {
  color: #82b1ff !important;
  caret-color: #82b1ff !important;
}
.blue.accent-2 {
  background-color: #448aff !important;
  border-color: #448aff !important;
}
.blue--text.text--accent-2 {
  color: #448aff !important;
  caret-color: #448aff !important;
}
.blue.accent-3 {
  background-color: #2979ff !important;
  border-color: #2979ff !important;
}
.blue--text.text--accent-3 {
  color: #2979ff !important;
  caret-color: #2979ff !important;
}
.blue.accent-4 {
  background-color: #2962ff !important;
  border-color: #2962ff !important;
}
.blue--text.text--accent-4 {
  color: #2962ff !important;
  caret-color: #2962ff !important;
}
.light-blue {
  background-color: #03a9f4 !important;
  border-color: #03a9f4 !important;
}
.light-blue--text {
  color: #03a9f4 !important;
  caret-color: #03a9f4 !important;
}
.light-blue.lighten-5 {
  background-color: #e1f5fe !important;
  border-color: #e1f5fe !important;
}
.light-blue--text.text--lighten-5 {
  color: #e1f5fe !important;
  caret-color: #e1f5fe !important;
}
.light-blue.lighten-4 {
  background-color: #b3e5fc !important;
  border-color: #b3e5fc !important;
}
.light-blue--text.text--lighten-4 {
  color: #b3e5fc !important;
  caret-color: #b3e5fc !important;
}
.light-blue.lighten-3 {
  background-color: #81d4fa !important;
  border-color: #81d4fa !important;
}
.light-blue--text.text--lighten-3 {
  color: #81d4fa !important;
  caret-color: #81d4fa !important;
}
.light-blue.lighten-2 {
  background-color: #4fc3f7 !important;
  border-color: #4fc3f7 !important;
}
.light-blue--text.text--lighten-2 {
  color: #4fc3f7 !important;
  caret-color: #4fc3f7 !important;
}
.light-blue.lighten-1 {
  background-color: #29b6f6 !important;
  border-color: #29b6f6 !important;
}
.light-blue--text.text--lighten-1 {
  color: #29b6f6 !important;
  caret-color: #29b6f6 !important;
}
.light-blue.darken-1 {
  background-color: #039be5 !important;
  border-color: #039be5 !important;
}
.light-blue--text.text--darken-1 {
  color: #039be5 !important;
  caret-color: #039be5 !important;
}
.light-blue.darken-2 {
  background-color: #0288d1 !important;
  border-color: #0288d1 !important;
}
.light-blue--text.text--darken-2 {
  color: #0288d1 !important;
  caret-color: #0288d1 !important;
}
.light-blue.darken-3 {
  background-color: #0277bd !important;
  border-color: #0277bd !important;
}
.light-blue--text.text--darken-3 {
  color: #0277bd !important;
  caret-color: #0277bd !important;
}
.light-blue.darken-4 {
  background-color: #01579b !important;
  border-color: #01579b !important;
}
.light-blue--text.text--darken-4 {
  color: #01579b !important;
  caret-color: #01579b !important;
}
.light-blue.accent-1 {
  background-color: #80d8ff !important;
  border-color: #80d8ff !important;
}
.light-blue--text.text--accent-1 {
  color: #80d8ff !important;
  caret-color: #80d8ff !important;
}
.light-blue.accent-2 {
  background-color: #40c4ff !important;
  border-color: #40c4ff !important;
}
.light-blue--text.text--accent-2 {
  color: #40c4ff !important;
  caret-color: #40c4ff !important;
}
.light-blue.accent-3 {
  background-color: #00b0ff !important;
  border-color: #00b0ff !important;
}
.light-blue--text.text--accent-3 {
  color: #00b0ff !important;
  caret-color: #00b0ff !important;
}
.light-blue.accent-4 {
  background-color: #0091ea !important;
  border-color: #0091ea !important;
}
.light-blue--text.text--accent-4 {
  color: #0091ea !important;
  caret-color: #0091ea !important;
}
.cyan {
  background-color: #00bcd4 !important;
  border-color: #00bcd4 !important;
}
.cyan--text {
  color: #00bcd4 !important;
  caret-color: #00bcd4 !important;
}
.cyan.lighten-5 {
  background-color: #e0f7fa !important;
  border-color: #e0f7fa !important;
}
.cyan--text.text--lighten-5 {
  color: #e0f7fa !important;
  caret-color: #e0f7fa !important;
}
.cyan.lighten-4 {
  background-color: #b2ebf2 !important;
  border-color: #b2ebf2 !important;
}
.cyan--text.text--lighten-4 {
  color: #b2ebf2 !important;
  caret-color: #b2ebf2 !important;
}
.cyan.lighten-3 {
  background-color: #80deea !important;
  border-color: #80deea !important;
}
.cyan--text.text--lighten-3 {
  color: #80deea !important;
  caret-color: #80deea !important;
}
.cyan.lighten-2 {
  background-color: #4dd0e1 !important;
  border-color: #4dd0e1 !important;
}
.cyan--text.text--lighten-2 {
  color: #4dd0e1 !important;
  caret-color: #4dd0e1 !important;
}
.cyan.lighten-1 {
  background-color: #26c6da !important;
  border-color: #26c6da !important;
}
.cyan--text.text--lighten-1 {
  color: #26c6da !important;
  caret-color: #26c6da !important;
}
.cyan.darken-1 {
  background-color: #00acc1 !important;
  border-color: #00acc1 !important;
}
.cyan--text.text--darken-1 {
  color: #00acc1 !important;
  caret-color: #00acc1 !important;
}
.cyan.darken-2 {
  background-color: #0097a7 !important;
  border-color: #0097a7 !important;
}
.cyan--text.text--darken-2 {
  color: #0097a7 !important;
  caret-color: #0097a7 !important;
}
.cyan.darken-3 {
  background-color: #00838f !important;
  border-color: #00838f !important;
}
.cyan--text.text--darken-3 {
  color: #00838f !important;
  caret-color: #00838f !important;
}
.cyan.darken-4 {
  background-color: #006064 !important;
  border-color: #006064 !important;
}
.cyan--text.text--darken-4 {
  color: #006064 !important;
  caret-color: #006064 !important;
}
.cyan.accent-1 {
  background-color: #84ffff !important;
  border-color: #84ffff !important;
}
.cyan--text.text--accent-1 {
  color: #84ffff !important;
  caret-color: #84ffff !important;
}
.cyan.accent-2 {
  background-color: #18ffff !important;
  border-color: #18ffff !important;
}
.cyan--text.text--accent-2 {
  color: #18ffff !important;
  caret-color: #18ffff !important;
}
.cyan.accent-3 {
  background-color: #00e5ff !important;
  border-color: #00e5ff !important;
}
.cyan--text.text--accent-3 {
  color: #00e5ff !important;
  caret-color: #00e5ff !important;
}
.cyan.accent-4 {
  background-color: #00b8d4 !important;
  border-color: #00b8d4 !important;
}
.cyan--text.text--accent-4 {
  color: #00b8d4 !important;
  caret-color: #00b8d4 !important;
}
.teal {
  background-color: #009688 !important;
  border-color: #009688 !important;
}
.teal--text {
  color: #009688 !important;
  caret-color: #009688 !important;
}
.teal.lighten-5 {
  background-color: #e0f2f1 !important;
  border-color: #e0f2f1 !important;
}
.teal--text.text--lighten-5 {
  color: #e0f2f1 !important;
  caret-color: #e0f2f1 !important;
}
.teal.lighten-4 {
  background-color: #b2dfdb !important;
  border-color: #b2dfdb !important;
}
.teal--text.text--lighten-4 {
  color: #b2dfdb !important;
  caret-color: #b2dfdb !important;
}
.teal.lighten-3 {
  background-color: #80cbc4 !important;
  border-color: #80cbc4 !important;
}
.teal--text.text--lighten-3 {
  color: #80cbc4 !important;
  caret-color: #80cbc4 !important;
}
.teal.lighten-2 {
  background-color: #4db6ac !important;
  border-color: #4db6ac !important;
}
.teal--text.text--lighten-2 {
  color: #4db6ac !important;
  caret-color: #4db6ac !important;
}
.teal.lighten-1 {
  background-color: #26a69a !important;
  border-color: #26a69a !important;
}
.teal--text.text--lighten-1 {
  color: #26a69a !important;
  caret-color: #26a69a !important;
}
.teal.darken-1 {
  background-color: #00897b !important;
  border-color: #00897b !important;
}
.teal--text.text--darken-1 {
  color: #00897b !important;
  caret-color: #00897b !important;
}
.teal.darken-2 {
  background-color: #00796b !important;
  border-color: #00796b !important;
}
.teal--text.text--darken-2 {
  color: #00796b !important;
  caret-color: #00796b !important;
}
.teal.darken-3 {
  background-color: #00695c !important;
  border-color: #00695c !important;
}
.teal--text.text--darken-3 {
  color: #00695c !important;
  caret-color: #00695c !important;
}
.teal.darken-4 {
  background-color: #004d40 !important;
  border-color: #004d40 !important;
}
.teal--text.text--darken-4 {
  color: #004d40 !important;
  caret-color: #004d40 !important;
}
.teal.accent-1 {
  background-color: #a7ffeb !important;
  border-color: #a7ffeb !important;
}
.teal--text.text--accent-1 {
  color: #a7ffeb !important;
  caret-color: #a7ffeb !important;
}
.teal.accent-2 {
  background-color: #64ffda !important;
  border-color: #64ffda !important;
}
.teal--text.text--accent-2 {
  color: #64ffda !important;
  caret-color: #64ffda !important;
}
.teal.accent-3 {
  background-color: #1de9b6 !important;
  border-color: #1de9b6 !important;
}
.teal--text.text--accent-3 {
  color: #1de9b6 !important;
  caret-color: #1de9b6 !important;
}
.teal.accent-4 {
  background-color: #00bfa5 !important;
  border-color: #00bfa5 !important;
}
.teal--text.text--accent-4 {
  color: #00bfa5 !important;
  caret-color: #00bfa5 !important;
}
.green {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}
.green--text {
  color: #4caf50 !important;
  caret-color: #4caf50 !important;
}
.green.lighten-5 {
  background-color: #e8f5e9 !important;
  border-color: #e8f5e9 !important;
}
.green--text.text--lighten-5 {
  color: #e8f5e9 !important;
  caret-color: #e8f5e9 !important;
}
.green.lighten-4 {
  background-color: #c8e6c9 !important;
  border-color: #c8e6c9 !important;
}
.green--text.text--lighten-4 {
  color: #c8e6c9 !important;
  caret-color: #c8e6c9 !important;
}
.green.lighten-3 {
  background-color: #a5d6a7 !important;
  border-color: #a5d6a7 !important;
}
.green--text.text--lighten-3 {
  color: #a5d6a7 !important;
  caret-color: #a5d6a7 !important;
}
.green.lighten-2 {
  background-color: #81c784 !important;
  border-color: #81c784 !important;
}
.green--text.text--lighten-2 {
  color: #81c784 !important;
  caret-color: #81c784 !important;
}
.green.lighten-1 {
  background-color: #66bb6a !important;
  border-color: #66bb6a !important;
}
.green--text.text--lighten-1 {
  color: #66bb6a !important;
  caret-color: #66bb6a !important;
}
.green.darken-1 {
  background-color: #43a047 !important;
  border-color: #43a047 !important;
}
.green--text.text--darken-1 {
  color: #43a047 !important;
  caret-color: #43a047 !important;
}
.green.darken-2 {
  background-color: #388e3c !important;
  border-color: #388e3c !important;
}
.green--text.text--darken-2 {
  color: #388e3c !important;
  caret-color: #388e3c !important;
}
.green.darken-3 {
  background-color: #2e7d32 !important;
  border-color: #2e7d32 !important;
}
.green--text.text--darken-3 {
  color: #2e7d32 !important;
  caret-color: #2e7d32 !important;
}
.green.darken-4 {
  background-color: #1b5e20 !important;
  border-color: #1b5e20 !important;
}
.green--text.text--darken-4 {
  color: #1b5e20 !important;
  caret-color: #1b5e20 !important;
}
.green.accent-1 {
  background-color: #b9f6ca !important;
  border-color: #b9f6ca !important;
}
.green--text.text--accent-1 {
  color: #b9f6ca !important;
  caret-color: #b9f6ca !important;
}
.green.accent-2 {
  background-color: #69f0ae !important;
  border-color: #69f0ae !important;
}
.green--text.text--accent-2 {
  color: #69f0ae !important;
  caret-color: #69f0ae !important;
}
.green.accent-3 {
  background-color: #00e676 !important;
  border-color: #00e676 !important;
}
.green--text.text--accent-3 {
  color: #00e676 !important;
  caret-color: #00e676 !important;
}
.green.accent-4 {
  background-color: #00c853 !important;
  border-color: #00c853 !important;
}
.green--text.text--accent-4 {
  color: #00c853 !important;
  caret-color: #00c853 !important;
}
.light-green {
  background-color: #8bc34a !important;
  border-color: #8bc34a !important;
}
.light-green--text {
  color: #8bc34a !important;
  caret-color: #8bc34a !important;
}
.light-green.lighten-5 {
  background-color: #f1f8e9 !important;
  border-color: #f1f8e9 !important;
}
.light-green--text.text--lighten-5 {
  color: #f1f8e9 !important;
  caret-color: #f1f8e9 !important;
}
.light-green.lighten-4 {
  background-color: #dcedc8 !important;
  border-color: #dcedc8 !important;
}
.light-green--text.text--lighten-4 {
  color: #dcedc8 !important;
  caret-color: #dcedc8 !important;
}
.light-green.lighten-3 {
  background-color: #c5e1a5 !important;
  border-color: #c5e1a5 !important;
}
.light-green--text.text--lighten-3 {
  color: #c5e1a5 !important;
  caret-color: #c5e1a5 !important;
}
.light-green.lighten-2 {
  background-color: #aed581 !important;
  border-color: #aed581 !important;
}
.light-green--text.text--lighten-2 {
  color: #aed581 !important;
  caret-color: #aed581 !important;
}
.light-green.lighten-1 {
  background-color: #9ccc65 !important;
  border-color: #9ccc65 !important;
}
.light-green--text.text--lighten-1 {
  color: #9ccc65 !important;
  caret-color: #9ccc65 !important;
}
.light-green.darken-1 {
  background-color: #7cb342 !important;
  border-color: #7cb342 !important;
}
.light-green--text.text--darken-1 {
  color: #7cb342 !important;
  caret-color: #7cb342 !important;
}
.light-green.darken-2 {
  background-color: #689f38 !important;
  border-color: #689f38 !important;
}
.light-green--text.text--darken-2 {
  color: #689f38 !important;
  caret-color: #689f38 !important;
}
.light-green.darken-3 {
  background-color: #558b2f !important;
  border-color: #558b2f !important;
}
.light-green--text.text--darken-3 {
  color: #558b2f !important;
  caret-color: #558b2f !important;
}
.light-green.darken-4 {
  background-color: #33691e !important;
  border-color: #33691e !important;
}
.light-green--text.text--darken-4 {
  color: #33691e !important;
  caret-color: #33691e !important;
}
.light-green.accent-1 {
  background-color: #ccff90 !important;
  border-color: #ccff90 !important;
}
.light-green--text.text--accent-1 {
  color: #ccff90 !important;
  caret-color: #ccff90 !important;
}
.light-green.accent-2 {
  background-color: #b2ff59 !important;
  border-color: #b2ff59 !important;
}
.light-green--text.text--accent-2 {
  color: #b2ff59 !important;
  caret-color: #b2ff59 !important;
}
.light-green.accent-3 {
  background-color: #76ff03 !important;
  border-color: #76ff03 !important;
}
.light-green--text.text--accent-3 {
  color: #76ff03 !important;
  caret-color: #76ff03 !important;
}
.light-green.accent-4 {
  background-color: #64dd17 !important;
  border-color: #64dd17 !important;
}
.light-green--text.text--accent-4 {
  color: #64dd17 !important;
  caret-color: #64dd17 !important;
}
.lime {
  background-color: #cddc39 !important;
  border-color: #cddc39 !important;
}
.lime--text {
  color: #cddc39 !important;
  caret-color: #cddc39 !important;
}
.lime.lighten-5 {
  background-color: #f9fbe7 !important;
  border-color: #f9fbe7 !important;
}
.lime--text.text--lighten-5 {
  color: #f9fbe7 !important;
  caret-color: #f9fbe7 !important;
}
.lime.lighten-4 {
  background-color: #f0f4c3 !important;
  border-color: #f0f4c3 !important;
}
.lime--text.text--lighten-4 {
  color: #f0f4c3 !important;
  caret-color: #f0f4c3 !important;
}
.lime.lighten-3 {
  background-color: #e6ee9c !important;
  border-color: #e6ee9c !important;
}
.lime--text.text--lighten-3 {
  color: #e6ee9c !important;
  caret-color: #e6ee9c !important;
}
.lime.lighten-2 {
  background-color: #dce775 !important;
  border-color: #dce775 !important;
}
.lime--text.text--lighten-2 {
  color: #dce775 !important;
  caret-color: #dce775 !important;
}
.lime.lighten-1 {
  background-color: #d4e157 !important;
  border-color: #d4e157 !important;
}
.lime--text.text--lighten-1 {
  color: #d4e157 !important;
  caret-color: #d4e157 !important;
}
.lime.darken-1 {
  background-color: #c0ca33 !important;
  border-color: #c0ca33 !important;
}
.lime--text.text--darken-1 {
  color: #c0ca33 !important;
  caret-color: #c0ca33 !important;
}
.lime.darken-2 {
  background-color: #afb42b !important;
  border-color: #afb42b !important;
}
.lime--text.text--darken-2 {
  color: #afb42b !important;
  caret-color: #afb42b !important;
}
.lime.darken-3 {
  background-color: #9e9d24 !important;
  border-color: #9e9d24 !important;
}
.lime--text.text--darken-3 {
  color: #9e9d24 !important;
  caret-color: #9e9d24 !important;
}
.lime.darken-4 {
  background-color: #827717 !important;
  border-color: #827717 !important;
}
.lime--text.text--darken-4 {
  color: #827717 !important;
  caret-color: #827717 !important;
}
.lime.accent-1 {
  background-color: #f4ff81 !important;
  border-color: #f4ff81 !important;
}
.lime--text.text--accent-1 {
  color: #f4ff81 !important;
  caret-color: #f4ff81 !important;
}
.lime.accent-2 {
  background-color: #eeff41 !important;
  border-color: #eeff41 !important;
}
.lime--text.text--accent-2 {
  color: #eeff41 !important;
  caret-color: #eeff41 !important;
}
.lime.accent-3 {
  background-color: #c6ff00 !important;
  border-color: #c6ff00 !important;
}
.lime--text.text--accent-3 {
  color: #c6ff00 !important;
  caret-color: #c6ff00 !important;
}
.lime.accent-4 {
  background-color: #aeea00 !important;
  border-color: #aeea00 !important;
}
.lime--text.text--accent-4 {
  color: #aeea00 !important;
  caret-color: #aeea00 !important;
}
.yellow {
  background-color: #ffeb3b !important;
  border-color: #ffeb3b !important;
}
.yellow--text {
  color: #ffeb3b !important;
  caret-color: #ffeb3b !important;
}
.yellow.lighten-5 {
  background-color: #fffde7 !important;
  border-color: #fffde7 !important;
}
.yellow--text.text--lighten-5 {
  color: #fffde7 !important;
  caret-color: #fffde7 !important;
}
.yellow.lighten-4 {
  background-color: #fff9c4 !important;
  border-color: #fff9c4 !important;
}
.yellow--text.text--lighten-4 {
  color: #fff9c4 !important;
  caret-color: #fff9c4 !important;
}
.yellow.lighten-3 {
  background-color: #fff59d !important;
  border-color: #fff59d !important;
}
.yellow--text.text--lighten-3 {
  color: #fff59d !important;
  caret-color: #fff59d !important;
}
.yellow.lighten-2 {
  background-color: #fff176 !important;
  border-color: #fff176 !important;
}
.yellow--text.text--lighten-2 {
  color: #fff176 !important;
  caret-color: #fff176 !important;
}
.yellow.lighten-1 {
  background-color: #ffee58 !important;
  border-color: #ffee58 !important;
}
.yellow--text.text--lighten-1 {
  color: #ffee58 !important;
  caret-color: #ffee58 !important;
}
.yellow.darken-1 {
  background-color: #fdd835 !important;
  border-color: #fdd835 !important;
}
.yellow--text.text--darken-1 {
  color: #fdd835 !important;
  caret-color: #fdd835 !important;
}
.yellow.darken-2 {
  background-color: #fbc02d !important;
  border-color: #fbc02d !important;
}
.yellow--text.text--darken-2 {
  color: #fbc02d !important;
  caret-color: #fbc02d !important;
}
.yellow.darken-3 {
  background-color: #f9a825 !important;
  border-color: #f9a825 !important;
}
.yellow--text.text--darken-3 {
  color: #f9a825 !important;
  caret-color: #f9a825 !important;
}
.yellow.darken-4 {
  background-color: #f57f17 !important;
  border-color: #f57f17 !important;
}
.yellow--text.text--darken-4 {
  color: #f57f17 !important;
  caret-color: #f57f17 !important;
}
.yellow.accent-1 {
  background-color: #ffff8d !important;
  border-color: #ffff8d !important;
}
.yellow--text.text--accent-1 {
  color: #ffff8d !important;
  caret-color: #ffff8d !important;
}
.yellow.accent-2 {
  background-color: #ff0 !important;
  border-color: #ff0 !important;
}
.yellow--text.text--accent-2 {
  color: #ff0 !important;
  caret-color: #ff0 !important;
}
.yellow.accent-3 {
  background-color: #ffea00 !important;
  border-color: #ffea00 !important;
}
.yellow--text.text--accent-3 {
  color: #ffea00 !important;
  caret-color: #ffea00 !important;
}
.yellow.accent-4 {
  background-color: #ffd600 !important;
  border-color: #ffd600 !important;
}
.yellow--text.text--accent-4 {
  color: #ffd600 !important;
  caret-color: #ffd600 !important;
}
.amber {
  background-color: #ffc107 !important;
  border-color: #ffc107 !important;
}
.amber--text {
  color: #ffc107 !important;
  caret-color: #ffc107 !important;
}
.amber.lighten-5 {
  background-color: #fff8e1 !important;
  border-color: #fff8e1 !important;
}
.amber--text.text--lighten-5 {
  color: #fff8e1 !important;
  caret-color: #fff8e1 !important;
}
.amber.lighten-4 {
  background-color: #ffecb3 !important;
  border-color: #ffecb3 !important;
}
.amber--text.text--lighten-4 {
  color: #ffecb3 !important;
  caret-color: #ffecb3 !important;
}
.amber.lighten-3 {
  background-color: #ffe082 !important;
  border-color: #ffe082 !important;
}
.amber--text.text--lighten-3 {
  color: #ffe082 !important;
  caret-color: #ffe082 !important;
}
.amber.lighten-2 {
  background-color: #ffd54f !important;
  border-color: #ffd54f !important;
}
.amber--text.text--lighten-2 {
  color: #ffd54f !important;
  caret-color: #ffd54f !important;
}
.amber.lighten-1 {
  background-color: #ffca28 !important;
  border-color: #ffca28 !important;
}
.amber--text.text--lighten-1 {
  color: #ffca28 !important;
  caret-color: #ffca28 !important;
}
.amber.darken-1 {
  background-color: #ffb300 !important;
  border-color: #ffb300 !important;
}
.amber--text.text--darken-1 {
  color: #ffb300 !important;
  caret-color: #ffb300 !important;
}
.amber.darken-2 {
  background-color: #ffa000 !important;
  border-color: #ffa000 !important;
}
.amber--text.text--darken-2 {
  color: #ffa000 !important;
  caret-color: #ffa000 !important;
}
.amber.darken-3 {
  background-color: #ff8f00 !important;
  border-color: #ff8f00 !important;
}
.amber--text.text--darken-3 {
  color: #ff8f00 !important;
  caret-color: #ff8f00 !important;
}
.amber.darken-4 {
  background-color: #ff6f00 !important;
  border-color: #ff6f00 !important;
}
.amber--text.text--darken-4 {
  color: #ff6f00 !important;
  caret-color: #ff6f00 !important;
}
.amber.accent-1 {
  background-color: #ffe57f !important;
  border-color: #ffe57f !important;
}
.amber--text.text--accent-1 {
  color: #ffe57f !important;
  caret-color: #ffe57f !important;
}
.amber.accent-2 {
  background-color: #ffd740 !important;
  border-color: #ffd740 !important;
}
.amber--text.text--accent-2 {
  color: #ffd740 !important;
  caret-color: #ffd740 !important;
}
.amber.accent-3 {
  background-color: #ffc400 !important;
  border-color: #ffc400 !important;
}
.amber--text.text--accent-3 {
  color: #ffc400 !important;
  caret-color: #ffc400 !important;
}
.amber.accent-4 {
  background-color: #ffab00 !important;
  border-color: #ffab00 !important;
}
.amber--text.text--accent-4 {
  color: #ffab00 !important;
  caret-color: #ffab00 !important;
}
.orange {
  background-color: #ff9800 !important;
  border-color: #ff9800 !important;
}
.orange--text {
  color: #ff9800 !important;
  caret-color: #ff9800 !important;
}
.orange.lighten-5 {
  background-color: #fff3e0 !important;
  border-color: #fff3e0 !important;
}
.orange--text.text--lighten-5 {
  color: #fff3e0 !important;
  caret-color: #fff3e0 !important;
}
.orange.lighten-4 {
  background-color: #ffe0b2 !important;
  border-color: #ffe0b2 !important;
}
.orange--text.text--lighten-4 {
  color: #ffe0b2 !important;
  caret-color: #ffe0b2 !important;
}
.orange.lighten-3 {
  background-color: #ffcc80 !important;
  border-color: #ffcc80 !important;
}
.orange--text.text--lighten-3 {
  color: #ffcc80 !important;
  caret-color: #ffcc80 !important;
}
.orange.lighten-2 {
  background-color: #ffb74d !important;
  border-color: #ffb74d !important;
}
.orange--text.text--lighten-2 {
  color: #ffb74d !important;
  caret-color: #ffb74d !important;
}
.orange.lighten-1 {
  background-color: #ffa726 !important;
  border-color: #ffa726 !important;
}
.orange--text.text--lighten-1 {
  color: #ffa726 !important;
  caret-color: #ffa726 !important;
}
.orange.darken-1 {
  background-color: #fb8c00 !important;
  border-color: #fb8c00 !important;
}
.orange--text.text--darken-1 {
  color: #fb8c00 !important;
  caret-color: #fb8c00 !important;
}
.orange.darken-2 {
  background-color: #f57c00 !important;
  border-color: #f57c00 !important;
}
.orange--text.text--darken-2 {
  color: #f57c00 !important;
  caret-color: #f57c00 !important;
}
.orange.darken-3 {
  background-color: #ef6c00 !important;
  border-color: #ef6c00 !important;
}
.orange--text.text--darken-3 {
  color: #ef6c00 !important;
  caret-color: #ef6c00 !important;
}
.orange.darken-4 {
  background-color: #e65100 !important;
  border-color: #e65100 !important;
}
.orange--text.text--darken-4 {
  color: #e65100 !important;
  caret-color: #e65100 !important;
}
.orange.accent-1 {
  background-color: #ffd180 !important;
  border-color: #ffd180 !important;
}
.orange--text.text--accent-1 {
  color: #ffd180 !important;
  caret-color: #ffd180 !important;
}
.orange.accent-2 {
  background-color: #ffab40 !important;
  border-color: #ffab40 !important;
}
.orange--text.text--accent-2 {
  color: #ffab40 !important;
  caret-color: #ffab40 !important;
}
.orange.accent-3 {
  background-color: #ff9100 !important;
  border-color: #ff9100 !important;
}
.orange--text.text--accent-3 {
  color: #ff9100 !important;
  caret-color: #ff9100 !important;
}
.orange.accent-4 {
  background-color: #ff6d00 !important;
  border-color: #ff6d00 !important;
}
.orange--text.text--accent-4 {
  color: #ff6d00 !important;
  caret-color: #ff6d00 !important;
}
.deep-orange {
  background-color: #ff5722 !important;
  border-color: #ff5722 !important;
}
.deep-orange--text {
  color: #ff5722 !important;
  caret-color: #ff5722 !important;
}
.deep-orange.lighten-5 {
  background-color: #fbe9e7 !important;
  border-color: #fbe9e7 !important;
}
.deep-orange--text.text--lighten-5 {
  color: #fbe9e7 !important;
  caret-color: #fbe9e7 !important;
}
.deep-orange.lighten-4 {
  background-color: #ffccbc !important;
  border-color: #ffccbc !important;
}
.deep-orange--text.text--lighten-4 {
  color: #ffccbc !important;
  caret-color: #ffccbc !important;
}
.deep-orange.lighten-3 {
  background-color: #ffab91 !important;
  border-color: #ffab91 !important;
}
.deep-orange--text.text--lighten-3 {
  color: #ffab91 !important;
  caret-color: #ffab91 !important;
}
.deep-orange.lighten-2 {
  background-color: #ff8a65 !important;
  border-color: #ff8a65 !important;
}
.deep-orange--text.text--lighten-2 {
  color: #ff8a65 !important;
  caret-color: #ff8a65 !important;
}
.deep-orange.lighten-1 {
  background-color: #ff7043 !important;
  border-color: #ff7043 !important;
}
.deep-orange--text.text--lighten-1 {
  color: #ff7043 !important;
  caret-color: #ff7043 !important;
}
.deep-orange.darken-1 {
  background-color: #f4511e !important;
  border-color: #f4511e !important;
}
.deep-orange--text.text--darken-1 {
  color: #f4511e !important;
  caret-color: #f4511e !important;
}
.deep-orange.darken-2 {
  background-color: #e64a19 !important;
  border-color: #e64a19 !important;
}
.deep-orange--text.text--darken-2 {
  color: #e64a19 !important;
  caret-color: #e64a19 !important;
}
.deep-orange.darken-3 {
  background-color: #d84315 !important;
  border-color: #d84315 !important;
}
.deep-orange--text.text--darken-3 {
  color: #d84315 !important;
  caret-color: #d84315 !important;
}
.deep-orange.darken-4 {
  background-color: #bf360c !important;
  border-color: #bf360c !important;
}
.deep-orange--text.text--darken-4 {
  color: #bf360c !important;
  caret-color: #bf360c !important;
}
.deep-orange.accent-1 {
  background-color: #ff9e80 !important;
  border-color: #ff9e80 !important;
}
.deep-orange--text.text--accent-1 {
  color: #ff9e80 !important;
  caret-color: #ff9e80 !important;
}
.deep-orange.accent-2 {
  background-color: #ff6e40 !important;
  border-color: #ff6e40 !important;
}
.deep-orange--text.text--accent-2 {
  color: #ff6e40 !important;
  caret-color: #ff6e40 !important;
}
.deep-orange.accent-3 {
  background-color: #ff3d00 !important;
  border-color: #ff3d00 !important;
}
.deep-orange--text.text--accent-3 {
  color: #ff3d00 !important;
  caret-color: #ff3d00 !important;
}
.deep-orange.accent-4 {
  background-color: #dd2c00 !important;
  border-color: #dd2c00 !important;
}
.deep-orange--text.text--accent-4 {
  color: #dd2c00 !important;
  caret-color: #dd2c00 !important;
}
.brown {
  background-color: #795548 !important;
  border-color: #795548 !important;
}
.brown--text {
  color: #795548 !important;
  caret-color: #795548 !important;
}
.brown.lighten-5 {
  background-color: #efebe9 !important;
  border-color: #efebe9 !important;
}
.brown--text.text--lighten-5 {
  color: #efebe9 !important;
  caret-color: #efebe9 !important;
}
.brown.lighten-4 {
  background-color: #d7ccc8 !important;
  border-color: #d7ccc8 !important;
}
.brown--text.text--lighten-4 {
  color: #d7ccc8 !important;
  caret-color: #d7ccc8 !important;
}
.brown.lighten-3 {
  background-color: #bcaaa4 !important;
  border-color: #bcaaa4 !important;
}
.brown--text.text--lighten-3 {
  color: #bcaaa4 !important;
  caret-color: #bcaaa4 !important;
}
.brown.lighten-2 {
  background-color: #a1887f !important;
  border-color: #a1887f !important;
}
.brown--text.text--lighten-2 {
  color: #a1887f !important;
  caret-color: #a1887f !important;
}
.brown.lighten-1 {
  background-color: #8d6e63 !important;
  border-color: #8d6e63 !important;
}
.brown--text.text--lighten-1 {
  color: #8d6e63 !important;
  caret-color: #8d6e63 !important;
}
.brown.darken-1 {
  background-color: #6d4c41 !important;
  border-color: #6d4c41 !important;
}
.brown--text.text--darken-1 {
  color: #6d4c41 !important;
  caret-color: #6d4c41 !important;
}
.brown.darken-2 {
  background-color: #5d4037 !important;
  border-color: #5d4037 !important;
}
.brown--text.text--darken-2 {
  color: #5d4037 !important;
  caret-color: #5d4037 !important;
}
.brown.darken-3 {
  background-color: #4e342e !important;
  border-color: #4e342e !important;
}
.brown--text.text--darken-3 {
  color: #4e342e !important;
  caret-color: #4e342e !important;
}
.brown.darken-4 {
  background-color: #3e2723 !important;
  border-color: #3e2723 !important;
}
.brown--text.text--darken-4 {
  color: #3e2723 !important;
  caret-color: #3e2723 !important;
}
.blue-grey {
  background-color: #607d8b !important;
  border-color: #607d8b !important;
}
.blue-grey--text {
  color: #607d8b !important;
  caret-color: #607d8b !important;
}
.blue-grey.lighten-5 {
  background-color: #eceff1 !important;
  border-color: #eceff1 !important;
}
.blue-grey--text.text--lighten-5 {
  color: #eceff1 !important;
  caret-color: #eceff1 !important;
}
.blue-grey.lighten-4 {
  background-color: #cfd8dc !important;
  border-color: #cfd8dc !important;
}
.blue-grey--text.text--lighten-4 {
  color: #cfd8dc !important;
  caret-color: #cfd8dc !important;
}
.blue-grey.lighten-3 {
  background-color: #b0bec5 !important;
  border-color: #b0bec5 !important;
}
.blue-grey--text.text--lighten-3 {
  color: #b0bec5 !important;
  caret-color: #b0bec5 !important;
}
.blue-grey.lighten-2 {
  background-color: #90a4ae !important;
  border-color: #90a4ae !important;
}
.blue-grey--text.text--lighten-2 {
  color: #90a4ae !important;
  caret-color: #90a4ae !important;
}
.blue-grey.lighten-1 {
  background-color: #78909c !important;
  border-color: #78909c !important;
}
.blue-grey--text.text--lighten-1 {
  color: #78909c !important;
  caret-color: #78909c !important;
}
.blue-grey.darken-1 {
  background-color: #546e7a !important;
  border-color: #546e7a !important;
}
.blue-grey--text.text--darken-1 {
  color: #546e7a !important;
  caret-color: #546e7a !important;
}
.blue-grey.darken-2 {
  background-color: #455a64 !important;
  border-color: #455a64 !important;
}
.blue-grey--text.text--darken-2 {
  color: #455a64 !important;
  caret-color: #455a64 !important;
}
.blue-grey.darken-3 {
  background-color: #37474f !important;
  border-color: #37474f !important;
}
.blue-grey--text.text--darken-3 {
  color: #37474f !important;
  caret-color: #37474f !important;
}
.blue-grey.darken-4 {
  background-color: #263238 !important;
  border-color: #263238 !important;
}
.blue-grey--text.text--darken-4 {
  color: #263238 !important;
  caret-color: #263238 !important;
}
.grey {
  background-color: #9e9e9e !important;
  border-color: #9e9e9e !important;
}
.grey--text {
  color: #9e9e9e !important;
  caret-color: #9e9e9e !important;
}
.grey.lighten-5 {
  background-color: #fafafa !important;
  border-color: #fafafa !important;
}
.grey--text.text--lighten-5 {
  color: #fafafa !important;
  caret-color: #fafafa !important;
}
.grey.lighten-4 {
  background-color: #f5f5f5 !important;
  border-color: #f5f5f5 !important;
}
.grey--text.text--lighten-4 {
  color: #f5f5f5 !important;
  caret-color: #f5f5f5 !important;
}
.grey.lighten-3 {
  background-color: #eee !important;
  border-color: #eee !important;
}
.grey--text.text--lighten-3 {
  color: #eee !important;
  caret-color: #eee !important;
}
.grey.lighten-2 {
  background-color: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
}
.grey--text.text--lighten-2 {
  color: #e0e0e0 !important;
  caret-color: #e0e0e0 !important;
}
.grey.lighten-1 {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd !important;
}
.grey--text.text--lighten-1 {
  color: #bdbdbd !important;
  caret-color: #bdbdbd !important;
}
.grey.darken-1 {
  background-color: #757575 !important;
  border-color: #757575 !important;
}
.grey--text.text--darken-1 {
  color: #757575 !important;
  caret-color: #757575 !important;
}
.grey.darken-2 {
  background-color: #616161 !important;
  border-color: #616161 !important;
}
.grey--text.text--darken-2 {
  color: #616161 !important;
  caret-color: #616161 !important;
}
.grey.darken-3 {
  background-color: #424242 !important;
  border-color: #424242 !important;
}
.grey--text.text--darken-3 {
  color: #424242 !important;
  caret-color: #424242 !important;
}
.grey.darken-4 {
  background-color: #212121 !important;
  border-color: #212121 !important;
}
.grey--text.text--darken-4 {
  color: #212121 !important;
  caret-color: #212121 !important;
}
.shades.black {
  background-color: #000 !important;
  border-color: #000 !important;
}
.shades--text.text--black {
  color: #000 !important;
  caret-color: #000 !important;
}
.shades.white {
  background-color: #fff !important;
  border-color: #fff !important;
}
.shades--text.text--white {
  color: #fff !important;
  caret-color: #fff !important;
}
.shades.transparent {
  background-color: transparent !important;
  border-color: transparent !important;
}
.shades--text.text--transparent {
  color: transparent !important;
  caret-color: transparent !important;
}
.elevation-0 {
  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12) !important;
}
.elevation-1 {
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important;
}
.elevation-2 {
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important;
}
.elevation-3 {
  box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12) !important;
}
.elevation-4 {
  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12) !important;
}
.elevation-5 {
  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12) !important;
}
.elevation-6 {
  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12) !important;
}
.elevation-7 {
  box-shadow: 0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12) !important;
}
.elevation-8 {
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12) !important;
}
.elevation-9 {
  box-shadow: 0px 5px 6px -3px rgba(0,0,0,0.2), 0px 9px 12px 1px rgba(0,0,0,0.14), 0px 3px 16px 2px rgba(0,0,0,0.12) !important;
}
.elevation-10 {
  box-shadow: 0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12) !important;
}
.elevation-11 {
  box-shadow: 0px 6px 7px -4px rgba(0,0,0,0.2), 0px 11px 15px 1px rgba(0,0,0,0.14), 0px 4px 20px 3px rgba(0,0,0,0.12) !important;
}
.elevation-12 {
  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12) !important;
}
.elevation-13 {
  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 13px 19px 2px rgba(0,0,0,0.14), 0px 5px 24px 4px rgba(0,0,0,0.12) !important;
}
.elevation-14 {
  box-shadow: 0px 7px 9px -4px rgba(0,0,0,0.2), 0px 14px 21px 2px rgba(0,0,0,0.14), 0px 5px 26px 4px rgba(0,0,0,0.12) !important;
}
.elevation-15 {
  box-shadow: 0px 8px 9px -5px rgba(0,0,0,0.2), 0px 15px 22px 2px rgba(0,0,0,0.14), 0px 6px 28px 5px rgba(0,0,0,0.12) !important;
}
.elevation-16 {
  box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12) !important;
}
.elevation-17 {
  box-shadow: 0px 8px 11px -5px rgba(0,0,0,0.2), 0px 17px 26px 2px rgba(0,0,0,0.14), 0px 6px 32px 5px rgba(0,0,0,0.12) !important;
}
.elevation-18 {
  box-shadow: 0px 9px 11px -5px rgba(0,0,0,0.2), 0px 18px 28px 2px rgba(0,0,0,0.14), 0px 7px 34px 6px rgba(0,0,0,0.12) !important;
}
.elevation-19 {
  box-shadow: 0px 9px 12px -6px rgba(0,0,0,0.2), 0px 19px 29px 2px rgba(0,0,0,0.14), 0px 7px 36px 6px rgba(0,0,0,0.12) !important;
}
.elevation-20 {
  box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 20px 31px 3px rgba(0,0,0,0.14), 0px 8px 38px 7px rgba(0,0,0,0.12) !important;
}
.elevation-21 {
  box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 21px 33px 3px rgba(0,0,0,0.14), 0px 8px 40px 7px rgba(0,0,0,0.12) !important;
}
.elevation-22 {
  box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.2), 0px 22px 35px 3px rgba(0,0,0,0.14), 0px 8px 42px 7px rgba(0,0,0,0.12) !important;
}
.elevation-23 {
  box-shadow: 0px 11px 14px -7px rgba(0,0,0,0.2), 0px 23px 36px 3px rgba(0,0,0,0.14), 0px 9px 44px 8px rgba(0,0,0,0.12) !important;
}
.elevation-24 {
  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12) !important;
}
html {
  box-sizing: border-box;
  overflow-y: scroll; /* All browsers without overlaying scrollbars */
  -webkit-text-size-adjust: 100%; /* iOS 8+ */
}
*,
::before,
::after {
  box-sizing: inherit;
}
::before,
::after {
  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */
  vertical-align: inherit;
}
* {
  background-repeat: no-repeat; /* Set \`background-repeat: no-repeat\` to all elements */
  padding: 0; /* Reset \`padding\` and \`margin\` of all elements */
  margin: 0;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
hr {
  overflow: visible; /* Show the overflow in Edge and IE */
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
main,
menu,
nav,
section,
summary {
  display: block;
}
summary {
  display: list-item; /* Add the correct display in all browsers */
}
small {
  font-size: 80%; /* Set font-size to 80% in \`small\` elements */
}
[hidden],
template {
  display: none; /* Add the correct display in IE */
}
abbr[title] {
  border-bottom: 1px dotted; /* Add a bordered underline effect in all browsers */
  text-decoration: none; /* Remove text decoration in Firefox 40+ */
}
a {
  background-color: transparent; /* Remove the gray background on active links in IE 10 */
  -webkit-text-decoration-skip: objects; /* Remove gaps in links underline in iOS 8+ and Safari 8+ */
}
a:active,
a:hover {
  outline-width: 0; /* Remove the outline when hovering in all browsers */
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace; /* Specify the font family of code elements */
}
b,
strong {
  font-weight: bolder; /* Correct style set to \`bold\` in Edge 12+, Safari 6.2+, and Chrome 18+ */
}
dfn {
  font-style: italic; /* Address styling not present in Safari and Chrome */
}
mark {
  background-color: #ff0;
  color: #000;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
input {
  border-radius: 0;
}
button,
[type="button"],
[type="reset"],
[type="submit"],
[role="button"] {
  cursor: pointer;
}
[disabled] {
  cursor: default;
}
[type="number"] {
  width: auto; /* Firefox 36+ */
}
[type="search"] {
  -webkit-appearance: textfield; /* Safari 8+ */
}
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; /* Safari 8 */
}
textarea {
  overflow: auto; /* Internet Explorer 11+ */
  resize: vertical; /* Specify textarea resizability */
}
button,
input,
optgroup,
select,
textarea {
  font: inherit; /* Specify font inheritance of form elements */
}
optgroup {
  font-weight: bold; /* Restore the font weight unset by the previous rule. */
}
button {
  overflow: visible; /* Address \`overflow\` set to \`hidden\` in IE 8/9/10/11 */
}
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: 0;
  padding: 0;
}
button:-moz-focusring,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  outline: 0;
  border: 0;
}
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */
}
button,
select {
  text-transform: none; /* Firefox 40+, Internet Explorer 11- */
}
button,
input,
select,
textarea {
  background-color: transparent;
  border-style: none;
  color: inherit;
}
select {
  -moz-appearance: none; /* Firefox 36+ */
  -webkit-appearance: none; /* Chrome 41+ */
}
select::-ms-expand {
  display: none; /* Internet Explorer 11+ */
}
select::-ms-value {
  color: currentColor; /* Internet Explorer 11+ */
}
legend {
  border: 0; /* Correct \`color\` not being inherited in IE 8/9/10/11 */
  color: inherit; /* Correct the color inheritance from \`fieldset\` elements in IE */
  display: table; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge and IE */
  white-space: normal; /* Correct the text wrapping in Edge and IE */
}
::-webkit-file-upload-button {
  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS and Safari */
  font: inherit; /* Change font properties to \`inherit\` in Chrome and Safari */
}
[type="search"] {
  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */
  outline-offset: -2px; /* Correct the outline style in Safari */
}
img {
  border-style: none; /* Remove border when inside \`a\` element in IE 8/9/10 */
}
progress {
  vertical-align: baseline;
}
svg:not(:root) {
  overflow: hidden; /* Internet Explorer 11- */
}
audio,
canvas,
progress,
video {
  display: inline-block; /* Internet Explorer 11+, Windows Phone 8.1+ */
}
@media screen {
  [hidden~="screen"] {
    display: inherit;
  }
  [hidden~="screen"]:not(:active):not(:focus):not(:target) {
    position: absolute !important;
    clip: rect(0 0 0 0) !important;
  }
}
[aria-busy="true"] {
  cursor: progress;
}
[aria-controls] {
  cursor: pointer;
}
[aria-disabled] {
  cursor: default;
}
::-moz-selection {
  background-color: #b3d4fc; /* Required when declaring ::selection */
  color: #000;
  text-shadow: none;
}
::selection {
  background-color: #b3d4fc; /* Required when declaring ::selection */
  color: #000;
  text-shadow: none;
}
.bottom-sheet-transition-enter {
  transform: translateY(100%);
}
.bottom-sheet-transition-leave-to {
  transform: translateY(100%);
}
.carousel-transition-enter {
  transform: translate(100%, 0);
}
.carousel-transition-leave,
.carousel-transition-leave-to {
  position: absolute;
  top: 0;
  transform: translate(-100%, 0);
}
.carousel-reverse-transition-enter {
  transform: translate(-100%, 0);
}
.carousel-reverse-transition-leave,
.carousel-reverse-transition-leave-to {
  position: absolute;
  top: 0;
  transform: translate(100%, 0);
}
.dialog-transition-enter,
.dialog-transition-leave-to {
  transform: scale(0.5);
  opacity: 0;
}
.dialog-transition-enter-to,
.dialog-transition-leave {
  opacity: 1;
}
.dialog-bottom-transition-enter,
.dialog-bottom-transition-leave-to {
  transform: translateY(100%);
}
.picker-transition-enter-active,
.picker-reverse-transition-enter-active,
.picker-transition-leave-active,
.picker-reverse-transition-leave-active {
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
}
.picker-transition-enter,
.picker-reverse-transition-enter,
.picker-transition-leave-to,
.picker-reverse-transition-leave-to {
  opacity: 0;
}
.picker-transition-leave,
.picker-reverse-transition-leave,
.picker-transition-leave-active,
.picker-reverse-transition-leave-active,
.picker-transition-leave-to,
.picker-reverse-transition-leave-to {
  position: absolute !important;
}
.picker-transition-enter {
  transform: translate(0, 100%);
}
.picker-transition-leave-to {
  transform: translate(0, -100%);
}
.picker-reverse-transition-enter {
  transform: translate(0, -100%);
}
.picker-reverse-transition-leave-to {
  transform: translate(0, 100%);
}
.picker-title-transition-enter-to,
.picker-title-transition-leave {
  transform: translate(0, 0);
}
.picker-title-transition-enter {
  transform: translate(-100%, 0);
}
.picker-title-transition-leave-to {
  opacity: 0;
  transform: translate(100%, 0);
}
.picker-title-transition-leave,
.picker-title-transition-leave-to,
.picker-title-transition-leave-active {
  position: absolute !important;
}
.tab-transition-enter {
  transform: translate(100%, 0);
}
.tab-transition-leave,
.tab-transition-leave-active {
  position: absolute;
  top: 0;
}
.tab-transition-leave-to {
  position: absolute;
  transform: translate(-100%, 0);
}
.tab-reverse-transition-enter {
  transform: translate(-100%, 0);
}
.tab-reverse-transition-leave,
.tab-reverse-transition-leave-to {
  top: 0;
  position: absolute;
  transform: translate(100%, 0);
}
.expand-transition-enter-active,
.expand-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.expand-transition-move {
  transition: transform 0.6s;
}
.expand-x-transition-enter-active,
.expand-x-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.expand-x-transition-move {
  transition: transform 0.6s;
}
.scale-transition-enter-active,
.scale-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.scale-transition-move {
  transition: transform 0.6s;
}
.scale-transition-enter,
.scale-transition-leave,
.scale-transition-leave-to {
  opacity: 0;
  transform: scale(0);
}
.message-transition-enter-active,
.message-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.message-transition-move {
  transition: transform 0.6s;
}
.message-transition-enter,
.message-transition-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
.message-transition-leave,
.message-transition-leave-active {
  position: absolute;
}
.slide-y-transition-enter-active,
.slide-y-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-y-transition-move {
  transition: transform 0.6s;
}
.slide-y-transition-enter,
.slide-y-transition-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
.slide-y-reverse-transition-enter-active,
.slide-y-reverse-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-y-reverse-transition-move {
  transition: transform 0.6s;
}
.slide-y-reverse-transition-enter,
.slide-y-reverse-transition-leave-to {
  opacity: 0;
  transform: translateY(15px);
}
.scroll-y-transition-enter-active,
.scroll-y-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.scroll-y-transition-move {
  transition: transform 0.6s;
}
.scroll-y-transition-enter,
.scroll-y-transition-leave-to {
  opacity: 0;
}
.scroll-y-transition-enter {
  transform: translateY(-15px);
}
.scroll-y-transition-leave-to {
  transform: translateY(15px);
}
.scroll-y-reverse-transition-enter-active,
.scroll-y-reverse-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.scroll-y-reverse-transition-move {
  transition: transform 0.6s;
}
.scroll-y-reverse-transition-enter,
.scroll-y-reverse-transition-leave-to {
  opacity: 0;
}
.scroll-y-reverse-transition-enter {
  transform: translateY(15px);
}
.scroll-y-reverse-transition-leave-to {
  transform: translateY(-15px);
}
.scroll-x-transition-enter-active,
.scroll-x-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.scroll-x-transition-move {
  transition: transform 0.6s;
}
.scroll-x-transition-enter,
.scroll-x-transition-leave-to {
  opacity: 0;
}
.scroll-x-transition-enter {
  transform: translateX(-15px);
}
.scroll-x-transition-leave-to {
  transform: translateX(15px);
}
.scroll-x-reverse-transition-enter-active,
.scroll-x-reverse-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.scroll-x-reverse-transition-move {
  transition: transform 0.6s;
}
.scroll-x-reverse-transition-enter,
.scroll-x-reverse-transition-leave-to {
  opacity: 0;
}
.scroll-x-reverse-transition-enter {
  transform: translateX(15px);
}
.scroll-x-reverse-transition-leave-to {
  transform: translateX(-15px);
}
.slide-x-transition-enter-active,
.slide-x-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-x-transition-move {
  transition: transform 0.6s;
}
.slide-x-transition-enter,
.slide-x-transition-leave-to {
  opacity: 0;
  transform: translateX(-15px);
}
.slide-x-reverse-transition-enter-active,
.slide-x-reverse-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-x-reverse-transition-move {
  transition: transform 0.6s;
}
.slide-x-reverse-transition-enter,
.slide-x-reverse-transition-leave-to {
  opacity: 0;
  transform: translateX(15px);
}
.fade-transition-enter-active,
.fade-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.fade-transition-move {
  transition: transform 0.6s;
}
.fade-transition-enter,
.fade-transition-leave-to {
  opacity: 0;
}
.fab-transition-enter-active,
.fab-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.fab-transition-move {
  transition: transform 0.6s;
}
.fab-transition-enter,
.fab-transition-leave-to {
  transform: scale(0) rotate(-45deg);
}
.blockquote {
  padding: 16px 0 16px 24px;
  font-size: 18px;
  font-weight: 300;
}
code,
kbd {
  display: inline-block;
  border-radius: 3px;
  white-space: pre-wrap;
  font-size: 85%;
  font-weight: 900;
}
code:after,
kbd:after,
code:before,
kbd:before {
  content: "\\00a0";
  letter-spacing: -1px;
}
code {
  background-color: #f5f5f5;
  color: #bd4147;
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}
kbd {
  background: #616161;
  color: #fff;
}
html {
  font-size: 14px;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.application {
  font-family: 'Roboto', sans-serif;
  line-height: 1.5;
}
::-ms-clear,
::-ms-reveal {
  display: none;
}
ul,
ol {
  padding-left: 24px;
}
.display-4 {
  font-size: 112px !important;
  font-weight: 300;
  line-height: 1 !important;
  letter-spacing: -0.04em !important;
  font-family: 'Roboto', sans-serif !important;
}
.display-3 {
  font-size: 56px !important;
  font-weight: 400;
  line-height: 1.35 !important;
  letter-spacing: -0.02em !important;
  font-family: 'Roboto', sans-serif !important;
}
.display-2 {
  font-size: 45px !important;
  font-weight: 400;
  line-height: 48px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.display-1 {
  font-size: 34px !important;
  font-weight: 400;
  line-height: 40px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.headline {
  font-size: 24px !important;
  font-weight: 400;
  line-height: 32px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.title {
  font-size: 20px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: 'Roboto', sans-serif !important;
}
.subheading {
  font-size: 16px !important;
  font-weight: 400;
}
.body-2 {
  font-size: 14px !important;
  font-weight: 500;
}
.body-1 {
  font-size: 14px !important;
  font-weight: 400;
}
.caption {
  font-size: 12px !important;
  font-weight: 400;
}
p {
  margin-bottom: 16px;
}
@media only print {
  .hidden-print-only {
    display: none !important;
  }
}
@media only screen {
  .hidden-screen-only {
    display: none !important;
  }
}
@media only screen and (max-width: 599px) {
  .hidden-xs-only {
    display: none !important;
  }
}
@media only screen and (min-width: 600px) and (max-width: 959px) {
  .hidden-sm-only {
    display: none !important;
  }
}
@media only screen and (max-width: 959px) {
  .hidden-sm-and-down {
    display: none !important;
  }
}
@media only screen and (min-width: 600px) {
  .hidden-sm-and-up {
    display: none !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1263px) {
  .hidden-md-only {
    display: none !important;
  }
}
@media only screen and (max-width: 1263px) {
  .hidden-md-and-down {
    display: none !important;
  }
}
@media only screen and (min-width: 960px) {
  .hidden-md-and-up {
    display: none !important;
  }
}
@media only screen and (min-width: 1264px) and (max-width: 1903px) {
  .hidden-lg-only {
    display: none !important;
  }
}
@media only screen and (max-width: 1903px) {
  .hidden-lg-and-down {
    display: none !important;
  }
}
@media only screen and (min-width: 1264px) {
  .hidden-lg-and-up {
    display: none !important;
  }
}
@media only screen and (min-width: 1904px) {
  .hidden-xl-only {
    display: none !important;
  }
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.right {
  float: right !important;
}
.left {
  float: left !important;
}
.ma-auto {
  margin-top: auto !important;
  margin-right: auto !important;
  margin-bottom: auto !important;
  margin-left: auto !important;
}
.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.mt-auto {
  margin-top: auto !important;
}
.mr-auto {
  margin-right: auto !important;
}
.mb-auto {
  margin-bottom: auto !important;
}
.ml-auto {
  margin-left: auto !important;
}
.ma-0 {
  margin: 0 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.pa-0 {
  padding: 0 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.ma-1 {
  margin: 4px 4px !important;
}
.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.mt-1 {
  margin-top: 4px !important;
}
.mr-1 {
  margin-right: 4px !important;
}
.mb-1 {
  margin-bottom: 4px !important;
}
.ml-1 {
  margin-left: 4px !important;
}
.pa-1 {
  padding: 4px 4px !important;
}
.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.pt-1 {
  padding-top: 4px !important;
}
.pr-1 {
  padding-right: 4px !important;
}
.pb-1 {
  padding-bottom: 4px !important;
}
.pl-1 {
  padding-left: 4px !important;
}
.ma-2 {
  margin: 8px 8px !important;
}
.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.mt-2 {
  margin-top: 8px !important;
}
.mr-2 {
  margin-right: 8px !important;
}
.mb-2 {
  margin-bottom: 8px !important;
}
.ml-2 {
  margin-left: 8px !important;
}
.pa-2 {
  padding: 8px 8px !important;
}
.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.pt-2 {
  padding-top: 8px !important;
}
.pr-2 {
  padding-right: 8px !important;
}
.pb-2 {
  padding-bottom: 8px !important;
}
.pl-2 {
  padding-left: 8px !important;
}
.ma-3 {
  margin: 16px 16px !important;
}
.my-3 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}
.mx-3 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}
.mt-3 {
  margin-top: 16px !important;
}
.mr-3 {
  margin-right: 16px !important;
}
.mb-3 {
  margin-bottom: 16px !important;
}
.ml-3 {
  margin-left: 16px !important;
}
.pa-3 {
  padding: 16px 16px !important;
}
.py-3 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.px-3 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.pt-3 {
  padding-top: 16px !important;
}
.pr-3 {
  padding-right: 16px !important;
}
.pb-3 {
  padding-bottom: 16px !important;
}
.pl-3 {
  padding-left: 16px !important;
}
.ma-4 {
  margin: 24px 24px !important;
}
.my-4 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}
.mx-4 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.mt-4 {
  margin-top: 24px !important;
}
.mr-4 {
  margin-right: 24px !important;
}
.mb-4 {
  margin-bottom: 24px !important;
}
.ml-4 {
  margin-left: 24px !important;
}
.pa-4 {
  padding: 24px 24px !important;
}
.py-4 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.px-4 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.pt-4 {
  padding-top: 24px !important;
}
.pr-4 {
  padding-right: 24px !important;
}
.pb-4 {
  padding-bottom: 24px !important;
}
.pl-4 {
  padding-left: 24px !important;
}
.ma-5 {
  margin: 48px 48px !important;
}
.my-5 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}
.mx-5 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}
.mt-5 {
  margin-top: 48px !important;
}
.mr-5 {
  margin-right: 48px !important;
}
.mb-5 {
  margin-bottom: 48px !important;
}
.ml-5 {
  margin-left: 48px !important;
}
.pa-5 {
  padding: 48px 48px !important;
}
.py-5 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}
.px-5 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}
.pt-5 {
  padding-top: 48px !important;
}
.pr-5 {
  padding-right: 48px !important;
}
.pb-5 {
  padding-bottom: 48px !important;
}
.pl-5 {
  padding-left: 48px !important;
}
@media all and (min-width: 0) {
  .text-xs-left {
    text-align: left !important;
  }
  .text-xs-center {
    text-align: center !important;
  }
  .text-xs-right {
    text-align: right !important;
  }
  .text-xs-justify {
    text-align: justify !important;
  }
}
@media all and (min-width: 600px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-justify {
    text-align: justify !important;
  }
}
@media all and (min-width: 960px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-center {
    text-align: center !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-justify {
    text-align: justify !important;
  }
}
@media all and (min-width: 1264px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-justify {
    text-align: justify !important;
  }
}
@media all and (min-width: 1904px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-justify {
    text-align: justify !important;
  }
}
.font-weight-thin {
  font-weight: 100 !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-regular {
  font-weight: 400 !important;
}
.font-weight-medium {
  font-weight: 500 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-black {
  font-weight: 900 !important;
}
.font-italic {
  font-style: italic !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-none {
  text-transform: none !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-no-wrap {
  white-space: nowrap !important;
}
.text-truncate {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.1 !important;
}
.transition-fast-out-slow-in {
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.transition-linear-out-slow-in {
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1) !important;
}
.transition-fast-out-linear-in {
  transition: 0.3s cubic-bezier(0.4, 0, 1, 1) !important;
}
.transition-ease-in-out {
  transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;
}
.transition-fast-in-fast-out {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}
.transition-swing {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/generic/_animations.styl","webpack://./node_modules/vuetify/src/stylus/app.styl","webpack://./node_modules/vuetify/src/stylus/generic/_colors.styl","webpack://./node_modules/vuetify/src/stylus/generic/_elevations.styl","webpack://./node_modules/vuetify/src/stylus/settings/_elevations.styl","webpack://./node_modules/vuetify/src/stylus/generic/_reset.styl","webpack://./node_modules/vuetify/src/stylus/generic/_transitions.styl","webpack://./node_modules/vuetify/src/stylus/elements/_blockquote.styl","webpack://./node_modules/vuetify/src/stylus/elements/_code.styl","webpack://./node_modules/vuetify/src/stylus/elements/_global.styl","webpack://./node_modules/vuetify/src/stylus/elements/_lists.styl","webpack://./node_modules/vuetify/src/stylus/elements/_typography.styl","webpack://./node_modules/vuetify/src/stylus/trumps/_display.styl","webpack://./node_modules/vuetify/src/stylus/trumps/_helpers.styl","webpack://./node_modules/vuetify/src/stylus/trumps/_spacing.styl","webpack://./node_modules/vuetify/src/stylus/trumps/_text.styl"],"names":[],"mappings":"AAAA;EACE;IACE,cAAa;ECCf;EDCA;IACE,gBAAa;ECCf;EDCA;IACE,iBAAa;ECCf;AACF;ADVA;EACE;IACE,cAAa;ECYf;EDVA;IACE,gBAAa;ECYf;EDVA;IACE,iBAAa;ECYf;AACF;ADrBA;EACE;IACE,cAAa;ECuBf;EDrBA;IACE,gBAAa;ECuBf;EDrBA;IACE,iBAAa;ECuBf;AACF;ADhCA;EACE;IACE,cAAa;ECkCf;EDhCA;IACE,gBAAa;ECkCf;EDhCA;IACE,iBAAa;ECkCf;AACF;AC1CE;EACE,iCAAiB;EACjB,6BAAc;AD4ClB;AC1CE;EACE,sBAAM;EACN,4BAAa;AD4CjB;AClDE;EACE,iCAAiB;EACjB,6BAAc;ADoDlB;AClDE;EACE,sBAAM;EACN,4BAAa;ADoDjB;AC1DE;EACE,wCAAiB;EACjB,oCAAc;AD4DlB;AC1DE;EACE,6BAAM;EACN,mCAAa;AD4DjB;AClEE;EACE,oCAAiB;EACjB,gCAAc;ADoElB;AClEE;EACE,yBAAM;EACN,+BAAa;ADoEjB;AChEI;EACE,oCAAiB;EACjB,gCAAc;ADkEpB;AC/DI;EACE,yBAAO;EACP,+BAAa;ADiEnB;ACxEI;EACE,oCAAiB;EACjB,gCAAc;AD0EpB;ACvEI;EACE,yBAAO;EACP,+BAAa;ADyEnB;AChFI;EACE,oCAAiB;EACjB,gCAAc;ADkFpB;AC/EI;EACE,yBAAO;EACP,+BAAa;ADiFnB;ACxFI;EACE,oCAAiB;EACjB,gCAAc;AD0FpB;ACvFI;EACE,yBAAO;EACP,+BAAa;ADyFnB;AChGI;EACE,oCAAiB;EACjB,gCAAc;ADkGpB;AC/FI;EACE,yBAAO;EACP,+BAAa;ADiGnB;ACxGI;EACE,oCAAiB;EACjB,gCAAc;AD0GpB;ACvGI;EACE,yBAAO;EACP,+BAAa;ADyGnB;AChHI;EACE,oCAAiB;EACjB,gCAAc;ADkHpB;AC/GI;EACE,yBAAO;EACP,+BAAa;ADiHnB;ACxHI;EACE,oCAAiB;EACjB,gCAAc;AD0HpB;ACvHI;EACE,yBAAO;EACP,+BAAa;ADyHnB;AChII;EACE,oCAAiB;EACjB,gCAAc;ADkIpB;AC/HI;EACE,yBAAO;EACP,+BAAa;ADiInB;ACxII;EACE,oCAAiB;EACjB,gCAAc;AD0IpB;ACvII;EACE,yBAAO;EACP,+BAAa;ADyInB;AChJI;EACE,oCAAiB;EACjB,gCAAc;ADkJpB;AC/II;EACE,yBAAO;EACP,+BAAa;ADiJnB;ACxJI;EACE,oCAAiB;EACjB,gCAAc;AD0JpB;ACvJI;EACE,yBAAO;EACP,+BAAa;ADyJnB;AChKI;EACE,oCAAiB;EACjB,gCAAc;ADkKpB;AC/JI;EACE,yBAAO;EACP,+BAAa;ADiKnB;AClLE;EACE,oCAAiB;EACjB,gCAAc;ADoLlB;AClLE;EACE,yBAAM;EACN,+BAAa;ADoLjB;AChLI;EACE,oCAAiB;EACjB,gCAAc;ADkLpB;AC/KI;EACE,yBAAO;EACP,+BAAa;ADiLnB;ACxLI;EACE,oCAAiB;EACjB,gCAAc;AD0LpB;ACvLI;EACE,yBAAO;EACP,+BAAa;ADyLnB;AChMI;EACE,oCAAiB;EACjB,gCAAc;ADkMpB;AC/LI;EACE,yBAAO;EACP,+BAAa;ADiMnB;ACxMI;EACE,oCAAiB;EACjB,gCAAc;AD0MpB;ACvMI;EACE,yBAAO;EACP,+BAAa;ADyMnB;AChNI;EACE,oCAAiB;EACjB,gCAAc;ADkNpB;AC/MI;EACE,yBAAO;EACP,+BAAa;ADiNnB;ACxNI;EACE,oCAAiB;EACjB,gCAAc;AD0NpB;ACvNI;EACE,yBAAO;EACP,+BAAa;ADyNnB;AChOI;EACE,oCAAiB;EACjB,gCAAc;ADkOpB;AC/NI;EACE,yBAAO;EACP,+BAAa;ADiOnB;ACxOI;EACE,oCAAiB;EACjB,gCAAc;AD0OpB;ACvOI;EACE,yBAAO;EACP,+BAAa;ADyOnB;AChPI;EACE,oCAAiB;EACjB,gCAAc;ADkPpB;AC/OI;EACE,yBAAO;EACP,+BAAa;ADiPnB;ACxPI;EACE,oCAAiB;EACjB,gCAAc;AD0PpB;ACvPI;EACE,yBAAO;EACP,+BAAa;ADyPnB;AChQI;EACE,oCAAiB;EACjB,gCAAc;ADkQpB;AC/PI;EACE,yBAAO;EACP,+BAAa;ADiQnB;ACxQI;EACE,oCAAiB;EACjB,gCAAc;AD0QpB;ACvQI;EACE,yBAAO;EACP,+BAAa;ADyQnB;AChRI;EACE,oCAAiB;EACjB,gCAAc;ADkRpB;AC/QI;EACE,yBAAO;EACP,+BAAa;ADiRnB;AClSE;EACE,oCAAiB;EACjB,gCAAc;ADoSlB;AClSE;EACE,yBAAM;EACN,+BAAa;ADoSjB;AChSI;EACE,oCAAiB;EACjB,gCAAc;ADkSpB;AC/RI;EACE,yBAAO;EACP,+BAAa;ADiSnB;ACxSI;EACE,oCAAiB;EACjB,gCAAc;AD0SpB;ACvSI;EACE,yBAAO;EACP,+BAAa;ADySnB;AChTI;EACE,oCAAiB;EACjB,gCAAc;ADkTpB;AC/SI;EACE,yBAAO;EACP,+BAAa;ADiTnB;ACxTI;EACE,oCAAiB;EACjB,gCAAc;AD0TpB;ACvTI;EACE,yBAAO;EACP,+BAAa;ADyTnB;AChUI;EACE,oCAAiB;EACjB,gCAAc;ADkUpB;AC/TI;EACE,yBAAO;EACP,+BAAa;ADiUnB;ACxUI;EACE,oCAAiB;EACjB,gCAAc;AD0UpB;ACvUI;EACE,yBAAO;EACP,+BAAa;ADyUnB;AChVI;EACE,oCAAiB;EACjB,gCAAc;ADkVpB;AC/UI;EACE,yBAAO;EACP,+BAAa;ADiVnB;ACxVI;EACE,oCAAiB;EACjB,gCAAc;AD0VpB;ACvVI;EACE,yBAAO;EACP,+BAAa;ADyVnB;AChWI;EACE,oCAAiB;EACjB,gCAAc;ADkWpB;AC/VI;EACE,yBAAO;EACP,+BAAa;ADiWnB;ACxWI;EACE,oCAAiB;EACjB,gCAAc;AD0WpB;ACvWI;EACE,yBAAO;EACP,+BAAa;ADyWnB;AChXI;EACE,oCAAiB;EACjB,gCAAc;ADkXpB;AC/WI;EACE,yBAAO;EACP,+BAAa;ADiXnB;ACxXI;EACE,oCAAiB;EACjB,gCAAc;AD0XpB;ACvXI;EACE,yBAAO;EACP,+BAAa;ADyXnB;AChYI;EACE,iCAAiB;EACjB,6BAAc;ADkYpB;AC/XI;EACE,sBAAO;EACP,4BAAa;ADiYnB;AClZE;EACE,oCAAiB;EACjB,gCAAc;ADoZlB;AClZE;EACE,yBAAM;EACN,+BAAa;ADoZjB;AChZI;EACE,oCAAiB;EACjB,gCAAc;ADkZpB;AC/YI;EACE,yBAAO;EACP,+BAAa;ADiZnB;ACxZI;EACE,oCAAiB;EACjB,gCAAc;AD0ZpB;ACvZI;EACE,yBAAO;EACP,+BAAa;ADyZnB;AChaI;EACE,oCAAiB;EACjB,gCAAc;ADkapB;AC/ZI;EACE,yBAAO;EACP,+BAAa;ADianB;ACxaI;EACE,oCAAiB;EACjB,gCAAc;AD0apB;ACvaI;EACE,yBAAO;EACP,+BAAa;ADyanB;AChbI;EACE,oCAAiB;EACjB,gCAAc;ADkbpB;AC/aI;EACE,yBAAO;EACP,+BAAa;ADibnB;ACxbI;EACE,oCAAiB;EACjB,gCAAc;AD0bpB;ACvbI;EACE,yBAAO;EACP,+BAAa;ADybnB;AChcI;EACE,oCAAiB;EACjB,gCAAc;ADkcpB;AC/bI;EACE,yBAAO;EACP,+BAAa;ADicnB;ACxcI;EACE,oCAAiB;EACjB,gCAAc;AD0cpB;ACvcI;EACE,yBAAO;EACP,+BAAa;ADycnB;AChdI;EACE,oCAAiB;EACjB,gCAAc;ADkdpB;AC/cI;EACE,yBAAO;EACP,+BAAa;ADidnB;ACxdI;EACE,oCAAiB;EACjB,gCAAc;AD0dpB;ACvdI;EACE,yBAAO;EACP,+BAAa;ADydnB;ACheI;EACE,oCAAiB;EACjB,gCAAc;ADkepB;AC/dI;EACE,yBAAO;EACP,+BAAa;ADienB;ACxeI;EACE,oCAAiB;EACjB,gCAAc;AD0epB;ACveI;EACE,yBAAO;EACP,+BAAa;ADyenB;AChfI;EACE,oCAAiB;EACjB,gCAAc;ADkfpB;AC/eI;EACE,yBAAO;EACP,+BAAa;ADifnB;AClgBE;EACE,oCAAiB;EACjB,gCAAc;ADogBlB;AClgBE;EACE,yBAAM;EACN,+BAAa;ADogBjB;AChgBI;EACE,oCAAiB;EACjB,gCAAc;ADkgBpB;AC/fI;EACE,yBAAO;EACP,+BAAa;ADigBnB;ACxgBI;EACE,oCAAiB;EACjB,gCAAc;AD0gBpB;ACvgBI;EACE,yBAAO;EACP,+BAAa;ADygBnB;AChhBI;EACE,oCAAiB;EACjB,gCAAc;ADkhBpB;AC/gBI;EACE,yBAAO;EACP,+BAAa;ADihBnB;ACxhBI;EACE,oCAAiB;EACjB,gCAAc;AD0hBpB;ACvhBI;EACE,yBAAO;EACP,+BAAa;ADyhBnB;AChiBI;EACE,oCAAiB;EACjB,gCAAc;ADkiBpB;AC/hBI;EACE,yBAAO;EACP,+BAAa;ADiiBnB;ACxiBI;EACE,oCAAiB;EACjB,gCAAc;AD0iBpB;ACviBI;EACE,yBAAO;EACP,+BAAa;ADyiBnB;AChjBI;EACE,oCAAiB;EACjB,gCAAc;ADkjBpB;AC/iBI;EACE,yBAAO;EACP,+BAAa;ADijBnB;ACxjBI;EACE,oCAAiB;EACjB,gCAAc;AD0jBpB;ACvjBI;EACE,yBAAO;EACP,+BAAa;ADyjBnB;AChkBI;EACE,oCAAiB;EACjB,gCAAc;ADkkBpB;AC/jBI;EACE,yBAAO;EACP,+BAAa;ADikBnB;ACxkBI;EACE,oCAAiB;EACjB,gCAAc;AD0kBpB;ACvkBI;EACE,yBAAO;EACP,+BAAa;ADykBnB;AChlBI;EACE,oCAAiB;EACjB,gCAAc;ADklBpB;AC/kBI;EACE,yBAAO;EACP,+BAAa;ADilBnB;ACxlBI;EACE,oCAAiB;EACjB,gCAAc;AD0lBpB;ACvlBI;EACE,yBAAO;EACP,+BAAa;ADylBnB;AChmBI;EACE,oCAAiB;EACjB,gCAAc;ADkmBpB;AC/lBI;EACE,yBAAO;EACP,+BAAa;ADimBnB;AClnBE;EACE,oCAAiB;EACjB,gCAAc;ADonBlB;AClnBE;EACE,yBAAM;EACN,+BAAa;ADonBjB;AChnBI;EACE,oCAAiB;EACjB,gCAAc;ADknBpB;AC/mBI;EACE,yBAAO;EACP,+BAAa;ADinBnB;ACxnBI;EACE,oCAAiB;EACjB,gCAAc;AD0nBpB;ACvnBI;EACE,yBAAO;EACP,+BAAa;ADynBnB;AChoBI;EACE,oCAAiB;EACjB,gCAAc;ADkoBpB;AC/nBI;EACE,yBAAO;EACP,+BAAa;ADioBnB;ACxoBI;EACE,oCAAiB;EACjB,gCAAc;AD0oBpB;ACvoBI;EACE,yBAAO;EACP,+BAAa;ADyoBnB;AChpBI;EACE,oCAAiB;EACjB,gCAAc;ADkpBpB;AC/oBI;EACE,yBAAO;EACP,+BAAa;ADipBnB;ACxpBI;EACE,oCAAiB;EACjB,gCAAc;AD0pBpB;ACvpBI;EACE,yBAAO;EACP,+BAAa;ADypBnB;AChqBI;EACE,oCAAiB;EACjB,gCAAc;ADkqBpB;AC/pBI;EACE,yBAAO;EACP,+BAAa;ADiqBnB;ACxqBI;EACE,oCAAiB;EACjB,gCAAc;AD0qBpB;ACvqBI;EACE,yBAAO;EACP,+BAAa;ADyqBnB;AChrBI;EACE,oCAAiB;EACjB,gCAAc;ADkrBpB;AC/qBI;EACE,yBAAO;EACP,+BAAa;ADirBnB;ACxrBI;EACE,oCAAiB;EACjB,gCAAc;AD0rBpB;ACvrBI;EACE,yBAAO;EACP,+BAAa;ADyrBnB;AChsBI;EACE,oCAAiB;EACjB,gCAAc;ADksBpB;AC/rBI;EACE,yBAAO;EACP,+BAAa;ADisBnB;ACxsBI;EACE,oCAAiB;EACjB,gCAAc;AD0sBpB;ACvsBI;EACE,yBAAO;EACP,+BAAa;ADysBnB;AChtBI;EACE,oCAAiB;EACjB,gCAAc;ADktBpB;AC/sBI;EACE,yBAAO;EACP,+BAAa;ADitBnB;ACluBE;EACE,oCAAiB;EACjB,gCAAc;ADouBlB;ACluBE;EACE,yBAAM;EACN,+BAAa;ADouBjB;AChuBI;EACE,oCAAiB;EACjB,gCAAc;ADkuBpB;AC/tBI;EACE,yBAAO;EACP,+BAAa;ADiuBnB;ACxuBI;EACE,oCAAiB;EACjB,gCAAc;AD0uBpB;ACvuBI;EACE,yBAAO;EACP,+BAAa;ADyuBnB;AChvBI;EACE,oCAAiB;EACjB,gCAAc;ADkvBpB;AC/uBI;EACE,yBAAO;EACP,+BAAa;ADivBnB;ACxvBI;EACE,oCAAiB;EACjB,gCAAc;AD0vBpB;ACvvBI;EACE,yBAAO;EACP,+BAAa;ADyvBnB;AChwBI;EACE,oCAAiB;EACjB,gCAAc;ADkwBpB;AC/vBI;EACE,yBAAO;EACP,+BAAa;ADiwBnB;ACxwBI;EACE,oCAAiB;EACjB,gCAAc;AD0wBpB;ACvwBI;EACE,yBAAO;EACP,+BAAa;ADywBnB;AChxBI;EACE,oCAAiB;EACjB,gCAAc;ADkxBpB;AC/wBI;EACE,yBAAO;EACP,+BAAa;ADixBnB;ACxxBI;EACE,oCAAiB;EACjB,gCAAc;AD0xBpB;ACvxBI;EACE,yBAAO;EACP,+BAAa;ADyxBnB;AChyBI;EACE,oCAAiB;EACjB,gCAAc;ADkyBpB;AC/xBI;EACE,yBAAO;EACP,+BAAa;ADiyBnB;ACxyBI;EACE,oCAAiB;EACjB,gCAAc;AD0yBpB;ACvyBI;EACE,yBAAO;EACP,+BAAa;ADyyBnB;AChzBI;EACE,oCAAiB;EACjB,gCAAc;ADkzBpB;AC/yBI;EACE,yBAAO;EACP,+BAAa;ADizBnB;ACxzBI;EACE,oCAAiB;EACjB,gCAAc;AD0zBpB;ACvzBI;EACE,yBAAO;EACP,+BAAa;ADyzBnB;ACh0BI;EACE,oCAAiB;EACjB,gCAAc;ADk0BpB;AC/zBI;EACE,yBAAO;EACP,+BAAa;ADi0BnB;ACl1BE;EACE,oCAAiB;EACjB,gCAAc;ADo1BlB;ACl1BE;EACE,yBAAM;EACN,+BAAa;ADo1BjB;ACh1BI;EACE,oCAAiB;EACjB,gCAAc;ADk1BpB;AC/0BI;EACE,yBAAO;EACP,+BAAa;ADi1BnB;ACx1BI;EACE,oCAAiB;EACjB,gCAAc;AD01BpB;ACv1BI;EACE,yBAAO;EACP,+BAAa;ADy1BnB;ACh2BI;EACE,oCAAiB;EACjB,gCAAc;ADk2BpB;AC/1BI;EACE,yBAAO;EACP,+BAAa;ADi2BnB;ACx2BI;EACE,oCAAiB;EACjB,gCAAc;AD02BpB;ACv2BI;EACE,yBAAO;EACP,+BAAa;ADy2BnB;ACh3BI;EACE,oCAAiB;EACjB,gCAAc;ADk3BpB;AC/2BI;EACE,yBAAO;EACP,+BAAa;ADi3BnB;ACx3BI;EACE,oCAAiB;EACjB,gCAAc;AD03BpB;ACv3BI;EACE,yBAAO;EACP,+BAAa;ADy3BnB;ACh4BI;EACE,oCAAiB;EACjB,gCAAc;ADk4BpB;AC/3BI;EACE,yBAAO;EACP,+BAAa;ADi4BnB;ACx4BI;EACE,oCAAiB;EACjB,gCAAc;AD04BpB;ACv4BI;EACE,yBAAO;EACP,+BAAa;ADy4BnB;ACh5BI;EACE,oCAAiB;EACjB,gCAAc;ADk5BpB;AC/4BI;EACE,yBAAO;EACP,+BAAa;ADi5BnB;ACx5BI;EACE,oCAAiB;EACjB,gCAAc;AD05BpB;ACv5BI;EACE,yBAAO;EACP,+BAAa;ADy5BnB;ACh6BI;EACE,oCAAiB;EACjB,gCAAc;ADk6BpB;AC/5BI;EACE,yBAAO;EACP,+BAAa;ADi6BnB;ACx6BI;EACE,oCAAiB;EACjB,gCAAc;AD06BpB;ACv6BI;EACE,yBAAO;EACP,+BAAa;ADy6BnB;ACh7BI;EACE,oCAAiB;EACjB,gCAAc;ADk7BpB;AC/6BI;EACE,yBAAO;EACP,+BAAa;ADi7BnB;ACl8BE;EACE,oCAAiB;EACjB,gCAAc;ADo8BlB;ACl8BE;EACE,yBAAM;EACN,+BAAa;ADo8BjB;ACh8BI;EACE,oCAAiB;EACjB,gCAAc;ADk8BpB;AC/7BI;EACE,yBAAO;EACP,+BAAa;ADi8BnB;ACx8BI;EACE,oCAAiB;EACjB,gCAAc;AD08BpB;ACv8BI;EACE,yBAAO;EACP,+BAAa;ADy8BnB;ACh9BI;EACE,oCAAiB;EACjB,gCAAc;ADk9BpB;AC/8BI;EACE,yBAAO;EACP,+BAAa;ADi9BnB;ACx9BI;EACE,oCAAiB;EACjB,gCAAc;AD09BpB;ACv9BI;EACE,yBAAO;EACP,+BAAa;ADy9BnB;ACh+BI;EACE,oCAAiB;EACjB,gCAAc;ADk+BpB;AC/9BI;EACE,yBAAO;EACP,+BAAa;ADi+BnB;ACx+BI;EACE,oCAAiB;EACjB,gCAAc;AD0+BpB;ACv+BI;EACE,yBAAO;EACP,+BAAa;ADy+BnB;ACh/BI;EACE,oCAAiB;EACjB,gCAAc;ADk/BpB;AC/+BI;EACE,yBAAO;EACP,+BAAa;ADi/BnB;ACx/BI;EACE,oCAAiB;EACjB,gCAAc;AD0/BpB;ACv/BI;EACE,yBAAO;EACP,+BAAa;ADy/BnB;AChgCI;EACE,oCAAiB;EACjB,gCAAc;ADkgCpB;AC//BI;EACE,yBAAO;EACP,+BAAa;ADigCnB;ACxgCI;EACE,oCAAiB;EACjB,gCAAc;AD0gCpB;ACvgCI;EACE,yBAAO;EACP,+BAAa;ADygCnB;AChhCI;EACE,oCAAiB;EACjB,gCAAc;ADkhCpB;AC/gCI;EACE,yBAAO;EACP,+BAAa;ADihCnB;ACxhCI;EACE,oCAAiB;EACjB,gCAAc;AD0hCpB;ACvhCI;EACE,yBAAO;EACP,+BAAa;ADyhCnB;AChiCI;EACE,oCAAiB;EACjB,gCAAc;ADkiCpB;AC/hCI;EACE,yBAAO;EACP,+BAAa;ADiiCnB;ACljCE;EACE,oCAAiB;EACjB,gCAAc;ADojClB;ACljCE;EACE,yBAAM;EACN,+BAAa;ADojCjB;AChjCI;EACE,oCAAiB;EACjB,gCAAc;ADkjCpB;AC/iCI;EACE,yBAAO;EACP,+BAAa;ADijCnB;ACxjCI;EACE,oCAAiB;EACjB,gCAAc;AD0jCpB;ACvjCI;EACE,yBAAO;EACP,+BAAa;ADyjCnB;AChkCI;EACE,oCAAiB;EACjB,gCAAc;ADkkCpB;AC/jCI;EACE,yBAAO;EACP,+BAAa;ADikCnB;ACxkCI;EACE,oCAAiB;EACjB,gCAAc;AD0kCpB;ACvkCI;EACE,yBAAO;EACP,+BAAa;ADykCnB;AChlCI;EACE,oCAAiB;EACjB,gCAAc;ADklCpB;AC/kCI;EACE,yBAAO;EACP,+BAAa;ADilCnB;ACxlCI;EACE,oCAAiB;EACjB,gCAAc;AD0lCpB;ACvlCI;EACE,yBAAO;EACP,+BAAa;ADylCnB;AChmCI;EACE,oCAAiB;EACjB,gCAAc;ADkmCpB;AC/lCI;EACE,yBAAO;EACP,+BAAa;ADimCnB;ACxmCI;EACE,oCAAiB;EACjB,gCAAc;AD0mCpB;ACvmCI;EACE,yBAAO;EACP,+BAAa;ADymCnB;AChnCI;EACE,oCAAiB;EACjB,gCAAc;ADknCpB;AC/mCI;EACE,yBAAO;EACP,+BAAa;ADinCnB;ACxnCI;EACE,oCAAiB;EACjB,gCAAc;AD0nCpB;ACvnCI;EACE,yBAAO;EACP,+BAAa;ADynCnB;AChoCI;EACE,oCAAiB;EACjB,gCAAc;ADkoCpB;AC/nCI;EACE,yBAAO;EACP,+BAAa;ADioCnB;ACxoCI;EACE,oCAAiB;EACjB,gCAAc;AD0oCpB;ACvoCI;EACE,yBAAO;EACP,+BAAa;ADyoCnB;AChpCI;EACE,oCAAiB;EACjB,gCAAc;ADkpCpB;AC/oCI;EACE,yBAAO;EACP,+BAAa;ADipCnB;AClqCE;EACE,oCAAiB;EACjB,gCAAc;ADoqClB;AClqCE;EACE,yBAAM;EACN,+BAAa;ADoqCjB;AChqCI;EACE,oCAAiB;EACjB,gCAAc;ADkqCpB;AC/pCI;EACE,yBAAO;EACP,+BAAa;ADiqCnB;ACxqCI;EACE,oCAAiB;EACjB,gCAAc;AD0qCpB;ACvqCI;EACE,yBAAO;EACP,+BAAa;ADyqCnB;AChrCI;EACE,oCAAiB;EACjB,gCAAc;ADkrCpB;AC/qCI;EACE,yBAAO;EACP,+BAAa;ADirCnB;ACxrCI;EACE,oCAAiB;EACjB,gCAAc;AD0rCpB;ACvrCI;EACE,yBAAO;EACP,+BAAa;ADyrCnB;AChsCI;EACE,oCAAiB;EACjB,gCAAc;ADksCpB;AC/rCI;EACE,yBAAO;EACP,+BAAa;ADisCnB;ACxsCI;EACE,oCAAiB;EACjB,gCAAc;AD0sCpB;ACvsCI;EACE,yBAAO;EACP,+BAAa;ADysCnB;AChtCI;EACE,oCAAiB;EACjB,gCAAc;ADktCpB;AC/sCI;EACE,yBAAO;EACP,+BAAa;ADitCnB;ACxtCI;EACE,oCAAiB;EACjB,gCAAc;AD0tCpB;ACvtCI;EACE,yBAAO;EACP,+BAAa;ADytCnB;AChuCI;EACE,oCAAiB;EACjB,gCAAc;ADkuCpB;AC/tCI;EACE,yBAAO;EACP,+BAAa;ADiuCnB;ACxuCI;EACE,oCAAiB;EACjB,gCAAc;AD0uCpB;ACvuCI;EACE,yBAAO;EACP,+BAAa;ADyuCnB;AChvCI;EACE,oCAAiB;EACjB,gCAAc;ADkvCpB;AC/uCI;EACE,yBAAO;EACP,+BAAa;ADivCnB;ACxvCI;EACE,oCAAiB;EACjB,gCAAc;AD0vCpB;ACvvCI;EACE,yBAAO;EACP,+BAAa;ADyvCnB;AChwCI;EACE,oCAAiB;EACjB,gCAAc;ADkwCpB;AC/vCI;EACE,yBAAO;EACP,+BAAa;ADiwCnB;AClxCE;EACE,oCAAiB;EACjB,gCAAc;ADoxClB;AClxCE;EACE,yBAAM;EACN,+BAAa;ADoxCjB;AChxCI;EACE,oCAAiB;EACjB,gCAAc;ADkxCpB;AC/wCI;EACE,yBAAO;EACP,+BAAa;ADixCnB;ACxxCI;EACE,oCAAiB;EACjB,gCAAc;AD0xCpB;ACvxCI;EACE,yBAAO;EACP,+BAAa;ADyxCnB;AChyCI;EACE,oCAAiB;EACjB,gCAAc;ADkyCpB;AC/xCI;EACE,yBAAO;EACP,+BAAa;ADiyCnB;ACxyCI;EACE,oCAAiB;EACjB,gCAAc;AD0yCpB;ACvyCI;EACE,yBAAO;EACP,+BAAa;ADyyCnB;AChzCI;EACE,oCAAiB;EACjB,gCAAc;ADkzCpB;AC/yCI;EACE,yBAAO;EACP,+BAAa;ADizCnB;ACxzCI;EACE,oCAAiB;EACjB,gCAAc;AD0zCpB;ACvzCI;EACE,yBAAO;EACP,+BAAa;ADyzCnB;ACh0CI;EACE,oCAAiB;EACjB,gCAAc;ADk0CpB;AC/zCI;EACE,yBAAO;EACP,+BAAa;ADi0CnB;ACx0CI;EACE,oCAAiB;EACjB,gCAAc;AD00CpB;ACv0CI;EACE,yBAAO;EACP,+BAAa;ADy0CnB;ACh1CI;EACE,oCAAiB;EACjB,gCAAc;ADk1CpB;AC/0CI;EACE,yBAAO;EACP,+BAAa;ADi1CnB;ACx1CI;EACE,oCAAiB;EACjB,gCAAc;AD01CpB;ACv1CI;EACE,yBAAO;EACP,+BAAa;ADy1CnB;ACh2CI;EACE,oCAAiB;EACjB,gCAAc;ADk2CpB;AC/1CI;EACE,yBAAO;EACP,+BAAa;ADi2CnB;ACx2CI;EACE,oCAAiB;EACjB,gCAAc;AD02CpB;ACv2CI;EACE,yBAAO;EACP,+BAAa;ADy2CnB;ACh3CI;EACE,oCAAiB;EACjB,gCAAc;ADk3CpB;AC/2CI;EACE,yBAAO;EACP,+BAAa;ADi3CnB;ACl4CE;EACE,oCAAiB;EACjB,gCAAc;ADo4ClB;ACl4CE;EACE,yBAAM;EACN,+BAAa;ADo4CjB;ACh4CI;EACE,oCAAiB;EACjB,gCAAc;ADk4CpB;AC/3CI;EACE,yBAAO;EACP,+BAAa;ADi4CnB;ACx4CI;EACE,oCAAiB;EACjB,gCAAc;AD04CpB;ACv4CI;EACE,yBAAO;EACP,+BAAa;ADy4CnB;ACh5CI;EACE,oCAAiB;EACjB,gCAAc;ADk5CpB;AC/4CI;EACE,yBAAO;EACP,+BAAa;ADi5CnB;ACx5CI;EACE,oCAAiB;EACjB,gCAAc;AD05CpB;ACv5CI;EACE,yBAAO;EACP,+BAAa;ADy5CnB;ACh6CI;EACE,oCAAiB;EACjB,gCAAc;ADk6CpB;AC/5CI;EACE,yBAAO;EACP,+BAAa;ADi6CnB;ACx6CI;EACE,oCAAiB;EACjB,gCAAc;AD06CpB;ACv6CI;EACE,yBAAO;EACP,+BAAa;ADy6CnB;ACh7CI;EACE,oCAAiB;EACjB,gCAAc;ADk7CpB;AC/6CI;EACE,yBAAO;EACP,+BAAa;ADi7CnB;ACx7CI;EACE,oCAAiB;EACjB,gCAAc;AD07CpB;ACv7CI;EACE,yBAAO;EACP,+BAAa;ADy7CnB;ACh8CI;EACE,oCAAiB;EACjB,gCAAc;ADk8CpB;AC/7CI;EACE,yBAAO;EACP,+BAAa;ADi8CnB;ACx8CI;EACE,oCAAiB;EACjB,gCAAc;AD08CpB;ACv8CI;EACE,yBAAO;EACP,+BAAa;ADy8CnB;ACh9CI;EACE,iCAAiB;EACjB,6BAAc;ADk9CpB;AC/8CI;EACE,sBAAO;EACP,4BAAa;ADi9CnB;ACx9CI;EACE,oCAAiB;EACjB,gCAAc;AD09CpB;ACv9CI;EACE,yBAAO;EACP,+BAAa;ADy9CnB;ACh+CI;EACE,oCAAiB;EACjB,gCAAc;ADk+CpB;AC/9CI;EACE,yBAAO;EACP,+BAAa;ADi+CnB;ACl/CE;EACE,oCAAiB;EACjB,gCAAc;ADo/ClB;ACl/CE;EACE,yBAAM;EACN,+BAAa;ADo/CjB;ACh/CI;EACE,oCAAiB;EACjB,gCAAc;ADk/CpB;AC/+CI;EACE,yBAAO;EACP,+BAAa;ADi/CnB;ACx/CI;EACE,oCAAiB;EACjB,gCAAc;AD0/CpB;ACv/CI;EACE,yBAAO;EACP,+BAAa;ADy/CnB;AChgDI;EACE,oCAAiB;EACjB,gCAAc;ADkgDpB;AC//CI;EACE,yBAAO;EACP,+BAAa;ADigDnB;ACxgDI;EACE,oCAAiB;EACjB,gCAAc;AD0gDpB;ACvgDI;EACE,yBAAO;EACP,+BAAa;ADygDnB;AChhDI;EACE,oCAAiB;EACjB,gCAAc;ADkhDpB;AC/gDI;EACE,yBAAO;EACP,+BAAa;ADihDnB;ACxhDI;EACE,oCAAiB;EACjB,gCAAc;AD0hDpB;ACvhDI;EACE,yBAAO;EACP,+BAAa;ADyhDnB;AChiDI;EACE,oCAAiB;EACjB,gCAAc;ADkiDpB;AC/hDI;EACE,yBAAO;EACP,+BAAa;ADiiDnB;ACxiDI;EACE,oCAAiB;EACjB,gCAAc;AD0iDpB;ACviDI;EACE,yBAAO;EACP,+BAAa;ADyiDnB;AChjDI;EACE,oCAAiB;EACjB,gCAAc;ADkjDpB;AC/iDI;EACE,yBAAO;EACP,+BAAa;ADijDnB;ACxjDI;EACE,oCAAiB;EACjB,gCAAc;AD0jDpB;ACvjDI;EACE,yBAAO;EACP,+BAAa;ADyjDnB;AChkDI;EACE,oCAAiB;EACjB,gCAAc;ADkkDpB;AC/jDI;EACE,yBAAO;EACP,+BAAa;ADikDnB;ACxkDI;EACE,oCAAiB;EACjB,gCAAc;AD0kDpB;ACvkDI;EACE,yBAAO;EACP,+BAAa;ADykDnB;AChlDI;EACE,oCAAiB;EACjB,gCAAc;ADklDpB;AC/kDI;EACE,yBAAO;EACP,+BAAa;ADilDnB;AClmDE;EACE,oCAAiB;EACjB,gCAAc;ADomDlB;AClmDE;EACE,yBAAM;EACN,+BAAa;ADomDjB;AChmDI;EACE,oCAAiB;EACjB,gCAAc;ADkmDpB;AC/lDI;EACE,yBAAO;EACP,+BAAa;ADimDnB;ACxmDI;EACE,oCAAiB;EACjB,gCAAc;AD0mDpB;ACvmDI;EACE,yBAAO;EACP,+BAAa;ADymDnB;AChnDI;EACE,oCAAiB;EACjB,gCAAc;ADknDpB;AC/mDI;EACE,yBAAO;EACP,+BAAa;ADinDnB;ACxnDI;EACE,oCAAiB;EACjB,gCAAc;AD0nDpB;ACvnDI;EACE,yBAAO;EACP,+BAAa;ADynDnB;AChoDI;EACE,oCAAiB;EACjB,gCAAc;ADkoDpB;AC/nDI;EACE,yBAAO;EACP,+BAAa;ADioDnB;ACxoDI;EACE,oCAAiB;EACjB,gCAAc;AD0oDpB;ACvoDI;EACE,yBAAO;EACP,+BAAa;ADyoDnB;AChpDI;EACE,oCAAiB;EACjB,gCAAc;ADkpDpB;AC/oDI;EACE,yBAAO;EACP,+BAAa;ADipDnB;ACxpDI;EACE,oCAAiB;EACjB,gCAAc;AD0pDpB;ACvpDI;EACE,yBAAO;EACP,+BAAa;ADypDnB;AChqDI;EACE,oCAAiB;EACjB,gCAAc;ADkqDpB;AC/pDI;EACE,yBAAO;EACP,+BAAa;ADiqDnB;ACxqDI;EACE,oCAAiB;EACjB,gCAAc;AD0qDpB;ACvqDI;EACE,yBAAO;EACP,+BAAa;ADyqDnB;AChrDI;EACE,oCAAiB;EACjB,gCAAc;ADkrDpB;AC/qDI;EACE,yBAAO;EACP,+BAAa;ADirDnB;ACxrDI;EACE,oCAAiB;EACjB,gCAAc;AD0rDpB;ACvrDI;EACE,yBAAO;EACP,+BAAa;ADyrDnB;AChsDI;EACE,oCAAiB;EACjB,gCAAc;ADksDpB;AC/rDI;EACE,yBAAO;EACP,+BAAa;ADisDnB;ACltDE;EACE,oCAAiB;EACjB,gCAAc;ADotDlB;ACltDE;EACE,yBAAM;EACN,+BAAa;ADotDjB;AChtDI;EACE,oCAAiB;EACjB,gCAAc;ADktDpB;AC/sDI;EACE,yBAAO;EACP,+BAAa;ADitDnB;ACxtDI;EACE,oCAAiB;EACjB,gCAAc;AD0tDpB;ACvtDI;EACE,yBAAO;EACP,+BAAa;ADytDnB;AChuDI;EACE,oCAAiB;EACjB,gCAAc;ADkuDpB;AC/tDI;EACE,yBAAO;EACP,+BAAa;ADiuDnB;ACxuDI;EACE,oCAAiB;EACjB,gCAAc;AD0uDpB;ACvuDI;EACE,yBAAO;EACP,+BAAa;ADyuDnB;AChvDI;EACE,oCAAiB;EACjB,gCAAc;ADkvDpB;AC/uDI;EACE,yBAAO;EACP,+BAAa;ADivDnB;ACxvDI;EACE,oCAAiB;EACjB,gCAAc;AD0vDpB;ACvvDI;EACE,yBAAO;EACP,+BAAa;ADyvDnB;AChwDI;EACE,oCAAiB;EACjB,gCAAc;ADkwDpB;AC/vDI;EACE,yBAAO;EACP,+BAAa;ADiwDnB;ACxwDI;EACE,oCAAiB;EACjB,gCAAc;AD0wDpB;ACvwDI;EACE,yBAAO;EACP,+BAAa;ADywDnB;AChxDI;EACE,oCAAiB;EACjB,gCAAc;ADkxDpB;AC/wDI;EACE,yBAAO;EACP,+BAAa;ADixDnB;ACxxDI;EACE,oCAAiB;EACjB,gCAAc;AD0xDpB;ACvxDI;EACE,yBAAO;EACP,+BAAa;ADyxDnB;AChyDI;EACE,oCAAiB;EACjB,gCAAc;ADkyDpB;AC/xDI;EACE,yBAAO;EACP,+BAAa;ADiyDnB;ACxyDI;EACE,oCAAiB;EACjB,gCAAc;AD0yDpB;ACvyDI;EACE,yBAAO;EACP,+BAAa;ADyyDnB;AChzDI;EACE,oCAAiB;EACjB,gCAAc;ADkzDpB;AC/yDI;EACE,yBAAO;EACP,+BAAa;ADizDnB;ACl0DE;EACE,oCAAiB;EACjB,gCAAc;ADo0DlB;ACl0DE;EACE,yBAAM;EACN,+BAAa;ADo0DjB;ACh0DI;EACE,oCAAiB;EACjB,gCAAc;ADk0DpB;AC/zDI;EACE,yBAAO;EACP,+BAAa;ADi0DnB;ACx0DI;EACE,oCAAiB;EACjB,gCAAc;AD00DpB;ACv0DI;EACE,yBAAO;EACP,+BAAa;ADy0DnB;ACh1DI;EACE,oCAAiB;EACjB,gCAAc;ADk1DpB;AC/0DI;EACE,yBAAO;EACP,+BAAa;ADi1DnB;ACx1DI;EACE,oCAAiB;EACjB,gCAAc;AD01DpB;ACv1DI;EACE,yBAAO;EACP,+BAAa;ADy1DnB;ACh2DI;EACE,oCAAiB;EACjB,gCAAc;ADk2DpB;AC/1DI;EACE,yBAAO;EACP,+BAAa;ADi2DnB;ACx2DI;EACE,oCAAiB;EACjB,gCAAc;AD02DpB;ACv2DI;EACE,yBAAO;EACP,+BAAa;ADy2DnB;ACh3DI;EACE,oCAAiB;EACjB,gCAAc;ADk3DpB;AC/2DI;EACE,yBAAO;EACP,+BAAa;ADi3DnB;ACx3DI;EACE,oCAAiB;EACjB,gCAAc;AD03DpB;ACv3DI;EACE,yBAAO;EACP,+BAAa;ADy3DnB;ACh4DI;EACE,oCAAiB;EACjB,gCAAc;ADk4DpB;AC/3DI;EACE,yBAAO;EACP,+BAAa;ADi4DnB;ACl5DE;EACE,oCAAiB;EACjB,gCAAc;ADo5DlB;ACl5DE;EACE,yBAAM;EACN,+BAAa;ADo5DjB;ACh5DI;EACE,oCAAiB;EACjB,gCAAc;ADk5DpB;AC/4DI;EACE,yBAAO;EACP,+BAAa;ADi5DnB;ACx5DI;EACE,oCAAiB;EACjB,gCAAc;AD05DpB;ACv5DI;EACE,yBAAO;EACP,+BAAa;ADy5DnB;ACh6DI;EACE,oCAAiB;EACjB,gCAAc;ADk6DpB;AC/5DI;EACE,yBAAO;EACP,+BAAa;ADi6DnB;ACx6DI;EACE,oCAAiB;EACjB,gCAAc;AD06DpB;ACv6DI;EACE,yBAAO;EACP,+BAAa;ADy6DnB;ACh7DI;EACE,oCAAiB;EACjB,gCAAc;ADk7DpB;AC/6DI;EACE,yBAAO;EACP,+BAAa;ADi7DnB;ACx7DI;EACE,oCAAiB;EACjB,gCAAc;AD07DpB;ACv7DI;EACE,yBAAO;EACP,+BAAa;ADy7DnB;ACh8DI;EACE,oCAAiB;EACjB,gCAAc;ADk8DpB;AC/7DI;EACE,yBAAO;EACP,+BAAa;ADi8DnB;ACx8DI;EACE,oCAAiB;EACjB,gCAAc;AD08DpB;ACv8DI;EACE,yBAAO;EACP,+BAAa;ADy8DnB;ACh9DI;EACE,oCAAiB;EACjB,gCAAc;ADk9DpB;AC/8DI;EACE,yBAAO;EACP,+BAAa;ADi9DnB;ACl+DE;EACE,oCAAiB;EACjB,gCAAc;ADo+DlB;ACl+DE;EACE,yBAAM;EACN,+BAAa;ADo+DjB;ACh+DI;EACE,oCAAiB;EACjB,gCAAc;ADk+DpB;AC/9DI;EACE,yBAAO;EACP,+BAAa;ADi+DnB;ACx+DI;EACE,oCAAiB;EACjB,gCAAc;AD0+DpB;ACv+DI;EACE,yBAAO;EACP,+BAAa;ADy+DnB;ACh/DI;EACE,iCAAiB;EACjB,6BAAc;ADk/DpB;AC/+DI;EACE,sBAAO;EACP,4BAAa;ADi/DnB;ACx/DI;EACE,oCAAiB;EACjB,gCAAc;AD0/DpB;ACv/DI;EACE,yBAAO;EACP,+BAAa;ADy/DnB;AChgEI;EACE,oCAAiB;EACjB,gCAAc;ADkgEpB;AC//DI;EACE,yBAAO;EACP,+BAAa;ADigEnB;ACxgEI;EACE,oCAAiB;EACjB,gCAAc;AD0gEpB;ACvgEI;EACE,yBAAO;EACP,+BAAa;ADygEnB;AChhEI;EACE,oCAAiB;EACjB,gCAAc;ADkhEpB;AC/gEI;EACE,yBAAO;EACP,+BAAa;ADihEnB;ACxhEI;EACE,oCAAiB;EACjB,gCAAc;AD0hEpB;ACvhEI;EACE,yBAAO;EACP,+BAAa;ADyhEnB;AChiEI;EACE,oCAAiB;EACjB,gCAAc;ADkiEpB;AC/hEI;EACE,yBAAO;EACP,+BAAa;ADiiEnB;ACxiEI;EACE,iCAAiB;EACjB,6BAAc;AD0iEpB;ACviEI;EACE,sBAAO;EACP,4BAAa;ADyiEnB;AChjEI;EACE,iCAAiB;EACjB,6BAAc;ADkjEpB;AC/iEI;EACE,sBAAO;EACP,4BAAa;ADijEnB;ACxjEI;EACE,wCAAiB;EACjB,oCAAc;AD0jEpB;ACvjEI;EACE,6BAAO;EACP,mCAAa;ADyjEnB;AEvkEE;ECgFA,0HAAiC;AH0/DnC;AE1kEE;ECgFA,2HAAiC;AH6/DnC;AE7kEE;ECgFA,2HAAiC;AHggEnC;AEhlEE;ECgFA,2HAAiC;AHmgEnC;AEnlEE;ECgFA,4HAAiC;AHsgEnC;AEtlEE;ECgFA,4HAAiC;AHygEnC;AEzlEE;ECgFA,6HAAiC;AH4gEnC;AE5lEE;ECgFA,6HAAiC;AH+gEnC;AE/lEE;ECgFA,6HAAiC;AHkhEnC;AElmEE;ECgFA,6HAAiC;AHqhEnC;AErmEE;ECgFA,8HAAiC;AHwhEnC;AExmEE;ECgFA,8HAAiC;AH2hEnC;AE3mEE;ECgFA,8HAAiC;AH8hEnC;AE9mEE;ECgFA,8HAAiC;AHiiEnC;AEjnEE;ECgFA,8HAAiC;AHoiEnC;AEpnEE;ECgFA,8HAAiC;AHuiEnC;AEvnEE;ECgFA,+HAAiC;AH0iEnC;AE1nEE;ECgFA,+HAAiC;AH6iEnC;AE7nEE;ECgFA,+HAAiC;AHgjEnC;AEhoEE;ECgFA,+HAAiC;AHmjEnC;AEnoEE;ECgFA,gIAAiC;AHsjEnC;AEtoEE;ECgFA,gIAAiC;AHyjEnC;AEzoEE;ECgFA,gIAAiC;AH4jEnC;AE5oEE;ECgFA,gIAAiC;AH+jEnC;AE/oEE;ECgFA,gIAAiC;AHkkEnC;AIhpEA;EACE,sBAAY;EACZ,kBAAY,EAAZ,+CAAA;EAAoB,8BAAA,EAAA,WAAA;AJmpEtB;AIlpEkC;;;EAIlC,mBAAA;AACA;AJmpEA;;EI/oEA,wBAAA,EAAA,uFAAA;EACA,uBAAA;AJkpEA;AIjpE4B;EAC1B,4BAAA,EAAA,uDAAA;EJmpEA,UAAU,EAAE,iDAAiD;EI/oE/D,SAAA;AJipEA;AIhpEgC;EAC9B,aAAA;EAAY,SAAA;AJmpEd;AACA;EI3oEA,iBAAA,EAAA,qCAAA;AJ6oEA;AACA;;;;;;;;;;;;EIznEA,cAAA;AACA;AACA;EACA,kBAAA,EAAA,4CAAA;AACA;AACA;EACE,cAAS,EAAT,6CAAA;AJsoEF;AInoEA;;EACsB,aAAA,EAAA,kCAAA;AJsoEtB;AInoEA;EACE,yBAAA,EAAA,oDAAA;EAAgB,qBAAA,EAAA,0CAAA;AJsoElB;AInoEA;EACA,6BAAA,EAAA,wDAAA;EACE,qCAAA,EAAA,2DAAA;AAAe;AJsoEjB;;EIloEE,gBAAe,EAAA,qDAAf;AAA2B;AJsoE7B;;;;EIjoEE,iCAAA,EAAA,6CAAA;AAA+B;AJuoEjC;;EAEE,mBAAmB,EAAE,yEAAyE;AIroEhG;AACA;EACE,kBAAA,EAAA,qDAAA;AAAkB;AJwoEpB;EIroEA,sBAAA;EACA,WAAA;AACA;AACA;;EACqC,cAAA;EJwoEnC,cAAc;EIroEhB,kBAAA;EACA,wBAAA;AJuoEA;AItoEuB;EJwoErB,eAAe;AIroEjB;AJuoEA;EItoEsB,WAAA;AJwoEtB;AIpoEA;EACE,gBAAA;AJsoEF;AACA;;;;;EI9nEE,eAAU;AJooEZ;AACA;EIjoEA,eAAA;AJmoEA;AACA;EIhoEA,WAAA,EAAA,gBAAA;AJkoEA;AACA;EI3nEA,6BAAA,EAAA,cAAA;AJ6nEA;AACA;;EIxnEA,wBAAA,EAAA,aAAA;AACA;AACA;EACA,cAAA,EAAA,0BAAA;EACE,gBAAA,EAAA,kCAAA;AJ2nEF;AIvnEA;;;;;EAKe,aAAA,EAAA,8CAAA;AJynEf;AItnEA;EACE,iBAAA,EAAA,wDAAA;AAA+B;AJynEjC;EItnEA,iBAAA,EAAA,uDAAA;AACA;AJwnEA;;;;EInnEE,eAAA;EAAgB,UAAA;AJynElB;AIxnEoB;;;;EAKpB,UAAA;EACA,SAAA;AACA;AJynEA;;;;EIpnEE,0BAAA,EAAA,0DAAA;AAAmB;AJ0nErB;;EItnEE,oBAAA,EAAA,uCAAA;AAAmB;AJ0nErB;;;;EInnEA,6BAAA;EACE,kBAAA;EACA,cAAA;AJwnEF;AIpnEA;EACA,qBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,eAAA;AACA;AJsnEA;EIpnEE,aAAA,EAAA,0BAAA;AJsnEF;AInnEA;EACA,mBAAA,EAAA,0BAAA;AACA;AACA;EACE,SAAA,EAAA,wDAAA;EAA4B,cAAA,EAAA,iEAAA;EJsnE5B,cAAc,EAAE,6CAA6C;EInnE/D,eAAA,EAAA,6CAAA;EACA,mBAAA,EAAA,6CAAA;AJqnEA;AIpnEwB;EJsnEtB,0BAA0B,EAAE,qEAAqE;EIlnEnG,aAAA,EAAA,6DAAA;AACA;AACA;EACA,6BAAA,EAAA,oDAAA;EACE,oBAAkB,EAAA,wCAAlB;AJonEF;AACA;EACE,kBAAkB,EAAE,uDAAuD;AIhnE7E;AJknEA;EIjnEyB,wBAAA;AJmnEzB;AIlnE4B;EJonE1B,gBAAgB,EAAE,0BAA0B;AIjnE9C;AJmnEA;;;;EI9mEE,qBAAA,EAAA,8CAAA;AAAqB;AJonEvB;EIjnEA;IACE,gBAAA;EAAW;EACX;IAAgB,6BAAA;IAChB,8BAAA;EAAgB;AJsnElB;AIrnEmB;EACjB,gBAAa;AAAQ;AJwnEvB;EIrnEA,eAAA;AJunEA;AItnE8B;EAC5B,eAAA;AAAe;AJynEjB;EItnEA,yBAAA,EAAA,wCAAA;EACE,WAAA;EAA+B,iBAAA;AJynEjC;AIxnEwB;EJ0nEtB,yBAAyB,EAAE,wCAAwC;EInnErE,WAAA;EACE,iBAAc;AAAM;AJsnEtB;EIlnEA,2BAAA;AJonEA;AACA;EIjnEA,2BAAA;AJmnEA;AIlnEoB;EJonElB,6BAA6B;AIjnE/B;AACA;;EAEA,kBAAA;EACE,MAAA;EAAuB,8BAAA;AJonEzB;AI5mEa;EACX,8BAAA;AJ8mEF;AACA;;EAEE,kBI7mEY;EJ8mEZ,MI7mEE;EJ8mEF,6BAA6B;AAC/B;AI1mEA;;EJ6mEE,qBAAqB;EIxmEvB,UAAA;AJ0mEA;AACA;;EIrmEE,UAAQ;AJwmEV;AI/lEA;;EAC6B,2BAAA;AJkmE7B;AACA;;;;EI7lE6B,2CAAA;AJkmE7B;AACA;;;;EAIE,UAAU;AKl6EV;ALo6EF;;;;;;EK75EW,6BAAA;ALo6EX;AACA;EKl6EI,6BAAW;ALo6Ef;AKj6EE;EACE,8BAAW;ALm6Ef;AKj6EE;EAAS,8BAAA;ALo6EX;AACA;EKl6EI,6BAAW;ALo6Ef;AKj6EE;;EACE,0BAAA;ALo6EJ;AACA;EKl6EE,8BAAA;AAAY;ALq6Ed;EACE,UAAU;EKl6EV,6BAAA;AAAS;ALq6EX;;;EK/5EA,6BAAA;ALm6EA;AACA;EKn6EI,6BAAY;ALq6EhB;AKn6EE;;ELs6EA,kBAAkB;EAClB,MAAM;AACR;AACA;EKr6EE,kBAAA;EACF,8BAAA;AACA;ALu6EA;EACE,8BAA8B;AAChC;AACA;;EKt6EE,MAAA;EACE,kBAAW;ELy6Eb,6BAA6B;AKv6E7B;ALy6EF;;EKr6EE,gDAAA;ALw6EF;AACA;EKt6EE,0BAAA;ALw6EF;AACA;;EKp6EA,gDAAA;ALu6EA;AACA;EKr6EE,0BAAA;ALu6EF;AACA;;EKp6EI,gDAAA;ALu6EJ;AACA;EKr6EE,0BAAA;AACF;AACA;;;EAIE,UAAA;EACE,mBAAW;ALs6Ef;AKp6EE;;EACE,gDAAA;ALu6EJ;AACA;EKr6EE,0BAAA;ALu6EF;AACA;;EKn6EE,UAAA;EACE,4BAAW;ALs6Ef;AKp6EE;;EACE,kBAAA;ALu6EJ;AACA;;EKphFE,gDAAA;AACF;ALuhFA;EACE,0BAA0B;AKrhF1B;ALuhFF;;EK3hFE,UAAA;EACF,4BAAA;AL8hFA;AACA;;EK3hFI,gDAAA;AL8hFJ;AKniFE;EACF,0BAAA;ALqiFA;AACA;;EKliFI,UAAA;ELqiFF,2BAA2B;AKh7E3B;AAAS;;EACP,gDAAA;ALo7EJ;AACA;EKhjFE,0BAAA;AACF;ALkjFA;;EK/iFE,UAAA;ALkjFF;AACA;EKt7EE,4BAAA;AAAS;ALy7EX;EKv7EI,2BAAW;ALy7Ef;AKv7EE;;EACE,gDAAA;AL07EJ;AKhkFE;EACF,0BAAA;ALkkFA;AACA;;EK/jFI,UAAA;ALkkFJ;AK57EE;EAAS,2BAAA;AL+7EX;AACA;EACE,4BAA4B;AK5kF5B;AACF;;EL+kFE,gDAAgD;AK5kFhD;AL8kFF;EACE,0BAA0B;AKj8E1B;AAAS;;EAEP,UAAA;ALo8EJ;AKxlFE;EACF,4BAAA;AL0lFA;AACA;EKxlFE,2BAAA;AL0lFF;AACA;;EKt8EW,gDAAA;ALy8EX;AACA;EKv8EE,0BAAA;ALy8EF;AACA;;EKt8EI,UAAA;ALy8EJ;AKzmFE;EACF,2BAAA;AL2mFA;AACA;EKzmFE,4BAAA;AL2mFF;AACA;;EK38EW,gDAAA;AL88EX;AACA;EK58EE,0BAAA;AL88EF;AACA;;EK38EI,UAAA;EL88EF,4BAA4B;AK1nF5B;AACF;;EL6nFE,gDAAgD;AK1nFhD;AL4nFF;EACE,0BAA0B;AKh9E1B;AAAS;;ELo9ET,UAAU;EKj9EV,2BAAA;ALm9EF;AACA;;EKh9EI,gDAAA;ALm9EJ;AK3oFE;EACF,0BAAA;AL6oFA;AACA;;EK1oFI,UAAA;AL6oFJ;AKr9EE;;EACE,gDAAA;ALw9EJ;AKt9EE;EACE,0BAAW;ALw9Ef;AKt9EE;;ELy9EA,kCAAkC;AK5pFlC;AACF;EACI,yBAAY;EL8pFd,eAAe;EK5pFf,gBAAA;AL8pFF;AACA;;EK19EW,qBAAA;EACP,kBAAA;EACA,qBAAW;EL69Eb,cAAc;EKxqFd,gBAAA;AACF;AL0qFA;;;;EAIE,gBAAgB;EK/9EhB,oBAAA;AAAS;ALk+EX;EKh+EI,yBAAW;ELk+Eb,cAAc;EKprFd,gHAAA;AACF;ALsrFA;EACE,mBAAmB;EKprFnB,WAAA;ALsrFF;AACA;EKp+EE,eAAA;EAAS,kBAAA;EACP,kCAAA;ELu+EF,mCAAmC;EK/rFnC,kCAAA;EACF,0CAAA;ALisFA;AACA;EK/rFE,iCAAA;EACE,gBAAY;ALisFhB;AKz+EE;;EACE,aAAW;AL4+Ef;AM3sFA;;EAEE,kBAAA;AN6sFF;AACA;EOhtFA,2BAAA;EAAM,gBAAA;EACJ,yBAAA;EACA,kCAAA;EACA,4CAAA;APmtFF;AACA;EACE,0BAA0B;EOjtF1B,gBAAA;EACF,4BAAA;EPmtFE,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,0BAA0B;EOntF5B,gBAAA;EACE,4BAAA;EACA,iCAAA;EJsEA,4CAAiC;AHgpFnC;AOntFA;EACE,0BAAA;EACA,gBAAA;EPqtFA,4BAA4B;EQxuF9B,iCAAA;EACE,4CAAA;AR0uFF;AACA;EQxuFE,0BAAwB;EACxB,gBAAA;EACA,4BAAA;ER0uFA,iCAAiC;EQxuFnC,4CAAA;AR0uFA;AACA;EACE,0BAA0B;EQxuF5B,gBAAA;EACA,yBAAA;EACE,iCAAA;ER0uFA,4CAA4C;ASxvF9C;AAAI;EACF,0BAAA;ET2vFA,gBAAgB;AU5vFlB;AV8vFA;EU5vFE,0BAAA;EACA,gBAA0B;AV8vF5B;AACA;EACE,0BAA0B;EU5vF5B,gBAAA;AV8vFA;AACA;EU5vFE,0BAA0B;EAC1B,gBAA6B;AV8vF/B;AACA;EU5vFA,mBAAA;AV8vFA;AACA;EU5vFE;IACA,wBAA6B;EAC7B;AV8vFF;AU5vFA;EACE;IACA,wBAAA;EACA;AV8vFF;AACA;EACE;IU5vFF,wBAAA;EACE;AV8vFF;AACA;EU5vFE;IACA,wBAA0B;EV8vF1B;AU5vFF;AV8vFA;EU5vFE;IACA,wBAAA;EACA;AV8vFF;AACA;EU5vFA;IACE,wBAAgC;EAChC;AV8vFF;AU5vFA;EACE;IACA,wBAAA;EV8vFA;AU5vFF;AV8vFA;EU5vFE;IV8vFE,wBAAwB;EU5vF5B;AV8vFA;AACA;EACE;IU5vFF,wBAAA;EACE;AV8vFF;AWtzFa;EAAA;IACL,wBAAS;EXyzFf;AACF;AW3zFa;EAAA;IACL,wBAAS;EX8zFf;AACF;AWh0Fa;EAAA;IACL,wBAAS;EXm0Ff;AACF;AWr0Fa;EAAA;IACL,wBAAS;EXw0Ff;AACF;AW10Fa;EAAA,gBAAA;AX60Fb;AACA;EACE,kBAAkB;AW/0FP;AAAA;EXk1FX,kBWj1Fe;AXk1FjB;AACA;EWp1Fa,uBAAA;AAAA;AXu1Fb;EACE,sBAAsB;AACxB;AWz1Fa;EAAA,2BAAA;EX41FX,6BW31FM;EX41FN,8BAA8B;EAC9B,4BAA4B;AW91FjB;AAAA;EXi2FX,2BWh2FM;EXi2FN,8BAA8B;AAChC;AWn2Fa;EAAA,4BAAA;EXs2FX,6BWr2FM;AXs2FR;AACA;EWx2Fa,2BAAA;AAAA;AX22Fb;EACE,6BAA6B;AAC/B;AW72Fa;EAAA,8BAAA;AXg3Fb;AACA;EACE,4BAA4B;AWl3FjB;AAAA;EXq3FX,sBWp3Fe;AXq3FjB;AACA;EWp3FA,wBAAA;EACE,2BAAA;AXs3FF;AWp3FA;EACE,yBAAA;EXs3FA,0BAA0B;AWp3F5B;AXs3FA;EACE,wBAAwB;AYn4F1B;AZq4FA;EACE,0BAA0B;AYn4F5B;AZq4FA;EACE,2BAA2B;Aaz4F7B;Ab24FA;Eaz4FE,yBAAc;Ab24FhB;AACA;EACE,uBAAuB;Aaz4FzB;Ab24FA;Eaz4FE,yBAAe;Eb24Ff,4BAA4B;Aaz4F9B;Ab24FA;Eaz4FE,0BAAc;Eb24Fd,2BAA2B;Aaz4F7B;Ab24FA;EACE,yBAAyB;Aaz4F3B;Ab24FA;EACE,2BAA2B;Aaz4F7B;Ab24FA;EACE,4BAA4B;Aaz4F9B;Ab24FA;EACE,0BAA0B;Aav4F1B;Aby4FF;EACE,0BAA0B;Aax4F1B;Ab04FF;Eax4FI,0BAAuB;Eb04FzB,6BAA6B;Aaz4F7B;Ab24FF;Eaz4FI,2BAAA;Eb24FF,4BAA4B;Aa14F5B;Ab44FF;EACE,0BAA0B;Aa34F1B;Ab64FF;EACE,4BAA4B;Aa54F5B;Ab84FF;EACE,6BAA6B;Aa74F7B;Ab+4FF;EACE,2BAA2B;Aa74F3B;Ab+4FF;EACE,2BAA2B;Aa94F3B;Abg5FF;Ea94FI,2BAAwB;Ebg5F1B,8BAA8B;Aa/4F9B;Abi5FF;Ea/4FI,4BAAA;Ebi5FF,6BAA6B;Aah5F7B;Abk5FF;EACE,2BAA2B;Aaj5F3B;Abm5FF;EACE,6BAA6B;Aal5F7B;Abo5FF;EACE,8BAA8B;Aan5F9B;Abq5FF;EACE,4BAA4B;Aar7F5B;Abu7FF;EACE,0BAA0B;Aat7F1B;Abw7FF;Eat7FI,0BAAuB;Ebw7FzB,6BAA6B;Aav7F7B;Aby7FF;Eav7FI,2BAAsB;Eby7FxB,4BAA4B;Aax7F5B;Ab07FF;EACE,0BAA0B;Aaz7F1B;Ab27FF;EACE,4BAA4B;Aa17F5B;Ab47FF;EACE,6BAA6B;Aa37F7B;Ab67FF;EACE,2BAA2B;Aa37F3B;Ab67FF;EACE,2BAA2B;Aa57F3B;Ab87FF;Ea57FI,2BAAwB;Eb87F1B,8BAA8B;Aa77F9B;Ab+7FF;Ea77FI,4BAAuB;Eb+7FzB,6BAA6B;Aa97F7B;Abg8FF;EACE,2BAA2B;Aa/7F3B;Abi8FF;EACE,6BAA6B;Aah8F7B;Abk8FF;EACE,8BAA8B;Aaj8F9B;Abm8FF;EACE,4BAA4B;Aan+F5B;Abq+FF;EACE,4BAA4B;Aap+F5B;Abs+FF;Eap+FI,2BAAuB;Ebs+FzB,8BAA8B;Aar+F9B;Abu+FF;Ear+FI,4BAAsB;Ebu+FxB,6BAA6B;Aat+F7B;Abw+FF;EACE,2BAA2B;Aav+F3B;Aby+FF;EACE,6BAA6B;Aax+F7B;Ab0+FF;EACE,8BAA8B;Aaz+F9B;Ab2+FF;EACE,4BAA4B;Aaz+F5B;Ab2+FF;EACE,6BAA6B;Aa1+F7B;Ab4+FF;Ea1+FI,4BAAwB;Eb4+F1B,+BAA+B;Aa3+F/B;Ab6+FF;Ea3+FI,6BAAuB;Eb6+FzB,8BAA8B;Aa5+F9B;Ab8+FF;EACE,4BAA4B;Aa7+F5B;Ab++FF;EACE,8BAA8B;Aa9+F9B;Abg/FF;EACE,+BAA+B;Aa/+F/B;Abi/FF;EACE,6BAA6B;AajhG7B;AbmhGF;EACE,4BAA4B;AalhG5B;AbohGF;EalhGI,2BAAuB;EbohGzB,8BAA8B;AanhG9B;AbqhGF;EanhGI,4BAAsB;EbqhGxB,6BAA6B;AaphG7B;AbshGF;EACE,2BAA2B;AarhG3B;AbuhGF;EACE,6BAA6B;AathG7B;AbwhGF;EACE,8BAA8B;AavhG9B;AbyhGF;EACE,4BAA4B;AavhG5B;AbyhGF;EACE,6BAA6B;AaxhG7B;Ab0hGF;EaxhGI,4BAAwB;Eb0hG1B,+BAA+B;AazhG/B;Ab2hGF;EazhGI,6BAAuB;Eb2hGzB,8BAA8B;Aa1hG9B;Ab4hGF;EACE,4BAA4B;Aa3hG5B;Ab6hGF;EACE,8BAA8B;Aa5hG9B;Ab8hGF;EACE,+BAA+B;Aa7hG/B;Ab+hGF;EACE,6BAA6B;Aa/jG7B;AbikGF;EACE,4BAA4B;AahkG5B;AbkkGF;EahkGI,2BAAuB;EbkkGzB,8BAA8B;AajkG9B;AbmkGF;EajkGI,4BAAsB;EbmkGxB,6BAA6B;AalkG7B;AbokGF;EACE,2BAA2B;AankG3B;AbqkGF;EACE,6BAA6B;AapkG7B;AbskGF;EACE,8BAA8B;AarkG9B;AbukGF;EACE,4BAA4B;AarkG5B;AbukGF;EACE,6BAA6B;AatkG7B;AbwkGF;EatkGI,4BAAwB;EbwkG1B,+BAA+B;AavkG/B;AbykGF;EavkGI,6BAAuB;EbykGzB,8BAA8B;AaxkG9B;Ab0kGF;EACE,4BAA4B;AazkG5B;Ab2kGF;EACE,8BAA8B;Aa1kG9B;Ab4kGF;EACE,+BAA+B;Aa3kG/B;Ab6kGF;EACE,6BAA6B;Aa7mG7B;Ab+mGF;EACE;Ia9mGA,2BAAA;EACE;EACA;IbgnGA,6BAA6B;Ea/mG/B;EACE;IACA,4BAAA;EbinGF;EahnGA;IACE,8BAAA;EbknGF;AajnGA;AbmnGF;EACE;IalnGA,2BAAA;EACE;EbonGF;IannGA,6BAAA;EACE;EbqnGF;IannGA,4BAAA;EACE;EbqnGF;IapnGA,8BAAA;EACE;AbsnGJ;AACA;EarnGE;IACE,2BAAsB;EACtB;EbunGF;IatnGA,6BAAA;EACE;EbwnGF;IavnGA,4BAAA;EACE;EbynGF;IaxnGA,8BAAA;EACE;Ab0nGJ;AaznGE;EACE;Ib2nGA,2BAA2B;EctrGI;EAC/B;IACE,6BAAA;EdwrGJ;EctrGE;IACE,4BAAY;EdwrGhB;EctrGE;IACE,8BAAA;EdwrGJ;ActrGE;AdwrGJ;EACE;IACE,2BAA2B;EcpsGI;EAC/B;IACE,6BAAA;EdssGJ;EcpsGE;IACE,4BAAY;EdssGhB;EcpsGE;IACE,8BAAA;EdssGJ;AcpsGE;AdssGJ;EACE,2BAA2B;AAC7B;AcltGmC;EAC/B,2BAAA;AdotGJ;AACA;EcltGI,2BAAA;AdotGJ;AACA;EcltGI,2BAAA;AdotGJ;AACA;EcltGI,2BAAA;AdotGJ;AACA;EACE,2BAA2B;AchuGM;AAC/B;EdkuGF,6BcjuGgB;AdkuGlB;AchuGI;EdkuGF,qCcjuGI;AdkuGN;AchuGI;EdkuGF,oCcjuGI;AdkuGN;AchuGI;EdkuGF,+BcjuGgB;AdkuGlB;AACA;Ec9uGmC,oCAAA;AAC/B;AdgvGJ;EACE,8BAA8B;Ac9uG5B;AdgvGJ;EACE,8BAA8B;Ec9uG5B,2BAAA;EdgvGF,kCc/uGI;EdgvGJ,2BAA2B;Ac9uGzB;AdgvGJ;EACE,wDAAwD;AAC1D;Ac7uGI;EACE,sDAAA;Ad+uGN;AchvGI;EACE,sDAAA;AdkvGN;AcnvGI;EACE,wDAAA;AdqvGN;ActvGI;EACE,4DAAA;AdwvGN;AczvGI;EACE,2DAAA;Ad2vGN","sourcesContent":["@keyframes shake\n  59%\n    margin-left: 0\n\n  60%, 80%\n    margin-left: 2px\n\n  70%, 90%\n    margin-left: -2px\n","@-moz-keyframes shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n@-webkit-keyframes shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n@-o-keyframes shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n@keyframes shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n.black {\n  background-color: #000 !important;\n  border-color: #000 !important;\n}\n.black--text {\n  color: #000 !important;\n  caret-color: #000 !important;\n}\n.white {\n  background-color: #fff !important;\n  border-color: #fff !important;\n}\n.white--text {\n  color: #fff !important;\n  caret-color: #fff !important;\n}\n.transparent {\n  background-color: transparent !important;\n  border-color: transparent !important;\n}\n.transparent--text {\n  color: transparent !important;\n  caret-color: transparent !important;\n}\n.red {\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.red--text {\n  color: #f44336 !important;\n  caret-color: #f44336 !important;\n}\n.red.lighten-5 {\n  background-color: #ffebee !important;\n  border-color: #ffebee !important;\n}\n.red--text.text--lighten-5 {\n  color: #ffebee !important;\n  caret-color: #ffebee !important;\n}\n.red.lighten-4 {\n  background-color: #ffcdd2 !important;\n  border-color: #ffcdd2 !important;\n}\n.red--text.text--lighten-4 {\n  color: #ffcdd2 !important;\n  caret-color: #ffcdd2 !important;\n}\n.red.lighten-3 {\n  background-color: #ef9a9a !important;\n  border-color: #ef9a9a !important;\n}\n.red--text.text--lighten-3 {\n  color: #ef9a9a !important;\n  caret-color: #ef9a9a !important;\n}\n.red.lighten-2 {\n  background-color: #e57373 !important;\n  border-color: #e57373 !important;\n}\n.red--text.text--lighten-2 {\n  color: #e57373 !important;\n  caret-color: #e57373 !important;\n}\n.red.lighten-1 {\n  background-color: #ef5350 !important;\n  border-color: #ef5350 !important;\n}\n.red--text.text--lighten-1 {\n  color: #ef5350 !important;\n  caret-color: #ef5350 !important;\n}\n.red.darken-1 {\n  background-color: #e53935 !important;\n  border-color: #e53935 !important;\n}\n.red--text.text--darken-1 {\n  color: #e53935 !important;\n  caret-color: #e53935 !important;\n}\n.red.darken-2 {\n  background-color: #d32f2f !important;\n  border-color: #d32f2f !important;\n}\n.red--text.text--darken-2 {\n  color: #d32f2f !important;\n  caret-color: #d32f2f !important;\n}\n.red.darken-3 {\n  background-color: #c62828 !important;\n  border-color: #c62828 !important;\n}\n.red--text.text--darken-3 {\n  color: #c62828 !important;\n  caret-color: #c62828 !important;\n}\n.red.darken-4 {\n  background-color: #b71c1c !important;\n  border-color: #b71c1c !important;\n}\n.red--text.text--darken-4 {\n  color: #b71c1c !important;\n  caret-color: #b71c1c !important;\n}\n.red.accent-1 {\n  background-color: #ff8a80 !important;\n  border-color: #ff8a80 !important;\n}\n.red--text.text--accent-1 {\n  color: #ff8a80 !important;\n  caret-color: #ff8a80 !important;\n}\n.red.accent-2 {\n  background-color: #ff5252 !important;\n  border-color: #ff5252 !important;\n}\n.red--text.text--accent-2 {\n  color: #ff5252 !important;\n  caret-color: #ff5252 !important;\n}\n.red.accent-3 {\n  background-color: #ff1744 !important;\n  border-color: #ff1744 !important;\n}\n.red--text.text--accent-3 {\n  color: #ff1744 !important;\n  caret-color: #ff1744 !important;\n}\n.red.accent-4 {\n  background-color: #d50000 !important;\n  border-color: #d50000 !important;\n}\n.red--text.text--accent-4 {\n  color: #d50000 !important;\n  caret-color: #d50000 !important;\n}\n.pink {\n  background-color: #e91e63 !important;\n  border-color: #e91e63 !important;\n}\n.pink--text {\n  color: #e91e63 !important;\n  caret-color: #e91e63 !important;\n}\n.pink.lighten-5 {\n  background-color: #fce4ec !important;\n  border-color: #fce4ec !important;\n}\n.pink--text.text--lighten-5 {\n  color: #fce4ec !important;\n  caret-color: #fce4ec !important;\n}\n.pink.lighten-4 {\n  background-color: #f8bbd0 !important;\n  border-color: #f8bbd0 !important;\n}\n.pink--text.text--lighten-4 {\n  color: #f8bbd0 !important;\n  caret-color: #f8bbd0 !important;\n}\n.pink.lighten-3 {\n  background-color: #f48fb1 !important;\n  border-color: #f48fb1 !important;\n}\n.pink--text.text--lighten-3 {\n  color: #f48fb1 !important;\n  caret-color: #f48fb1 !important;\n}\n.pink.lighten-2 {\n  background-color: #f06292 !important;\n  border-color: #f06292 !important;\n}\n.pink--text.text--lighten-2 {\n  color: #f06292 !important;\n  caret-color: #f06292 !important;\n}\n.pink.lighten-1 {\n  background-color: #ec407a !important;\n  border-color: #ec407a !important;\n}\n.pink--text.text--lighten-1 {\n  color: #ec407a !important;\n  caret-color: #ec407a !important;\n}\n.pink.darken-1 {\n  background-color: #d81b60 !important;\n  border-color: #d81b60 !important;\n}\n.pink--text.text--darken-1 {\n  color: #d81b60 !important;\n  caret-color: #d81b60 !important;\n}\n.pink.darken-2 {\n  background-color: #c2185b !important;\n  border-color: #c2185b !important;\n}\n.pink--text.text--darken-2 {\n  color: #c2185b !important;\n  caret-color: #c2185b !important;\n}\n.pink.darken-3 {\n  background-color: #ad1457 !important;\n  border-color: #ad1457 !important;\n}\n.pink--text.text--darken-3 {\n  color: #ad1457 !important;\n  caret-color: #ad1457 !important;\n}\n.pink.darken-4 {\n  background-color: #880e4f !important;\n  border-color: #880e4f !important;\n}\n.pink--text.text--darken-4 {\n  color: #880e4f !important;\n  caret-color: #880e4f !important;\n}\n.pink.accent-1 {\n  background-color: #ff80ab !important;\n  border-color: #ff80ab !important;\n}\n.pink--text.text--accent-1 {\n  color: #ff80ab !important;\n  caret-color: #ff80ab !important;\n}\n.pink.accent-2 {\n  background-color: #ff4081 !important;\n  border-color: #ff4081 !important;\n}\n.pink--text.text--accent-2 {\n  color: #ff4081 !important;\n  caret-color: #ff4081 !important;\n}\n.pink.accent-3 {\n  background-color: #f50057 !important;\n  border-color: #f50057 !important;\n}\n.pink--text.text--accent-3 {\n  color: #f50057 !important;\n  caret-color: #f50057 !important;\n}\n.pink.accent-4 {\n  background-color: #c51162 !important;\n  border-color: #c51162 !important;\n}\n.pink--text.text--accent-4 {\n  color: #c51162 !important;\n  caret-color: #c51162 !important;\n}\n.purple {\n  background-color: #9c27b0 !important;\n  border-color: #9c27b0 !important;\n}\n.purple--text {\n  color: #9c27b0 !important;\n  caret-color: #9c27b0 !important;\n}\n.purple.lighten-5 {\n  background-color: #f3e5f5 !important;\n  border-color: #f3e5f5 !important;\n}\n.purple--text.text--lighten-5 {\n  color: #f3e5f5 !important;\n  caret-color: #f3e5f5 !important;\n}\n.purple.lighten-4 {\n  background-color: #e1bee7 !important;\n  border-color: #e1bee7 !important;\n}\n.purple--text.text--lighten-4 {\n  color: #e1bee7 !important;\n  caret-color: #e1bee7 !important;\n}\n.purple.lighten-3 {\n  background-color: #ce93d8 !important;\n  border-color: #ce93d8 !important;\n}\n.purple--text.text--lighten-3 {\n  color: #ce93d8 !important;\n  caret-color: #ce93d8 !important;\n}\n.purple.lighten-2 {\n  background-color: #ba68c8 !important;\n  border-color: #ba68c8 !important;\n}\n.purple--text.text--lighten-2 {\n  color: #ba68c8 !important;\n  caret-color: #ba68c8 !important;\n}\n.purple.lighten-1 {\n  background-color: #ab47bc !important;\n  border-color: #ab47bc !important;\n}\n.purple--text.text--lighten-1 {\n  color: #ab47bc !important;\n  caret-color: #ab47bc !important;\n}\n.purple.darken-1 {\n  background-color: #8e24aa !important;\n  border-color: #8e24aa !important;\n}\n.purple--text.text--darken-1 {\n  color: #8e24aa !important;\n  caret-color: #8e24aa !important;\n}\n.purple.darken-2 {\n  background-color: #7b1fa2 !important;\n  border-color: #7b1fa2 !important;\n}\n.purple--text.text--darken-2 {\n  color: #7b1fa2 !important;\n  caret-color: #7b1fa2 !important;\n}\n.purple.darken-3 {\n  background-color: #6a1b9a !important;\n  border-color: #6a1b9a !important;\n}\n.purple--text.text--darken-3 {\n  color: #6a1b9a !important;\n  caret-color: #6a1b9a !important;\n}\n.purple.darken-4 {\n  background-color: #4a148c !important;\n  border-color: #4a148c !important;\n}\n.purple--text.text--darken-4 {\n  color: #4a148c !important;\n  caret-color: #4a148c !important;\n}\n.purple.accent-1 {\n  background-color: #ea80fc !important;\n  border-color: #ea80fc !important;\n}\n.purple--text.text--accent-1 {\n  color: #ea80fc !important;\n  caret-color: #ea80fc !important;\n}\n.purple.accent-2 {\n  background-color: #e040fb !important;\n  border-color: #e040fb !important;\n}\n.purple--text.text--accent-2 {\n  color: #e040fb !important;\n  caret-color: #e040fb !important;\n}\n.purple.accent-3 {\n  background-color: #d500f9 !important;\n  border-color: #d500f9 !important;\n}\n.purple--text.text--accent-3 {\n  color: #d500f9 !important;\n  caret-color: #d500f9 !important;\n}\n.purple.accent-4 {\n  background-color: #a0f !important;\n  border-color: #a0f !important;\n}\n.purple--text.text--accent-4 {\n  color: #a0f !important;\n  caret-color: #a0f !important;\n}\n.deep-purple {\n  background-color: #673ab7 !important;\n  border-color: #673ab7 !important;\n}\n.deep-purple--text {\n  color: #673ab7 !important;\n  caret-color: #673ab7 !important;\n}\n.deep-purple.lighten-5 {\n  background-color: #ede7f6 !important;\n  border-color: #ede7f6 !important;\n}\n.deep-purple--text.text--lighten-5 {\n  color: #ede7f6 !important;\n  caret-color: #ede7f6 !important;\n}\n.deep-purple.lighten-4 {\n  background-color: #d1c4e9 !important;\n  border-color: #d1c4e9 !important;\n}\n.deep-purple--text.text--lighten-4 {\n  color: #d1c4e9 !important;\n  caret-color: #d1c4e9 !important;\n}\n.deep-purple.lighten-3 {\n  background-color: #b39ddb !important;\n  border-color: #b39ddb !important;\n}\n.deep-purple--text.text--lighten-3 {\n  color: #b39ddb !important;\n  caret-color: #b39ddb !important;\n}\n.deep-purple.lighten-2 {\n  background-color: #9575cd !important;\n  border-color: #9575cd !important;\n}\n.deep-purple--text.text--lighten-2 {\n  color: #9575cd !important;\n  caret-color: #9575cd !important;\n}\n.deep-purple.lighten-1 {\n  background-color: #7e57c2 !important;\n  border-color: #7e57c2 !important;\n}\n.deep-purple--text.text--lighten-1 {\n  color: #7e57c2 !important;\n  caret-color: #7e57c2 !important;\n}\n.deep-purple.darken-1 {\n  background-color: #5e35b1 !important;\n  border-color: #5e35b1 !important;\n}\n.deep-purple--text.text--darken-1 {\n  color: #5e35b1 !important;\n  caret-color: #5e35b1 !important;\n}\n.deep-purple.darken-2 {\n  background-color: #512da8 !important;\n  border-color: #512da8 !important;\n}\n.deep-purple--text.text--darken-2 {\n  color: #512da8 !important;\n  caret-color: #512da8 !important;\n}\n.deep-purple.darken-3 {\n  background-color: #4527a0 !important;\n  border-color: #4527a0 !important;\n}\n.deep-purple--text.text--darken-3 {\n  color: #4527a0 !important;\n  caret-color: #4527a0 !important;\n}\n.deep-purple.darken-4 {\n  background-color: #311b92 !important;\n  border-color: #311b92 !important;\n}\n.deep-purple--text.text--darken-4 {\n  color: #311b92 !important;\n  caret-color: #311b92 !important;\n}\n.deep-purple.accent-1 {\n  background-color: #b388ff !important;\n  border-color: #b388ff !important;\n}\n.deep-purple--text.text--accent-1 {\n  color: #b388ff !important;\n  caret-color: #b388ff !important;\n}\n.deep-purple.accent-2 {\n  background-color: #7c4dff !important;\n  border-color: #7c4dff !important;\n}\n.deep-purple--text.text--accent-2 {\n  color: #7c4dff !important;\n  caret-color: #7c4dff !important;\n}\n.deep-purple.accent-3 {\n  background-color: #651fff !important;\n  border-color: #651fff !important;\n}\n.deep-purple--text.text--accent-3 {\n  color: #651fff !important;\n  caret-color: #651fff !important;\n}\n.deep-purple.accent-4 {\n  background-color: #6200ea !important;\n  border-color: #6200ea !important;\n}\n.deep-purple--text.text--accent-4 {\n  color: #6200ea !important;\n  caret-color: #6200ea !important;\n}\n.indigo {\n  background-color: #3f51b5 !important;\n  border-color: #3f51b5 !important;\n}\n.indigo--text {\n  color: #3f51b5 !important;\n  caret-color: #3f51b5 !important;\n}\n.indigo.lighten-5 {\n  background-color: #e8eaf6 !important;\n  border-color: #e8eaf6 !important;\n}\n.indigo--text.text--lighten-5 {\n  color: #e8eaf6 !important;\n  caret-color: #e8eaf6 !important;\n}\n.indigo.lighten-4 {\n  background-color: #c5cae9 !important;\n  border-color: #c5cae9 !important;\n}\n.indigo--text.text--lighten-4 {\n  color: #c5cae9 !important;\n  caret-color: #c5cae9 !important;\n}\n.indigo.lighten-3 {\n  background-color: #9fa8da !important;\n  border-color: #9fa8da !important;\n}\n.indigo--text.text--lighten-3 {\n  color: #9fa8da !important;\n  caret-color: #9fa8da !important;\n}\n.indigo.lighten-2 {\n  background-color: #7986cb !important;\n  border-color: #7986cb !important;\n}\n.indigo--text.text--lighten-2 {\n  color: #7986cb !important;\n  caret-color: #7986cb !important;\n}\n.indigo.lighten-1 {\n  background-color: #5c6bc0 !important;\n  border-color: #5c6bc0 !important;\n}\n.indigo--text.text--lighten-1 {\n  color: #5c6bc0 !important;\n  caret-color: #5c6bc0 !important;\n}\n.indigo.darken-1 {\n  background-color: #3949ab !important;\n  border-color: #3949ab !important;\n}\n.indigo--text.text--darken-1 {\n  color: #3949ab !important;\n  caret-color: #3949ab !important;\n}\n.indigo.darken-2 {\n  background-color: #303f9f !important;\n  border-color: #303f9f !important;\n}\n.indigo--text.text--darken-2 {\n  color: #303f9f !important;\n  caret-color: #303f9f !important;\n}\n.indigo.darken-3 {\n  background-color: #283593 !important;\n  border-color: #283593 !important;\n}\n.indigo--text.text--darken-3 {\n  color: #283593 !important;\n  caret-color: #283593 !important;\n}\n.indigo.darken-4 {\n  background-color: #1a237e !important;\n  border-color: #1a237e !important;\n}\n.indigo--text.text--darken-4 {\n  color: #1a237e !important;\n  caret-color: #1a237e !important;\n}\n.indigo.accent-1 {\n  background-color: #8c9eff !important;\n  border-color: #8c9eff !important;\n}\n.indigo--text.text--accent-1 {\n  color: #8c9eff !important;\n  caret-color: #8c9eff !important;\n}\n.indigo.accent-2 {\n  background-color: #536dfe !important;\n  border-color: #536dfe !important;\n}\n.indigo--text.text--accent-2 {\n  color: #536dfe !important;\n  caret-color: #536dfe !important;\n}\n.indigo.accent-3 {\n  background-color: #3d5afe !important;\n  border-color: #3d5afe !important;\n}\n.indigo--text.text--accent-3 {\n  color: #3d5afe !important;\n  caret-color: #3d5afe !important;\n}\n.indigo.accent-4 {\n  background-color: #304ffe !important;\n  border-color: #304ffe !important;\n}\n.indigo--text.text--accent-4 {\n  color: #304ffe !important;\n  caret-color: #304ffe !important;\n}\n.blue {\n  background-color: #2196f3 !important;\n  border-color: #2196f3 !important;\n}\n.blue--text {\n  color: #2196f3 !important;\n  caret-color: #2196f3 !important;\n}\n.blue.lighten-5 {\n  background-color: #e3f2fd !important;\n  border-color: #e3f2fd !important;\n}\n.blue--text.text--lighten-5 {\n  color: #e3f2fd !important;\n  caret-color: #e3f2fd !important;\n}\n.blue.lighten-4 {\n  background-color: #bbdefb !important;\n  border-color: #bbdefb !important;\n}\n.blue--text.text--lighten-4 {\n  color: #bbdefb !important;\n  caret-color: #bbdefb !important;\n}\n.blue.lighten-3 {\n  background-color: #90caf9 !important;\n  border-color: #90caf9 !important;\n}\n.blue--text.text--lighten-3 {\n  color: #90caf9 !important;\n  caret-color: #90caf9 !important;\n}\n.blue.lighten-2 {\n  background-color: #64b5f6 !important;\n  border-color: #64b5f6 !important;\n}\n.blue--text.text--lighten-2 {\n  color: #64b5f6 !important;\n  caret-color: #64b5f6 !important;\n}\n.blue.lighten-1 {\n  background-color: #42a5f5 !important;\n  border-color: #42a5f5 !important;\n}\n.blue--text.text--lighten-1 {\n  color: #42a5f5 !important;\n  caret-color: #42a5f5 !important;\n}\n.blue.darken-1 {\n  background-color: #1e88e5 !important;\n  border-color: #1e88e5 !important;\n}\n.blue--text.text--darken-1 {\n  color: #1e88e5 !important;\n  caret-color: #1e88e5 !important;\n}\n.blue.darken-2 {\n  background-color: #1976d2 !important;\n  border-color: #1976d2 !important;\n}\n.blue--text.text--darken-2 {\n  color: #1976d2 !important;\n  caret-color: #1976d2 !important;\n}\n.blue.darken-3 {\n  background-color: #1565c0 !important;\n  border-color: #1565c0 !important;\n}\n.blue--text.text--darken-3 {\n  color: #1565c0 !important;\n  caret-color: #1565c0 !important;\n}\n.blue.darken-4 {\n  background-color: #0d47a1 !important;\n  border-color: #0d47a1 !important;\n}\n.blue--text.text--darken-4 {\n  color: #0d47a1 !important;\n  caret-color: #0d47a1 !important;\n}\n.blue.accent-1 {\n  background-color: #82b1ff !important;\n  border-color: #82b1ff !important;\n}\n.blue--text.text--accent-1 {\n  color: #82b1ff !important;\n  caret-color: #82b1ff !important;\n}\n.blue.accent-2 {\n  background-color: #448aff !important;\n  border-color: #448aff !important;\n}\n.blue--text.text--accent-2 {\n  color: #448aff !important;\n  caret-color: #448aff !important;\n}\n.blue.accent-3 {\n  background-color: #2979ff !important;\n  border-color: #2979ff !important;\n}\n.blue--text.text--accent-3 {\n  color: #2979ff !important;\n  caret-color: #2979ff !important;\n}\n.blue.accent-4 {\n  background-color: #2962ff !important;\n  border-color: #2962ff !important;\n}\n.blue--text.text--accent-4 {\n  color: #2962ff !important;\n  caret-color: #2962ff !important;\n}\n.light-blue {\n  background-color: #03a9f4 !important;\n  border-color: #03a9f4 !important;\n}\n.light-blue--text {\n  color: #03a9f4 !important;\n  caret-color: #03a9f4 !important;\n}\n.light-blue.lighten-5 {\n  background-color: #e1f5fe !important;\n  border-color: #e1f5fe !important;\n}\n.light-blue--text.text--lighten-5 {\n  color: #e1f5fe !important;\n  caret-color: #e1f5fe !important;\n}\n.light-blue.lighten-4 {\n  background-color: #b3e5fc !important;\n  border-color: #b3e5fc !important;\n}\n.light-blue--text.text--lighten-4 {\n  color: #b3e5fc !important;\n  caret-color: #b3e5fc !important;\n}\n.light-blue.lighten-3 {\n  background-color: #81d4fa !important;\n  border-color: #81d4fa !important;\n}\n.light-blue--text.text--lighten-3 {\n  color: #81d4fa !important;\n  caret-color: #81d4fa !important;\n}\n.light-blue.lighten-2 {\n  background-color: #4fc3f7 !important;\n  border-color: #4fc3f7 !important;\n}\n.light-blue--text.text--lighten-2 {\n  color: #4fc3f7 !important;\n  caret-color: #4fc3f7 !important;\n}\n.light-blue.lighten-1 {\n  background-color: #29b6f6 !important;\n  border-color: #29b6f6 !important;\n}\n.light-blue--text.text--lighten-1 {\n  color: #29b6f6 !important;\n  caret-color: #29b6f6 !important;\n}\n.light-blue.darken-1 {\n  background-color: #039be5 !important;\n  border-color: #039be5 !important;\n}\n.light-blue--text.text--darken-1 {\n  color: #039be5 !important;\n  caret-color: #039be5 !important;\n}\n.light-blue.darken-2 {\n  background-color: #0288d1 !important;\n  border-color: #0288d1 !important;\n}\n.light-blue--text.text--darken-2 {\n  color: #0288d1 !important;\n  caret-color: #0288d1 !important;\n}\n.light-blue.darken-3 {\n  background-color: #0277bd !important;\n  border-color: #0277bd !important;\n}\n.light-blue--text.text--darken-3 {\n  color: #0277bd !important;\n  caret-color: #0277bd !important;\n}\n.light-blue.darken-4 {\n  background-color: #01579b !important;\n  border-color: #01579b !important;\n}\n.light-blue--text.text--darken-4 {\n  color: #01579b !important;\n  caret-color: #01579b !important;\n}\n.light-blue.accent-1 {\n  background-color: #80d8ff !important;\n  border-color: #80d8ff !important;\n}\n.light-blue--text.text--accent-1 {\n  color: #80d8ff !important;\n  caret-color: #80d8ff !important;\n}\n.light-blue.accent-2 {\n  background-color: #40c4ff !important;\n  border-color: #40c4ff !important;\n}\n.light-blue--text.text--accent-2 {\n  color: #40c4ff !important;\n  caret-color: #40c4ff !important;\n}\n.light-blue.accent-3 {\n  background-color: #00b0ff !important;\n  border-color: #00b0ff !important;\n}\n.light-blue--text.text--accent-3 {\n  color: #00b0ff !important;\n  caret-color: #00b0ff !important;\n}\n.light-blue.accent-4 {\n  background-color: #0091ea !important;\n  border-color: #0091ea !important;\n}\n.light-blue--text.text--accent-4 {\n  color: #0091ea !important;\n  caret-color: #0091ea !important;\n}\n.cyan {\n  background-color: #00bcd4 !important;\n  border-color: #00bcd4 !important;\n}\n.cyan--text {\n  color: #00bcd4 !important;\n  caret-color: #00bcd4 !important;\n}\n.cyan.lighten-5 {\n  background-color: #e0f7fa !important;\n  border-color: #e0f7fa !important;\n}\n.cyan--text.text--lighten-5 {\n  color: #e0f7fa !important;\n  caret-color: #e0f7fa !important;\n}\n.cyan.lighten-4 {\n  background-color: #b2ebf2 !important;\n  border-color: #b2ebf2 !important;\n}\n.cyan--text.text--lighten-4 {\n  color: #b2ebf2 !important;\n  caret-color: #b2ebf2 !important;\n}\n.cyan.lighten-3 {\n  background-color: #80deea !important;\n  border-color: #80deea !important;\n}\n.cyan--text.text--lighten-3 {\n  color: #80deea !important;\n  caret-color: #80deea !important;\n}\n.cyan.lighten-2 {\n  background-color: #4dd0e1 !important;\n  border-color: #4dd0e1 !important;\n}\n.cyan--text.text--lighten-2 {\n  color: #4dd0e1 !important;\n  caret-color: #4dd0e1 !important;\n}\n.cyan.lighten-1 {\n  background-color: #26c6da !important;\n  border-color: #26c6da !important;\n}\n.cyan--text.text--lighten-1 {\n  color: #26c6da !important;\n  caret-color: #26c6da !important;\n}\n.cyan.darken-1 {\n  background-color: #00acc1 !important;\n  border-color: #00acc1 !important;\n}\n.cyan--text.text--darken-1 {\n  color: #00acc1 !important;\n  caret-color: #00acc1 !important;\n}\n.cyan.darken-2 {\n  background-color: #0097a7 !important;\n  border-color: #0097a7 !important;\n}\n.cyan--text.text--darken-2 {\n  color: #0097a7 !important;\n  caret-color: #0097a7 !important;\n}\n.cyan.darken-3 {\n  background-color: #00838f !important;\n  border-color: #00838f !important;\n}\n.cyan--text.text--darken-3 {\n  color: #00838f !important;\n  caret-color: #00838f !important;\n}\n.cyan.darken-4 {\n  background-color: #006064 !important;\n  border-color: #006064 !important;\n}\n.cyan--text.text--darken-4 {\n  color: #006064 !important;\n  caret-color: #006064 !important;\n}\n.cyan.accent-1 {\n  background-color: #84ffff !important;\n  border-color: #84ffff !important;\n}\n.cyan--text.text--accent-1 {\n  color: #84ffff !important;\n  caret-color: #84ffff !important;\n}\n.cyan.accent-2 {\n  background-color: #18ffff !important;\n  border-color: #18ffff !important;\n}\n.cyan--text.text--accent-2 {\n  color: #18ffff !important;\n  caret-color: #18ffff !important;\n}\n.cyan.accent-3 {\n  background-color: #00e5ff !important;\n  border-color: #00e5ff !important;\n}\n.cyan--text.text--accent-3 {\n  color: #00e5ff !important;\n  caret-color: #00e5ff !important;\n}\n.cyan.accent-4 {\n  background-color: #00b8d4 !important;\n  border-color: #00b8d4 !important;\n}\n.cyan--text.text--accent-4 {\n  color: #00b8d4 !important;\n  caret-color: #00b8d4 !important;\n}\n.teal {\n  background-color: #009688 !important;\n  border-color: #009688 !important;\n}\n.teal--text {\n  color: #009688 !important;\n  caret-color: #009688 !important;\n}\n.teal.lighten-5 {\n  background-color: #e0f2f1 !important;\n  border-color: #e0f2f1 !important;\n}\n.teal--text.text--lighten-5 {\n  color: #e0f2f1 !important;\n  caret-color: #e0f2f1 !important;\n}\n.teal.lighten-4 {\n  background-color: #b2dfdb !important;\n  border-color: #b2dfdb !important;\n}\n.teal--text.text--lighten-4 {\n  color: #b2dfdb !important;\n  caret-color: #b2dfdb !important;\n}\n.teal.lighten-3 {\n  background-color: #80cbc4 !important;\n  border-color: #80cbc4 !important;\n}\n.teal--text.text--lighten-3 {\n  color: #80cbc4 !important;\n  caret-color: #80cbc4 !important;\n}\n.teal.lighten-2 {\n  background-color: #4db6ac !important;\n  border-color: #4db6ac !important;\n}\n.teal--text.text--lighten-2 {\n  color: #4db6ac !important;\n  caret-color: #4db6ac !important;\n}\n.teal.lighten-1 {\n  background-color: #26a69a !important;\n  border-color: #26a69a !important;\n}\n.teal--text.text--lighten-1 {\n  color: #26a69a !important;\n  caret-color: #26a69a !important;\n}\n.teal.darken-1 {\n  background-color: #00897b !important;\n  border-color: #00897b !important;\n}\n.teal--text.text--darken-1 {\n  color: #00897b !important;\n  caret-color: #00897b !important;\n}\n.teal.darken-2 {\n  background-color: #00796b !important;\n  border-color: #00796b !important;\n}\n.teal--text.text--darken-2 {\n  color: #00796b !important;\n  caret-color: #00796b !important;\n}\n.teal.darken-3 {\n  background-color: #00695c !important;\n  border-color: #00695c !important;\n}\n.teal--text.text--darken-3 {\n  color: #00695c !important;\n  caret-color: #00695c !important;\n}\n.teal.darken-4 {\n  background-color: #004d40 !important;\n  border-color: #004d40 !important;\n}\n.teal--text.text--darken-4 {\n  color: #004d40 !important;\n  caret-color: #004d40 !important;\n}\n.teal.accent-1 {\n  background-color: #a7ffeb !important;\n  border-color: #a7ffeb !important;\n}\n.teal--text.text--accent-1 {\n  color: #a7ffeb !important;\n  caret-color: #a7ffeb !important;\n}\n.teal.accent-2 {\n  background-color: #64ffda !important;\n  border-color: #64ffda !important;\n}\n.teal--text.text--accent-2 {\n  color: #64ffda !important;\n  caret-color: #64ffda !important;\n}\n.teal.accent-3 {\n  background-color: #1de9b6 !important;\n  border-color: #1de9b6 !important;\n}\n.teal--text.text--accent-3 {\n  color: #1de9b6 !important;\n  caret-color: #1de9b6 !important;\n}\n.teal.accent-4 {\n  background-color: #00bfa5 !important;\n  border-color: #00bfa5 !important;\n}\n.teal--text.text--accent-4 {\n  color: #00bfa5 !important;\n  caret-color: #00bfa5 !important;\n}\n.green {\n  background-color: #4caf50 !important;\n  border-color: #4caf50 !important;\n}\n.green--text {\n  color: #4caf50 !important;\n  caret-color: #4caf50 !important;\n}\n.green.lighten-5 {\n  background-color: #e8f5e9 !important;\n  border-color: #e8f5e9 !important;\n}\n.green--text.text--lighten-5 {\n  color: #e8f5e9 !important;\n  caret-color: #e8f5e9 !important;\n}\n.green.lighten-4 {\n  background-color: #c8e6c9 !important;\n  border-color: #c8e6c9 !important;\n}\n.green--text.text--lighten-4 {\n  color: #c8e6c9 !important;\n  caret-color: #c8e6c9 !important;\n}\n.green.lighten-3 {\n  background-color: #a5d6a7 !important;\n  border-color: #a5d6a7 !important;\n}\n.green--text.text--lighten-3 {\n  color: #a5d6a7 !important;\n  caret-color: #a5d6a7 !important;\n}\n.green.lighten-2 {\n  background-color: #81c784 !important;\n  border-color: #81c784 !important;\n}\n.green--text.text--lighten-2 {\n  color: #81c784 !important;\n  caret-color: #81c784 !important;\n}\n.green.lighten-1 {\n  background-color: #66bb6a !important;\n  border-color: #66bb6a !important;\n}\n.green--text.text--lighten-1 {\n  color: #66bb6a !important;\n  caret-color: #66bb6a !important;\n}\n.green.darken-1 {\n  background-color: #43a047 !important;\n  border-color: #43a047 !important;\n}\n.green--text.text--darken-1 {\n  color: #43a047 !important;\n  caret-color: #43a047 !important;\n}\n.green.darken-2 {\n  background-color: #388e3c !important;\n  border-color: #388e3c !important;\n}\n.green--text.text--darken-2 {\n  color: #388e3c !important;\n  caret-color: #388e3c !important;\n}\n.green.darken-3 {\n  background-color: #2e7d32 !important;\n  border-color: #2e7d32 !important;\n}\n.green--text.text--darken-3 {\n  color: #2e7d32 !important;\n  caret-color: #2e7d32 !important;\n}\n.green.darken-4 {\n  background-color: #1b5e20 !important;\n  border-color: #1b5e20 !important;\n}\n.green--text.text--darken-4 {\n  color: #1b5e20 !important;\n  caret-color: #1b5e20 !important;\n}\n.green.accent-1 {\n  background-color: #b9f6ca !important;\n  border-color: #b9f6ca !important;\n}\n.green--text.text--accent-1 {\n  color: #b9f6ca !important;\n  caret-color: #b9f6ca !important;\n}\n.green.accent-2 {\n  background-color: #69f0ae !important;\n  border-color: #69f0ae !important;\n}\n.green--text.text--accent-2 {\n  color: #69f0ae !important;\n  caret-color: #69f0ae !important;\n}\n.green.accent-3 {\n  background-color: #00e676 !important;\n  border-color: #00e676 !important;\n}\n.green--text.text--accent-3 {\n  color: #00e676 !important;\n  caret-color: #00e676 !important;\n}\n.green.accent-4 {\n  background-color: #00c853 !important;\n  border-color: #00c853 !important;\n}\n.green--text.text--accent-4 {\n  color: #00c853 !important;\n  caret-color: #00c853 !important;\n}\n.light-green {\n  background-color: #8bc34a !important;\n  border-color: #8bc34a !important;\n}\n.light-green--text {\n  color: #8bc34a !important;\n  caret-color: #8bc34a !important;\n}\n.light-green.lighten-5 {\n  background-color: #f1f8e9 !important;\n  border-color: #f1f8e9 !important;\n}\n.light-green--text.text--lighten-5 {\n  color: #f1f8e9 !important;\n  caret-color: #f1f8e9 !important;\n}\n.light-green.lighten-4 {\n  background-color: #dcedc8 !important;\n  border-color: #dcedc8 !important;\n}\n.light-green--text.text--lighten-4 {\n  color: #dcedc8 !important;\n  caret-color: #dcedc8 !important;\n}\n.light-green.lighten-3 {\n  background-color: #c5e1a5 !important;\n  border-color: #c5e1a5 !important;\n}\n.light-green--text.text--lighten-3 {\n  color: #c5e1a5 !important;\n  caret-color: #c5e1a5 !important;\n}\n.light-green.lighten-2 {\n  background-color: #aed581 !important;\n  border-color: #aed581 !important;\n}\n.light-green--text.text--lighten-2 {\n  color: #aed581 !important;\n  caret-color: #aed581 !important;\n}\n.light-green.lighten-1 {\n  background-color: #9ccc65 !important;\n  border-color: #9ccc65 !important;\n}\n.light-green--text.text--lighten-1 {\n  color: #9ccc65 !important;\n  caret-color: #9ccc65 !important;\n}\n.light-green.darken-1 {\n  background-color: #7cb342 !important;\n  border-color: #7cb342 !important;\n}\n.light-green--text.text--darken-1 {\n  color: #7cb342 !important;\n  caret-color: #7cb342 !important;\n}\n.light-green.darken-2 {\n  background-color: #689f38 !important;\n  border-color: #689f38 !important;\n}\n.light-green--text.text--darken-2 {\n  color: #689f38 !important;\n  caret-color: #689f38 !important;\n}\n.light-green.darken-3 {\n  background-color: #558b2f !important;\n  border-color: #558b2f !important;\n}\n.light-green--text.text--darken-3 {\n  color: #558b2f !important;\n  caret-color: #558b2f !important;\n}\n.light-green.darken-4 {\n  background-color: #33691e !important;\n  border-color: #33691e !important;\n}\n.light-green--text.text--darken-4 {\n  color: #33691e !important;\n  caret-color: #33691e !important;\n}\n.light-green.accent-1 {\n  background-color: #ccff90 !important;\n  border-color: #ccff90 !important;\n}\n.light-green--text.text--accent-1 {\n  color: #ccff90 !important;\n  caret-color: #ccff90 !important;\n}\n.light-green.accent-2 {\n  background-color: #b2ff59 !important;\n  border-color: #b2ff59 !important;\n}\n.light-green--text.text--accent-2 {\n  color: #b2ff59 !important;\n  caret-color: #b2ff59 !important;\n}\n.light-green.accent-3 {\n  background-color: #76ff03 !important;\n  border-color: #76ff03 !important;\n}\n.light-green--text.text--accent-3 {\n  color: #76ff03 !important;\n  caret-color: #76ff03 !important;\n}\n.light-green.accent-4 {\n  background-color: #64dd17 !important;\n  border-color: #64dd17 !important;\n}\n.light-green--text.text--accent-4 {\n  color: #64dd17 !important;\n  caret-color: #64dd17 !important;\n}\n.lime {\n  background-color: #cddc39 !important;\n  border-color: #cddc39 !important;\n}\n.lime--text {\n  color: #cddc39 !important;\n  caret-color: #cddc39 !important;\n}\n.lime.lighten-5 {\n  background-color: #f9fbe7 !important;\n  border-color: #f9fbe7 !important;\n}\n.lime--text.text--lighten-5 {\n  color: #f9fbe7 !important;\n  caret-color: #f9fbe7 !important;\n}\n.lime.lighten-4 {\n  background-color: #f0f4c3 !important;\n  border-color: #f0f4c3 !important;\n}\n.lime--text.text--lighten-4 {\n  color: #f0f4c3 !important;\n  caret-color: #f0f4c3 !important;\n}\n.lime.lighten-3 {\n  background-color: #e6ee9c !important;\n  border-color: #e6ee9c !important;\n}\n.lime--text.text--lighten-3 {\n  color: #e6ee9c !important;\n  caret-color: #e6ee9c !important;\n}\n.lime.lighten-2 {\n  background-color: #dce775 !important;\n  border-color: #dce775 !important;\n}\n.lime--text.text--lighten-2 {\n  color: #dce775 !important;\n  caret-color: #dce775 !important;\n}\n.lime.lighten-1 {\n  background-color: #d4e157 !important;\n  border-color: #d4e157 !important;\n}\n.lime--text.text--lighten-1 {\n  color: #d4e157 !important;\n  caret-color: #d4e157 !important;\n}\n.lime.darken-1 {\n  background-color: #c0ca33 !important;\n  border-color: #c0ca33 !important;\n}\n.lime--text.text--darken-1 {\n  color: #c0ca33 !important;\n  caret-color: #c0ca33 !important;\n}\n.lime.darken-2 {\n  background-color: #afb42b !important;\n  border-color: #afb42b !important;\n}\n.lime--text.text--darken-2 {\n  color: #afb42b !important;\n  caret-color: #afb42b !important;\n}\n.lime.darken-3 {\n  background-color: #9e9d24 !important;\n  border-color: #9e9d24 !important;\n}\n.lime--text.text--darken-3 {\n  color: #9e9d24 !important;\n  caret-color: #9e9d24 !important;\n}\n.lime.darken-4 {\n  background-color: #827717 !important;\n  border-color: #827717 !important;\n}\n.lime--text.text--darken-4 {\n  color: #827717 !important;\n  caret-color: #827717 !important;\n}\n.lime.accent-1 {\n  background-color: #f4ff81 !important;\n  border-color: #f4ff81 !important;\n}\n.lime--text.text--accent-1 {\n  color: #f4ff81 !important;\n  caret-color: #f4ff81 !important;\n}\n.lime.accent-2 {\n  background-color: #eeff41 !important;\n  border-color: #eeff41 !important;\n}\n.lime--text.text--accent-2 {\n  color: #eeff41 !important;\n  caret-color: #eeff41 !important;\n}\n.lime.accent-3 {\n  background-color: #c6ff00 !important;\n  border-color: #c6ff00 !important;\n}\n.lime--text.text--accent-3 {\n  color: #c6ff00 !important;\n  caret-color: #c6ff00 !important;\n}\n.lime.accent-4 {\n  background-color: #aeea00 !important;\n  border-color: #aeea00 !important;\n}\n.lime--text.text--accent-4 {\n  color: #aeea00 !important;\n  caret-color: #aeea00 !important;\n}\n.yellow {\n  background-color: #ffeb3b !important;\n  border-color: #ffeb3b !important;\n}\n.yellow--text {\n  color: #ffeb3b !important;\n  caret-color: #ffeb3b !important;\n}\n.yellow.lighten-5 {\n  background-color: #fffde7 !important;\n  border-color: #fffde7 !important;\n}\n.yellow--text.text--lighten-5 {\n  color: #fffde7 !important;\n  caret-color: #fffde7 !important;\n}\n.yellow.lighten-4 {\n  background-color: #fff9c4 !important;\n  border-color: #fff9c4 !important;\n}\n.yellow--text.text--lighten-4 {\n  color: #fff9c4 !important;\n  caret-color: #fff9c4 !important;\n}\n.yellow.lighten-3 {\n  background-color: #fff59d !important;\n  border-color: #fff59d !important;\n}\n.yellow--text.text--lighten-3 {\n  color: #fff59d !important;\n  caret-color: #fff59d !important;\n}\n.yellow.lighten-2 {\n  background-color: #fff176 !important;\n  border-color: #fff176 !important;\n}\n.yellow--text.text--lighten-2 {\n  color: #fff176 !important;\n  caret-color: #fff176 !important;\n}\n.yellow.lighten-1 {\n  background-color: #ffee58 !important;\n  border-color: #ffee58 !important;\n}\n.yellow--text.text--lighten-1 {\n  color: #ffee58 !important;\n  caret-color: #ffee58 !important;\n}\n.yellow.darken-1 {\n  background-color: #fdd835 !important;\n  border-color: #fdd835 !important;\n}\n.yellow--text.text--darken-1 {\n  color: #fdd835 !important;\n  caret-color: #fdd835 !important;\n}\n.yellow.darken-2 {\n  background-color: #fbc02d !important;\n  border-color: #fbc02d !important;\n}\n.yellow--text.text--darken-2 {\n  color: #fbc02d !important;\n  caret-color: #fbc02d !important;\n}\n.yellow.darken-3 {\n  background-color: #f9a825 !important;\n  border-color: #f9a825 !important;\n}\n.yellow--text.text--darken-3 {\n  color: #f9a825 !important;\n  caret-color: #f9a825 !important;\n}\n.yellow.darken-4 {\n  background-color: #f57f17 !important;\n  border-color: #f57f17 !important;\n}\n.yellow--text.text--darken-4 {\n  color: #f57f17 !important;\n  caret-color: #f57f17 !important;\n}\n.yellow.accent-1 {\n  background-color: #ffff8d !important;\n  border-color: #ffff8d !important;\n}\n.yellow--text.text--accent-1 {\n  color: #ffff8d !important;\n  caret-color: #ffff8d !important;\n}\n.yellow.accent-2 {\n  background-color: #ff0 !important;\n  border-color: #ff0 !important;\n}\n.yellow--text.text--accent-2 {\n  color: #ff0 !important;\n  caret-color: #ff0 !important;\n}\n.yellow.accent-3 {\n  background-color: #ffea00 !important;\n  border-color: #ffea00 !important;\n}\n.yellow--text.text--accent-3 {\n  color: #ffea00 !important;\n  caret-color: #ffea00 !important;\n}\n.yellow.accent-4 {\n  background-color: #ffd600 !important;\n  border-color: #ffd600 !important;\n}\n.yellow--text.text--accent-4 {\n  color: #ffd600 !important;\n  caret-color: #ffd600 !important;\n}\n.amber {\n  background-color: #ffc107 !important;\n  border-color: #ffc107 !important;\n}\n.amber--text {\n  color: #ffc107 !important;\n  caret-color: #ffc107 !important;\n}\n.amber.lighten-5 {\n  background-color: #fff8e1 !important;\n  border-color: #fff8e1 !important;\n}\n.amber--text.text--lighten-5 {\n  color: #fff8e1 !important;\n  caret-color: #fff8e1 !important;\n}\n.amber.lighten-4 {\n  background-color: #ffecb3 !important;\n  border-color: #ffecb3 !important;\n}\n.amber--text.text--lighten-4 {\n  color: #ffecb3 !important;\n  caret-color: #ffecb3 !important;\n}\n.amber.lighten-3 {\n  background-color: #ffe082 !important;\n  border-color: #ffe082 !important;\n}\n.amber--text.text--lighten-3 {\n  color: #ffe082 !important;\n  caret-color: #ffe082 !important;\n}\n.amber.lighten-2 {\n  background-color: #ffd54f !important;\n  border-color: #ffd54f !important;\n}\n.amber--text.text--lighten-2 {\n  color: #ffd54f !important;\n  caret-color: #ffd54f !important;\n}\n.amber.lighten-1 {\n  background-color: #ffca28 !important;\n  border-color: #ffca28 !important;\n}\n.amber--text.text--lighten-1 {\n  color: #ffca28 !important;\n  caret-color: #ffca28 !important;\n}\n.amber.darken-1 {\n  background-color: #ffb300 !important;\n  border-color: #ffb300 !important;\n}\n.amber--text.text--darken-1 {\n  color: #ffb300 !important;\n  caret-color: #ffb300 !important;\n}\n.amber.darken-2 {\n  background-color: #ffa000 !important;\n  border-color: #ffa000 !important;\n}\n.amber--text.text--darken-2 {\n  color: #ffa000 !important;\n  caret-color: #ffa000 !important;\n}\n.amber.darken-3 {\n  background-color: #ff8f00 !important;\n  border-color: #ff8f00 !important;\n}\n.amber--text.text--darken-3 {\n  color: #ff8f00 !important;\n  caret-color: #ff8f00 !important;\n}\n.amber.darken-4 {\n  background-color: #ff6f00 !important;\n  border-color: #ff6f00 !important;\n}\n.amber--text.text--darken-4 {\n  color: #ff6f00 !important;\n  caret-color: #ff6f00 !important;\n}\n.amber.accent-1 {\n  background-color: #ffe57f !important;\n  border-color: #ffe57f !important;\n}\n.amber--text.text--accent-1 {\n  color: #ffe57f !important;\n  caret-color: #ffe57f !important;\n}\n.amber.accent-2 {\n  background-color: #ffd740 !important;\n  border-color: #ffd740 !important;\n}\n.amber--text.text--accent-2 {\n  color: #ffd740 !important;\n  caret-color: #ffd740 !important;\n}\n.amber.accent-3 {\n  background-color: #ffc400 !important;\n  border-color: #ffc400 !important;\n}\n.amber--text.text--accent-3 {\n  color: #ffc400 !important;\n  caret-color: #ffc400 !important;\n}\n.amber.accent-4 {\n  background-color: #ffab00 !important;\n  border-color: #ffab00 !important;\n}\n.amber--text.text--accent-4 {\n  color: #ffab00 !important;\n  caret-color: #ffab00 !important;\n}\n.orange {\n  background-color: #ff9800 !important;\n  border-color: #ff9800 !important;\n}\n.orange--text {\n  color: #ff9800 !important;\n  caret-color: #ff9800 !important;\n}\n.orange.lighten-5 {\n  background-color: #fff3e0 !important;\n  border-color: #fff3e0 !important;\n}\n.orange--text.text--lighten-5 {\n  color: #fff3e0 !important;\n  caret-color: #fff3e0 !important;\n}\n.orange.lighten-4 {\n  background-color: #ffe0b2 !important;\n  border-color: #ffe0b2 !important;\n}\n.orange--text.text--lighten-4 {\n  color: #ffe0b2 !important;\n  caret-color: #ffe0b2 !important;\n}\n.orange.lighten-3 {\n  background-color: #ffcc80 !important;\n  border-color: #ffcc80 !important;\n}\n.orange--text.text--lighten-3 {\n  color: #ffcc80 !important;\n  caret-color: #ffcc80 !important;\n}\n.orange.lighten-2 {\n  background-color: #ffb74d !important;\n  border-color: #ffb74d !important;\n}\n.orange--text.text--lighten-2 {\n  color: #ffb74d !important;\n  caret-color: #ffb74d !important;\n}\n.orange.lighten-1 {\n  background-color: #ffa726 !important;\n  border-color: #ffa726 !important;\n}\n.orange--text.text--lighten-1 {\n  color: #ffa726 !important;\n  caret-color: #ffa726 !important;\n}\n.orange.darken-1 {\n  background-color: #fb8c00 !important;\n  border-color: #fb8c00 !important;\n}\n.orange--text.text--darken-1 {\n  color: #fb8c00 !important;\n  caret-color: #fb8c00 !important;\n}\n.orange.darken-2 {\n  background-color: #f57c00 !important;\n  border-color: #f57c00 !important;\n}\n.orange--text.text--darken-2 {\n  color: #f57c00 !important;\n  caret-color: #f57c00 !important;\n}\n.orange.darken-3 {\n  background-color: #ef6c00 !important;\n  border-color: #ef6c00 !important;\n}\n.orange--text.text--darken-3 {\n  color: #ef6c00 !important;\n  caret-color: #ef6c00 !important;\n}\n.orange.darken-4 {\n  background-color: #e65100 !important;\n  border-color: #e65100 !important;\n}\n.orange--text.text--darken-4 {\n  color: #e65100 !important;\n  caret-color: #e65100 !important;\n}\n.orange.accent-1 {\n  background-color: #ffd180 !important;\n  border-color: #ffd180 !important;\n}\n.orange--text.text--accent-1 {\n  color: #ffd180 !important;\n  caret-color: #ffd180 !important;\n}\n.orange.accent-2 {\n  background-color: #ffab40 !important;\n  border-color: #ffab40 !important;\n}\n.orange--text.text--accent-2 {\n  color: #ffab40 !important;\n  caret-color: #ffab40 !important;\n}\n.orange.accent-3 {\n  background-color: #ff9100 !important;\n  border-color: #ff9100 !important;\n}\n.orange--text.text--accent-3 {\n  color: #ff9100 !important;\n  caret-color: #ff9100 !important;\n}\n.orange.accent-4 {\n  background-color: #ff6d00 !important;\n  border-color: #ff6d00 !important;\n}\n.orange--text.text--accent-4 {\n  color: #ff6d00 !important;\n  caret-color: #ff6d00 !important;\n}\n.deep-orange {\n  background-color: #ff5722 !important;\n  border-color: #ff5722 !important;\n}\n.deep-orange--text {\n  color: #ff5722 !important;\n  caret-color: #ff5722 !important;\n}\n.deep-orange.lighten-5 {\n  background-color: #fbe9e7 !important;\n  border-color: #fbe9e7 !important;\n}\n.deep-orange--text.text--lighten-5 {\n  color: #fbe9e7 !important;\n  caret-color: #fbe9e7 !important;\n}\n.deep-orange.lighten-4 {\n  background-color: #ffccbc !important;\n  border-color: #ffccbc !important;\n}\n.deep-orange--text.text--lighten-4 {\n  color: #ffccbc !important;\n  caret-color: #ffccbc !important;\n}\n.deep-orange.lighten-3 {\n  background-color: #ffab91 !important;\n  border-color: #ffab91 !important;\n}\n.deep-orange--text.text--lighten-3 {\n  color: #ffab91 !important;\n  caret-color: #ffab91 !important;\n}\n.deep-orange.lighten-2 {\n  background-color: #ff8a65 !important;\n  border-color: #ff8a65 !important;\n}\n.deep-orange--text.text--lighten-2 {\n  color: #ff8a65 !important;\n  caret-color: #ff8a65 !important;\n}\n.deep-orange.lighten-1 {\n  background-color: #ff7043 !important;\n  border-color: #ff7043 !important;\n}\n.deep-orange--text.text--lighten-1 {\n  color: #ff7043 !important;\n  caret-color: #ff7043 !important;\n}\n.deep-orange.darken-1 {\n  background-color: #f4511e !important;\n  border-color: #f4511e !important;\n}\n.deep-orange--text.text--darken-1 {\n  color: #f4511e !important;\n  caret-color: #f4511e !important;\n}\n.deep-orange.darken-2 {\n  background-color: #e64a19 !important;\n  border-color: #e64a19 !important;\n}\n.deep-orange--text.text--darken-2 {\n  color: #e64a19 !important;\n  caret-color: #e64a19 !important;\n}\n.deep-orange.darken-3 {\n  background-color: #d84315 !important;\n  border-color: #d84315 !important;\n}\n.deep-orange--text.text--darken-3 {\n  color: #d84315 !important;\n  caret-color: #d84315 !important;\n}\n.deep-orange.darken-4 {\n  background-color: #bf360c !important;\n  border-color: #bf360c !important;\n}\n.deep-orange--text.text--darken-4 {\n  color: #bf360c !important;\n  caret-color: #bf360c !important;\n}\n.deep-orange.accent-1 {\n  background-color: #ff9e80 !important;\n  border-color: #ff9e80 !important;\n}\n.deep-orange--text.text--accent-1 {\n  color: #ff9e80 !important;\n  caret-color: #ff9e80 !important;\n}\n.deep-orange.accent-2 {\n  background-color: #ff6e40 !important;\n  border-color: #ff6e40 !important;\n}\n.deep-orange--text.text--accent-2 {\n  color: #ff6e40 !important;\n  caret-color: #ff6e40 !important;\n}\n.deep-orange.accent-3 {\n  background-color: #ff3d00 !important;\n  border-color: #ff3d00 !important;\n}\n.deep-orange--text.text--accent-3 {\n  color: #ff3d00 !important;\n  caret-color: #ff3d00 !important;\n}\n.deep-orange.accent-4 {\n  background-color: #dd2c00 !important;\n  border-color: #dd2c00 !important;\n}\n.deep-orange--text.text--accent-4 {\n  color: #dd2c00 !important;\n  caret-color: #dd2c00 !important;\n}\n.brown {\n  background-color: #795548 !important;\n  border-color: #795548 !important;\n}\n.brown--text {\n  color: #795548 !important;\n  caret-color: #795548 !important;\n}\n.brown.lighten-5 {\n  background-color: #efebe9 !important;\n  border-color: #efebe9 !important;\n}\n.brown--text.text--lighten-5 {\n  color: #efebe9 !important;\n  caret-color: #efebe9 !important;\n}\n.brown.lighten-4 {\n  background-color: #d7ccc8 !important;\n  border-color: #d7ccc8 !important;\n}\n.brown--text.text--lighten-4 {\n  color: #d7ccc8 !important;\n  caret-color: #d7ccc8 !important;\n}\n.brown.lighten-3 {\n  background-color: #bcaaa4 !important;\n  border-color: #bcaaa4 !important;\n}\n.brown--text.text--lighten-3 {\n  color: #bcaaa4 !important;\n  caret-color: #bcaaa4 !important;\n}\n.brown.lighten-2 {\n  background-color: #a1887f !important;\n  border-color: #a1887f !important;\n}\n.brown--text.text--lighten-2 {\n  color: #a1887f !important;\n  caret-color: #a1887f !important;\n}\n.brown.lighten-1 {\n  background-color: #8d6e63 !important;\n  border-color: #8d6e63 !important;\n}\n.brown--text.text--lighten-1 {\n  color: #8d6e63 !important;\n  caret-color: #8d6e63 !important;\n}\n.brown.darken-1 {\n  background-color: #6d4c41 !important;\n  border-color: #6d4c41 !important;\n}\n.brown--text.text--darken-1 {\n  color: #6d4c41 !important;\n  caret-color: #6d4c41 !important;\n}\n.brown.darken-2 {\n  background-color: #5d4037 !important;\n  border-color: #5d4037 !important;\n}\n.brown--text.text--darken-2 {\n  color: #5d4037 !important;\n  caret-color: #5d4037 !important;\n}\n.brown.darken-3 {\n  background-color: #4e342e !important;\n  border-color: #4e342e !important;\n}\n.brown--text.text--darken-3 {\n  color: #4e342e !important;\n  caret-color: #4e342e !important;\n}\n.brown.darken-4 {\n  background-color: #3e2723 !important;\n  border-color: #3e2723 !important;\n}\n.brown--text.text--darken-4 {\n  color: #3e2723 !important;\n  caret-color: #3e2723 !important;\n}\n.blue-grey {\n  background-color: #607d8b !important;\n  border-color: #607d8b !important;\n}\n.blue-grey--text {\n  color: #607d8b !important;\n  caret-color: #607d8b !important;\n}\n.blue-grey.lighten-5 {\n  background-color: #eceff1 !important;\n  border-color: #eceff1 !important;\n}\n.blue-grey--text.text--lighten-5 {\n  color: #eceff1 !important;\n  caret-color: #eceff1 !important;\n}\n.blue-grey.lighten-4 {\n  background-color: #cfd8dc !important;\n  border-color: #cfd8dc !important;\n}\n.blue-grey--text.text--lighten-4 {\n  color: #cfd8dc !important;\n  caret-color: #cfd8dc !important;\n}\n.blue-grey.lighten-3 {\n  background-color: #b0bec5 !important;\n  border-color: #b0bec5 !important;\n}\n.blue-grey--text.text--lighten-3 {\n  color: #b0bec5 !important;\n  caret-color: #b0bec5 !important;\n}\n.blue-grey.lighten-2 {\n  background-color: #90a4ae !important;\n  border-color: #90a4ae !important;\n}\n.blue-grey--text.text--lighten-2 {\n  color: #90a4ae !important;\n  caret-color: #90a4ae !important;\n}\n.blue-grey.lighten-1 {\n  background-color: #78909c !important;\n  border-color: #78909c !important;\n}\n.blue-grey--text.text--lighten-1 {\n  color: #78909c !important;\n  caret-color: #78909c !important;\n}\n.blue-grey.darken-1 {\n  background-color: #546e7a !important;\n  border-color: #546e7a !important;\n}\n.blue-grey--text.text--darken-1 {\n  color: #546e7a !important;\n  caret-color: #546e7a !important;\n}\n.blue-grey.darken-2 {\n  background-color: #455a64 !important;\n  border-color: #455a64 !important;\n}\n.blue-grey--text.text--darken-2 {\n  color: #455a64 !important;\n  caret-color: #455a64 !important;\n}\n.blue-grey.darken-3 {\n  background-color: #37474f !important;\n  border-color: #37474f !important;\n}\n.blue-grey--text.text--darken-3 {\n  color: #37474f !important;\n  caret-color: #37474f !important;\n}\n.blue-grey.darken-4 {\n  background-color: #263238 !important;\n  border-color: #263238 !important;\n}\n.blue-grey--text.text--darken-4 {\n  color: #263238 !important;\n  caret-color: #263238 !important;\n}\n.grey {\n  background-color: #9e9e9e !important;\n  border-color: #9e9e9e !important;\n}\n.grey--text {\n  color: #9e9e9e !important;\n  caret-color: #9e9e9e !important;\n}\n.grey.lighten-5 {\n  background-color: #fafafa !important;\n  border-color: #fafafa !important;\n}\n.grey--text.text--lighten-5 {\n  color: #fafafa !important;\n  caret-color: #fafafa !important;\n}\n.grey.lighten-4 {\n  background-color: #f5f5f5 !important;\n  border-color: #f5f5f5 !important;\n}\n.grey--text.text--lighten-4 {\n  color: #f5f5f5 !important;\n  caret-color: #f5f5f5 !important;\n}\n.grey.lighten-3 {\n  background-color: #eee !important;\n  border-color: #eee !important;\n}\n.grey--text.text--lighten-3 {\n  color: #eee !important;\n  caret-color: #eee !important;\n}\n.grey.lighten-2 {\n  background-color: #e0e0e0 !important;\n  border-color: #e0e0e0 !important;\n}\n.grey--text.text--lighten-2 {\n  color: #e0e0e0 !important;\n  caret-color: #e0e0e0 !important;\n}\n.grey.lighten-1 {\n  background-color: #bdbdbd !important;\n  border-color: #bdbdbd !important;\n}\n.grey--text.text--lighten-1 {\n  color: #bdbdbd !important;\n  caret-color: #bdbdbd !important;\n}\n.grey.darken-1 {\n  background-color: #757575 !important;\n  border-color: #757575 !important;\n}\n.grey--text.text--darken-1 {\n  color: #757575 !important;\n  caret-color: #757575 !important;\n}\n.grey.darken-2 {\n  background-color: #616161 !important;\n  border-color: #616161 !important;\n}\n.grey--text.text--darken-2 {\n  color: #616161 !important;\n  caret-color: #616161 !important;\n}\n.grey.darken-3 {\n  background-color: #424242 !important;\n  border-color: #424242 !important;\n}\n.grey--text.text--darken-3 {\n  color: #424242 !important;\n  caret-color: #424242 !important;\n}\n.grey.darken-4 {\n  background-color: #212121 !important;\n  border-color: #212121 !important;\n}\n.grey--text.text--darken-4 {\n  color: #212121 !important;\n  caret-color: #212121 !important;\n}\n.shades.black {\n  background-color: #000 !important;\n  border-color: #000 !important;\n}\n.shades--text.text--black {\n  color: #000 !important;\n  caret-color: #000 !important;\n}\n.shades.white {\n  background-color: #fff !important;\n  border-color: #fff !important;\n}\n.shades--text.text--white {\n  color: #fff !important;\n  caret-color: #fff !important;\n}\n.shades.transparent {\n  background-color: transparent !important;\n  border-color: transparent !important;\n}\n.shades--text.text--transparent {\n  color: transparent !important;\n  caret-color: transparent !important;\n}\n.elevation-0 {\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-1 {\n  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-2 {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-3 {\n  box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-4 {\n  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-5 {\n  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-6 {\n  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-7 {\n  box-shadow: 0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12) !important;\n}\n.elevation-8 {\n  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12) !important;\n}\n.elevation-9 {\n  box-shadow: 0px 5px 6px -3px rgba(0,0,0,0.2), 0px 9px 12px 1px rgba(0,0,0,0.14), 0px 3px 16px 2px rgba(0,0,0,0.12) !important;\n}\n.elevation-10 {\n  box-shadow: 0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12) !important;\n}\n.elevation-11 {\n  box-shadow: 0px 6px 7px -4px rgba(0,0,0,0.2), 0px 11px 15px 1px rgba(0,0,0,0.14), 0px 4px 20px 3px rgba(0,0,0,0.12) !important;\n}\n.elevation-12 {\n  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12) !important;\n}\n.elevation-13 {\n  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 13px 19px 2px rgba(0,0,0,0.14), 0px 5px 24px 4px rgba(0,0,0,0.12) !important;\n}\n.elevation-14 {\n  box-shadow: 0px 7px 9px -4px rgba(0,0,0,0.2), 0px 14px 21px 2px rgba(0,0,0,0.14), 0px 5px 26px 4px rgba(0,0,0,0.12) !important;\n}\n.elevation-15 {\n  box-shadow: 0px 8px 9px -5px rgba(0,0,0,0.2), 0px 15px 22px 2px rgba(0,0,0,0.14), 0px 6px 28px 5px rgba(0,0,0,0.12) !important;\n}\n.elevation-16 {\n  box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12) !important;\n}\n.elevation-17 {\n  box-shadow: 0px 8px 11px -5px rgba(0,0,0,0.2), 0px 17px 26px 2px rgba(0,0,0,0.14), 0px 6px 32px 5px rgba(0,0,0,0.12) !important;\n}\n.elevation-18 {\n  box-shadow: 0px 9px 11px -5px rgba(0,0,0,0.2), 0px 18px 28px 2px rgba(0,0,0,0.14), 0px 7px 34px 6px rgba(0,0,0,0.12) !important;\n}\n.elevation-19 {\n  box-shadow: 0px 9px 12px -6px rgba(0,0,0,0.2), 0px 19px 29px 2px rgba(0,0,0,0.14), 0px 7px 36px 6px rgba(0,0,0,0.12) !important;\n}\n.elevation-20 {\n  box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 20px 31px 3px rgba(0,0,0,0.14), 0px 8px 38px 7px rgba(0,0,0,0.12) !important;\n}\n.elevation-21 {\n  box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 21px 33px 3px rgba(0,0,0,0.14), 0px 8px 40px 7px rgba(0,0,0,0.12) !important;\n}\n.elevation-22 {\n  box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.2), 0px 22px 35px 3px rgba(0,0,0,0.14), 0px 8px 42px 7px rgba(0,0,0,0.12) !important;\n}\n.elevation-23 {\n  box-shadow: 0px 11px 14px -7px rgba(0,0,0,0.2), 0px 23px 36px 3px rgba(0,0,0,0.14), 0px 9px 44px 8px rgba(0,0,0,0.12) !important;\n}\n.elevation-24 {\n  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12) !important;\n}\nhtml {\n  box-sizing: border-box;\n  overflow-y: scroll; /* All browsers without overlaying scrollbars */\n  -webkit-text-size-adjust: 100%; /* iOS 8+ */\n}\n*,\n::before,\n::after {\n  box-sizing: inherit;\n}\n::before,\n::after {\n  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */\n  vertical-align: inherit;\n}\n* {\n  background-repeat: no-repeat; /* Set `background-repeat: no-repeat` to all elements */\n  padding: 0; /* Reset `padding` and `margin` of all elements */\n  margin: 0;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\nhr {\n  overflow: visible; /* Show the overflow in Edge and IE */\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\nsummary {\n  display: list-item; /* Add the correct display in all browsers */\n}\nsmall {\n  font-size: 80%; /* Set font-size to 80% in `small` elements */\n}\n[hidden],\ntemplate {\n  display: none; /* Add the correct display in IE */\n}\nabbr[title] {\n  border-bottom: 1px dotted; /* Add a bordered underline effect in all browsers */\n  text-decoration: none; /* Remove text decoration in Firefox 40+ */\n}\na {\n  background-color: transparent; /* Remove the gray background on active links in IE 10 */\n  -webkit-text-decoration-skip: objects; /* Remove gaps in links underline in iOS 8+ and Safari 8+ */\n}\na:active,\na:hover {\n  outline-width: 0; /* Remove the outline when hovering in all browsers */\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* Specify the font family of code elements */\n}\nb,\nstrong {\n  font-weight: bolder; /* Correct style set to `bold` in Edge 12+, Safari 6.2+, and Chrome 18+ */\n}\ndfn {\n  font-style: italic; /* Address styling not present in Safari and Chrome */\n}\nmark {\n  background-color: #ff0;\n  color: #000;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\ninput {\n  border-radius: 0;\n}\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"],\n[role=\"button\"] {\n  cursor: pointer;\n}\n[disabled] {\n  cursor: default;\n}\n[type=\"number\"] {\n  width: auto; /* Firefox 36+ */\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* Safari 8+ */\n}\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; /* Safari 8 */\n}\ntextarea {\n  overflow: auto; /* Internet Explorer 11+ */\n  resize: vertical; /* Specify textarea resizability */\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* Specify font inheritance of form elements */\n}\noptgroup {\n  font-weight: bold; /* Restore the font weight unset by the previous rule. */\n}\nbutton {\n  overflow: visible; /* Address `overflow` set to `hidden` in IE 8/9/10/11 */\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: 0;\n  padding: 0;\n}\nbutton:-moz-focusring,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  outline: 0;\n  border: 0;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */\n}\nbutton,\nselect {\n  text-transform: none; /* Firefox 40+, Internet Explorer 11- */\n}\nbutton,\ninput,\nselect,\ntextarea {\n  background-color: transparent;\n  border-style: none;\n  color: inherit;\n}\nselect {\n  -moz-appearance: none; /* Firefox 36+ */\n  -webkit-appearance: none; /* Chrome 41+ */\n}\nselect::-ms-expand {\n  display: none; /* Internet Explorer 11+ */\n}\nselect::-ms-value {\n  color: currentColor; /* Internet Explorer 11+ */\n}\nlegend {\n  border: 0; /* Correct `color` not being inherited in IE 8/9/10/11 */\n  color: inherit; /* Correct the color inheritance from `fieldset` elements in IE */\n  display: table; /* Correct the text wrapping in Edge and IE */\n  max-width: 100%; /* Correct the text wrapping in Edge and IE */\n  white-space: normal; /* Correct the text wrapping in Edge and IE */\n}\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS and Safari */\n  font: inherit; /* Change font properties to `inherit` in Chrome and Safari */\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */\n  outline-offset: -2px; /* Correct the outline style in Safari */\n}\nimg {\n  border-style: none; /* Remove border when inside `a` element in IE 8/9/10 */\n}\nprogress {\n  vertical-align: baseline;\n}\nsvg:not(:root) {\n  overflow: hidden; /* Internet Explorer 11- */\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; /* Internet Explorer 11+, Windows Phone 8.1+ */\n}\n@media screen {\n  [hidden~=\"screen\"] {\n    display: inherit;\n  }\n  [hidden~=\"screen\"]:not(:active):not(:focus):not(:target) {\n    position: absolute !important;\n    clip: rect(0 0 0 0) !important;\n  }\n}\n[aria-busy=\"true\"] {\n  cursor: progress;\n}\n[aria-controls] {\n  cursor: pointer;\n}\n[aria-disabled] {\n  cursor: default;\n}\n::-moz-selection {\n  background-color: #b3d4fc; /* Required when declaring ::selection */\n  color: #000;\n  text-shadow: none;\n}\n::selection {\n  background-color: #b3d4fc; /* Required when declaring ::selection */\n  color: #000;\n  text-shadow: none;\n}\n.bottom-sheet-transition-enter {\n  transform: translateY(100%);\n}\n.bottom-sheet-transition-leave-to {\n  transform: translateY(100%);\n}\n.carousel-transition-enter {\n  transform: translate(100%, 0);\n}\n.carousel-transition-leave,\n.carousel-transition-leave-to {\n  position: absolute;\n  top: 0;\n  transform: translate(-100%, 0);\n}\n.carousel-reverse-transition-enter {\n  transform: translate(-100%, 0);\n}\n.carousel-reverse-transition-leave,\n.carousel-reverse-transition-leave-to {\n  position: absolute;\n  top: 0;\n  transform: translate(100%, 0);\n}\n.dialog-transition-enter,\n.dialog-transition-leave-to {\n  transform: scale(0.5);\n  opacity: 0;\n}\n.dialog-transition-enter-to,\n.dialog-transition-leave {\n  opacity: 1;\n}\n.dialog-bottom-transition-enter,\n.dialog-bottom-transition-leave-to {\n  transform: translateY(100%);\n}\n.picker-transition-enter-active,\n.picker-reverse-transition-enter-active,\n.picker-transition-leave-active,\n.picker-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n.picker-transition-enter,\n.picker-reverse-transition-enter,\n.picker-transition-leave-to,\n.picker-reverse-transition-leave-to {\n  opacity: 0;\n}\n.picker-transition-leave,\n.picker-reverse-transition-leave,\n.picker-transition-leave-active,\n.picker-reverse-transition-leave-active,\n.picker-transition-leave-to,\n.picker-reverse-transition-leave-to {\n  position: absolute !important;\n}\n.picker-transition-enter {\n  transform: translate(0, 100%);\n}\n.picker-transition-leave-to {\n  transform: translate(0, -100%);\n}\n.picker-reverse-transition-enter {\n  transform: translate(0, -100%);\n}\n.picker-reverse-transition-leave-to {\n  transform: translate(0, 100%);\n}\n.picker-title-transition-enter-to,\n.picker-title-transition-leave {\n  transform: translate(0, 0);\n}\n.picker-title-transition-enter {\n  transform: translate(-100%, 0);\n}\n.picker-title-transition-leave-to {\n  opacity: 0;\n  transform: translate(100%, 0);\n}\n.picker-title-transition-leave,\n.picker-title-transition-leave-to,\n.picker-title-transition-leave-active {\n  position: absolute !important;\n}\n.tab-transition-enter {\n  transform: translate(100%, 0);\n}\n.tab-transition-leave,\n.tab-transition-leave-active {\n  position: absolute;\n  top: 0;\n}\n.tab-transition-leave-to {\n  position: absolute;\n  transform: translate(-100%, 0);\n}\n.tab-reverse-transition-enter {\n  transform: translate(-100%, 0);\n}\n.tab-reverse-transition-leave,\n.tab-reverse-transition-leave-to {\n  top: 0;\n  position: absolute;\n  transform: translate(100%, 0);\n}\n.expand-transition-enter-active,\n.expand-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.expand-transition-move {\n  transition: transform 0.6s;\n}\n.expand-x-transition-enter-active,\n.expand-x-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.expand-x-transition-move {\n  transition: transform 0.6s;\n}\n.scale-transition-enter-active,\n.scale-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scale-transition-move {\n  transition: transform 0.6s;\n}\n.scale-transition-enter,\n.scale-transition-leave,\n.scale-transition-leave-to {\n  opacity: 0;\n  transform: scale(0);\n}\n.message-transition-enter-active,\n.message-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.message-transition-move {\n  transition: transform 0.6s;\n}\n.message-transition-enter,\n.message-transition-leave-to {\n  opacity: 0;\n  transform: translateY(-15px);\n}\n.message-transition-leave,\n.message-transition-leave-active {\n  position: absolute;\n}\n.slide-y-transition-enter-active,\n.slide-y-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-y-transition-move {\n  transition: transform 0.6s;\n}\n.slide-y-transition-enter,\n.slide-y-transition-leave-to {\n  opacity: 0;\n  transform: translateY(-15px);\n}\n.slide-y-reverse-transition-enter-active,\n.slide-y-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-y-reverse-transition-move {\n  transition: transform 0.6s;\n}\n.slide-y-reverse-transition-enter,\n.slide-y-reverse-transition-leave-to {\n  opacity: 0;\n  transform: translateY(15px);\n}\n.scroll-y-transition-enter-active,\n.scroll-y-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-y-transition-move {\n  transition: transform 0.6s;\n}\n.scroll-y-transition-enter,\n.scroll-y-transition-leave-to {\n  opacity: 0;\n}\n.scroll-y-transition-enter {\n  transform: translateY(-15px);\n}\n.scroll-y-transition-leave-to {\n  transform: translateY(15px);\n}\n.scroll-y-reverse-transition-enter-active,\n.scroll-y-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-y-reverse-transition-move {\n  transition: transform 0.6s;\n}\n.scroll-y-reverse-transition-enter,\n.scroll-y-reverse-transition-leave-to {\n  opacity: 0;\n}\n.scroll-y-reverse-transition-enter {\n  transform: translateY(15px);\n}\n.scroll-y-reverse-transition-leave-to {\n  transform: translateY(-15px);\n}\n.scroll-x-transition-enter-active,\n.scroll-x-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-x-transition-move {\n  transition: transform 0.6s;\n}\n.scroll-x-transition-enter,\n.scroll-x-transition-leave-to {\n  opacity: 0;\n}\n.scroll-x-transition-enter {\n  transform: translateX(-15px);\n}\n.scroll-x-transition-leave-to {\n  transform: translateX(15px);\n}\n.scroll-x-reverse-transition-enter-active,\n.scroll-x-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-x-reverse-transition-move {\n  transition: transform 0.6s;\n}\n.scroll-x-reverse-transition-enter,\n.scroll-x-reverse-transition-leave-to {\n  opacity: 0;\n}\n.scroll-x-reverse-transition-enter {\n  transform: translateX(15px);\n}\n.scroll-x-reverse-transition-leave-to {\n  transform: translateX(-15px);\n}\n.slide-x-transition-enter-active,\n.slide-x-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-x-transition-move {\n  transition: transform 0.6s;\n}\n.slide-x-transition-enter,\n.slide-x-transition-leave-to {\n  opacity: 0;\n  transform: translateX(-15px);\n}\n.slide-x-reverse-transition-enter-active,\n.slide-x-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-x-reverse-transition-move {\n  transition: transform 0.6s;\n}\n.slide-x-reverse-transition-enter,\n.slide-x-reverse-transition-leave-to {\n  opacity: 0;\n  transform: translateX(15px);\n}\n.fade-transition-enter-active,\n.fade-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.fade-transition-move {\n  transition: transform 0.6s;\n}\n.fade-transition-enter,\n.fade-transition-leave-to {\n  opacity: 0;\n}\n.fab-transition-enter-active,\n.fab-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.fab-transition-move {\n  transition: transform 0.6s;\n}\n.fab-transition-enter,\n.fab-transition-leave-to {\n  transform: scale(0) rotate(-45deg);\n}\n.blockquote {\n  padding: 16px 0 16px 24px;\n  font-size: 18px;\n  font-weight: 300;\n}\ncode,\nkbd {\n  display: inline-block;\n  border-radius: 3px;\n  white-space: pre-wrap;\n  font-size: 85%;\n  font-weight: 900;\n}\ncode:after,\nkbd:after,\ncode:before,\nkbd:before {\n  content: \"\\00a0\";\n  letter-spacing: -1px;\n}\ncode {\n  background-color: #f5f5f5;\n  color: #bd4147;\n  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);\n}\nkbd {\n  background: #616161;\n  color: #fff;\n}\nhtml {\n  font-size: 14px;\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n.application {\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.5;\n}\n::-ms-clear,\n::-ms-reveal {\n  display: none;\n}\nul,\nol {\n  padding-left: 24px;\n}\n.display-4 {\n  font-size: 112px !important;\n  font-weight: 300;\n  line-height: 1 !important;\n  letter-spacing: -0.04em !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.display-3 {\n  font-size: 56px !important;\n  font-weight: 400;\n  line-height: 1.35 !important;\n  letter-spacing: -0.02em !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.display-2 {\n  font-size: 45px !important;\n  font-weight: 400;\n  line-height: 48px !important;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.display-1 {\n  font-size: 34px !important;\n  font-weight: 400;\n  line-height: 40px !important;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.headline {\n  font-size: 24px !important;\n  font-weight: 400;\n  line-height: 32px !important;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.title {\n  font-size: 20px !important;\n  font-weight: 500;\n  line-height: 1 !important;\n  letter-spacing: 0.02em !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.subheading {\n  font-size: 16px !important;\n  font-weight: 400;\n}\n.body-2 {\n  font-size: 14px !important;\n  font-weight: 500;\n}\n.body-1 {\n  font-size: 14px !important;\n  font-weight: 400;\n}\n.caption {\n  font-size: 12px !important;\n  font-weight: 400;\n}\np {\n  margin-bottom: 16px;\n}\n@media only print {\n  .hidden-print-only {\n    display: none !important;\n  }\n}\n@media only screen {\n  .hidden-screen-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 599px) {\n  .hidden-xs-only {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 600px) and (max-width: 959px) {\n  .hidden-sm-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 959px) {\n  .hidden-sm-and-down {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 600px) {\n  .hidden-sm-and-up {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 960px) and (max-width: 1263px) {\n  .hidden-md-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1263px) {\n  .hidden-md-and-down {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 960px) {\n  .hidden-md-and-up {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 1264px) and (max-width: 1903px) {\n  .hidden-lg-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1903px) {\n  .hidden-lg-and-down {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 1264px) {\n  .hidden-lg-and-up {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 1904px) {\n  .hidden-xl-only {\n    display: none !important;\n  }\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n.overflow-y-hidden {\n  overflow-y: hidden;\n}\n.right {\n  float: right !important;\n}\n.left {\n  float: left !important;\n}\n.ma-auto {\n  margin-top: auto !important;\n  margin-right: auto !important;\n  margin-bottom: auto !important;\n  margin-left: auto !important;\n}\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n.mx-auto {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n.mt-auto {\n  margin-top: auto !important;\n}\n.mr-auto {\n  margin-right: auto !important;\n}\n.mb-auto {\n  margin-bottom: auto !important;\n}\n.ml-auto {\n  margin-left: auto !important;\n}\n.ma-0 {\n  margin: 0 0 !important;\n}\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.pa-0 {\n  padding: 0 0 !important;\n}\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.ma-1 {\n  margin: 4px 4px !important;\n}\n.my-1 {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n.mx-1 {\n  margin-left: 4px !important;\n  margin-right: 4px !important;\n}\n.mt-1 {\n  margin-top: 4px !important;\n}\n.mr-1 {\n  margin-right: 4px !important;\n}\n.mb-1 {\n  margin-bottom: 4px !important;\n}\n.ml-1 {\n  margin-left: 4px !important;\n}\n.pa-1 {\n  padding: 4px 4px !important;\n}\n.py-1 {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n.px-1 {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n.pt-1 {\n  padding-top: 4px !important;\n}\n.pr-1 {\n  padding-right: 4px !important;\n}\n.pb-1 {\n  padding-bottom: 4px !important;\n}\n.pl-1 {\n  padding-left: 4px !important;\n}\n.ma-2 {\n  margin: 8px 8px !important;\n}\n.my-2 {\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n}\n.mx-2 {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n}\n.mt-2 {\n  margin-top: 8px !important;\n}\n.mr-2 {\n  margin-right: 8px !important;\n}\n.mb-2 {\n  margin-bottom: 8px !important;\n}\n.ml-2 {\n  margin-left: 8px !important;\n}\n.pa-2 {\n  padding: 8px 8px !important;\n}\n.py-2 {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.px-2 {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n.pt-2 {\n  padding-top: 8px !important;\n}\n.pr-2 {\n  padding-right: 8px !important;\n}\n.pb-2 {\n  padding-bottom: 8px !important;\n}\n.pl-2 {\n  padding-left: 8px !important;\n}\n.ma-3 {\n  margin: 16px 16px !important;\n}\n.my-3 {\n  margin-top: 16px !important;\n  margin-bottom: 16px !important;\n}\n.mx-3 {\n  margin-left: 16px !important;\n  margin-right: 16px !important;\n}\n.mt-3 {\n  margin-top: 16px !important;\n}\n.mr-3 {\n  margin-right: 16px !important;\n}\n.mb-3 {\n  margin-bottom: 16px !important;\n}\n.ml-3 {\n  margin-left: 16px !important;\n}\n.pa-3 {\n  padding: 16px 16px !important;\n}\n.py-3 {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n.px-3 {\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n.pt-3 {\n  padding-top: 16px !important;\n}\n.pr-3 {\n  padding-right: 16px !important;\n}\n.pb-3 {\n  padding-bottom: 16px !important;\n}\n.pl-3 {\n  padding-left: 16px !important;\n}\n.ma-4 {\n  margin: 24px 24px !important;\n}\n.my-4 {\n  margin-top: 24px !important;\n  margin-bottom: 24px !important;\n}\n.mx-4 {\n  margin-left: 24px !important;\n  margin-right: 24px !important;\n}\n.mt-4 {\n  margin-top: 24px !important;\n}\n.mr-4 {\n  margin-right: 24px !important;\n}\n.mb-4 {\n  margin-bottom: 24px !important;\n}\n.ml-4 {\n  margin-left: 24px !important;\n}\n.pa-4 {\n  padding: 24px 24px !important;\n}\n.py-4 {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n.px-4 {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.pt-4 {\n  padding-top: 24px !important;\n}\n.pr-4 {\n  padding-right: 24px !important;\n}\n.pb-4 {\n  padding-bottom: 24px !important;\n}\n.pl-4 {\n  padding-left: 24px !important;\n}\n.ma-5 {\n  margin: 48px 48px !important;\n}\n.my-5 {\n  margin-top: 48px !important;\n  margin-bottom: 48px !important;\n}\n.mx-5 {\n  margin-left: 48px !important;\n  margin-right: 48px !important;\n}\n.mt-5 {\n  margin-top: 48px !important;\n}\n.mr-5 {\n  margin-right: 48px !important;\n}\n.mb-5 {\n  margin-bottom: 48px !important;\n}\n.ml-5 {\n  margin-left: 48px !important;\n}\n.pa-5 {\n  padding: 48px 48px !important;\n}\n.py-5 {\n  padding-top: 48px !important;\n  padding-bottom: 48px !important;\n}\n.px-5 {\n  padding-left: 48px !important;\n  padding-right: 48px !important;\n}\n.pt-5 {\n  padding-top: 48px !important;\n}\n.pr-5 {\n  padding-right: 48px !important;\n}\n.pb-5 {\n  padding-bottom: 48px !important;\n}\n.pl-5 {\n  padding-left: 48px !important;\n}\n@media all and (min-width: 0) {\n  .text-xs-left {\n    text-align: left !important;\n  }\n  .text-xs-center {\n    text-align: center !important;\n  }\n  .text-xs-right {\n    text-align: right !important;\n  }\n  .text-xs-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 600px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 960px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 1264px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 1904px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-justify {\n    text-align: justify !important;\n  }\n}\n.font-weight-thin {\n  font-weight: 100 !important;\n}\n.font-weight-light {\n  font-weight: 300 !important;\n}\n.font-weight-regular {\n  font-weight: 400 !important;\n}\n.font-weight-medium {\n  font-weight: 500 !important;\n}\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n.font-weight-black {\n  font-weight: 900 !important;\n}\n.font-italic {\n  font-style: italic !important;\n}\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n.text-none {\n  text-transform: none !important;\n}\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n.text-no-wrap {\n  white-space: nowrap !important;\n}\n.text-truncate {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  line-height: 1.1 !important;\n}\n.transition-fast-out-slow-in {\n  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n.transition-linear-out-slow-in {\n  transition: 0.3s cubic-bezier(0, 0, 0.2, 1) !important;\n}\n.transition-fast-out-linear-in {\n  transition: 0.3s cubic-bezier(0.4, 0, 1, 1) !important;\n}\n.transition-ease-in-out {\n  transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;\n}\n.transition-fast-in-fast-out {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n}\n.transition-swing {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;\n}\n","global-color($color_name, $color_value)\n  .{$color_name}\n    background-color $color_value !important\n    border-color: $color_value !important\n\n  .{$color_name}--text\n    color $color_value !important\n    caret-color: $color_value !important\n\nglobal-color-accent($color_name, $color_value, $color_type)\n  .{$color_name}\n    &.{$color_type}\n      background-color $color_value !important\n      border-color: $color_value !important\n\n  .{$color_name}--text\n    &.text--{$color_type}\n      color: $color_value !important\n      caret-color: $color_value !important\n\n// Put the loop in a function so it can't leak\ncreate-global-colors()\n  for $color_name, $color_value in $shades\n    global-color($color_name, $color_value)\n\n  if ($color-pack)\n    for $color_name, $color_color in $colors\n      for $color_type, $color_value in $color_color\n        if $color_type == 'base'\n          global-color($color_name, $color_value)\n\n        else if $color_type != 'shades'\n          global-color-accent($color_name, $color_value, $color_type)\n\ncreate-global-colors()\n","@import '../settings/_elevations'\n\n// GENERATE HELPER CLASSES\nfor z in (0..24)\n  .elevation-{z}\n    elevation(z, true)\n","$shadow-key-umbra-opacity := rgba(0,0,0, .2)\n$shadow-key-penumbra-opacity := rgba(0,0,0, .14)\n$shadow-key-ambient-opacity := rgba(0,0,0, .12)\n\n$shadow-key-umbra := 0px 0px 0px 0px $shadow-key-umbra-opacity,\n                    0px 2px 1px -1px $shadow-key-umbra-opacity,\n                    0px 3px 1px -2px $shadow-key-umbra-opacity,\n                    0px 3px 3px -2px $shadow-key-umbra-opacity,\n                    0px 2px 4px -1px $shadow-key-umbra-opacity,\n                    0px 3px 5px -1px $shadow-key-umbra-opacity,\n                    0px 3px 5px -1px $shadow-key-umbra-opacity,\n                    0px 4px 5px -2px $shadow-key-umbra-opacity,\n                    0px 5px 5px -3px $shadow-key-umbra-opacity,\n                    0px 5px 6px -3px $shadow-key-umbra-opacity,\n                    0px 6px 6px -3px $shadow-key-umbra-opacity,\n                    0px 6px 7px -4px $shadow-key-umbra-opacity,\n                    0px 7px 8px -4px $shadow-key-umbra-opacity,\n                    0px 7px 8px -4px $shadow-key-umbra-opacity,\n                    0px 7px 9px -4px $shadow-key-umbra-opacity,\n                    0px 8px 9px -5px $shadow-key-umbra-opacity,\n                    0px 8px 10px -5px $shadow-key-umbra-opacity,\n                    0px 8px 11px -5px $shadow-key-umbra-opacity,\n                    0px 9px 11px -5px $shadow-key-umbra-opacity,\n                    0px 9px 12px -6px $shadow-key-umbra-opacity,\n                    0px 10px 13px -6px $shadow-key-umbra-opacity,\n                    0px 10px 13px -6px $shadow-key-umbra-opacity,\n                    0px 10px 14px -6px $shadow-key-umbra-opacity,\n                    0px 11px 14px -7px $shadow-key-umbra-opacity,\n                    0px 11px 15px -7px $shadow-key-umbra-opacity\n\n$shadow-key-penumbra := 0px 0px 0px 0px $shadow-key-penumbra-opacity,\n                        0px 1px 1px 0px $shadow-key-penumbra-opacity,\n                        0px 2px 2px 0px $shadow-key-penumbra-opacity,\n                        0px 3px 4px 0px $shadow-key-penumbra-opacity,\n                        0px 4px 5px 0px $shadow-key-penumbra-opacity,\n                        0px 5px 8px 0px $shadow-key-penumbra-opacity,\n                        0px 6px 10px 0px $shadow-key-penumbra-opacity,\n                        0px 7px 10px 1px $shadow-key-penumbra-opacity,\n                        0px 8px 10px 1px $shadow-key-penumbra-opacity,\n                        0px 9px 12px 1px $shadow-key-penumbra-opacity,\n                        0px 10px 14px 1px $shadow-key-penumbra-opacity,\n                        0px 11px 15px 1px $shadow-key-penumbra-opacity,\n                        0px 12px 17px 2px $shadow-key-penumbra-opacity,\n                        0px 13px 19px 2px $shadow-key-penumbra-opacity,\n                        0px 14px 21px 2px $shadow-key-penumbra-opacity,\n                        0px 15px 22px 2px $shadow-key-penumbra-opacity,\n                        0px 16px 24px 2px $shadow-key-penumbra-opacity,\n                        0px 17px 26px 2px $shadow-key-penumbra-opacity,\n                        0px 18px 28px 2px $shadow-key-penumbra-opacity,\n                        0px 19px 29px 2px $shadow-key-penumbra-opacity,\n                        0px 20px 31px 3px $shadow-key-penumbra-opacity,\n                        0px 21px 33px 3px $shadow-key-penumbra-opacity,\n                        0px 22px 35px 3px $shadow-key-penumbra-opacity,\n                        0px 23px 36px 3px $shadow-key-penumbra-opacity,\n                        0px 24px 38px 3px $shadow-key-penumbra-opacity\n\n$shadow-key-ambient := 0px 0px 0px 0px $shadow-key-ambient-opacity,\n                      0px 1px 3px 0px $shadow-key-ambient-opacity,\n                      0px 1px 5px 0px $shadow-key-ambient-opacity,\n                      0px 1px 8px 0px $shadow-key-ambient-opacity,\n                      0px 1px 10px 0px $shadow-key-ambient-opacity,\n                      0px 1px 14px 0px $shadow-key-ambient-opacity,\n                      0px 1px 18px 0px $shadow-key-ambient-opacity,\n                      0px 2px 16px 1px $shadow-key-ambient-opacity,\n                      0px 3px 14px 2px $shadow-key-ambient-opacity,\n                      0px 3px 16px 2px $shadow-key-ambient-opacity,\n                      0px 4px 18px 3px $shadow-key-ambient-opacity,\n                      0px 4px 20px 3px $shadow-key-ambient-opacity,\n                      0px 5px 22px 4px $shadow-key-ambient-opacity,\n                      0px 5px 24px 4px $shadow-key-ambient-opacity,\n                      0px 5px 26px 4px $shadow-key-ambient-opacity,\n                      0px 6px 28px 5px $shadow-key-ambient-opacity,\n                      0px 6px 30px 5px $shadow-key-ambient-opacity,\n                      0px 6px 32px 5px $shadow-key-ambient-opacity,\n                      0px 7px 34px 6px $shadow-key-ambient-opacity,\n                      0px 7px 36px 6px $shadow-key-ambient-opacity,\n                      0px 8px 38px 7px $shadow-key-ambient-opacity,\n                      0px 8px 40px 7px $shadow-key-ambient-opacity,\n                      0px 8px 42px 7px $shadow-key-ambient-opacity,\n                      0px 9px 44px 8px $shadow-key-ambient-opacity,\n                      0px 9px 46px 8px $shadow-key-ambient-opacity\n\n// MIXINS\nelevation($z, important = false)\n  box-shadow: $shadow-key-umbra[$z],\n              $shadow-key-penumbra[$z],\n              $shadow-key-ambient[$z] (important ? !important : )\n\nelevationTransition($duration = 280ms, $easing = cubic-bezier(.4, 0, .2, 1))\n  transition: box-shadow $duration $easing\n  will-change: box-shadow\n","/* ! ress.css • v1.1.1 - MIT License - github.com/filipelinhares/ress */\n\n/* # =================================================================\n   # Global selectors\n   # ================================================================= */\n\nhtml {\n  box-sizing: border-box;\n  overflow-y: scroll; /* All browsers without overlaying scrollbars */\n  -webkit-text-size-adjust: 100%; /* iOS 8+ */\n}\n\n*,\n::before,\n::after {\n  box-sizing: inherit;\n}\n\n::before,\n::after {\n  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */\n  vertical-align: inherit;\n}\n\n/* Remove margin, padding of all elements and set background-no-repeat as default */\n* {\n  background-repeat: no-repeat; /* Set `background-repeat: no-repeat` to all elements */\n  padding: 0; /* Reset `padding` and `margin` of all elements */\n  margin: 0;\n}\n\n/* # =================================================================\n   # General elements\n   # ================================================================= */\n\n/* Add the correct display in iOS 4-7.*/\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\nhr {\n  overflow: visible; /* Show the overflow in Edge and IE */\n}\n\n/*\n* Correct `block` display not defined for any HTML5 element in IE 8/9\n* Correct `block` display not defined for `details` or `summary` in IE 10/11\n* and Firefox\n* Correct `block` display not defined for `main` in IE 11\n*/\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\nsummary {\n  display: list-item; /* Add the correct display in all browsers */\n}\n\nsmall {\n  font-size: 80%; /* Set font-size to 80% in `small` elements */\n}\n\n[hidden],\ntemplate {\n  display: none; /* Add the correct display in IE */\n}\n\nabbr[title] {\n  border-bottom: 1px dotted; /* Add a bordered underline effect in all browsers */\n  text-decoration: none; /* Remove text decoration in Firefox 40+ */\n}\n\na {\n  background-color: transparent; /* Remove the gray background on active links in IE 10 */\n  -webkit-text-decoration-skip: objects; /* Remove gaps in links underline in iOS 8+ and Safari 8+ */\n}\n\na:active,\na:hover {\n  outline-width: 0; /* Remove the outline when hovering in all browsers */\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* Specify the font family of code elements */\n}\n\nb,\nstrong {\n  font-weight: bolder; /* Correct style set to `bold` in Edge 12+, Safari 6.2+, and Chrome 18+ */\n}\n\ndfn {\n  font-style: italic; /* Address styling not present in Safari and Chrome */\n}\n\n/* Address styling not present in IE 8/9 */\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/* https://gist.github.com/unruthless/413930 */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* # =================================================================\n   # Forms\n   # ================================================================= */\n\ninput {\n  border-radius: 0;\n}\n\n/* Apply cursor pointer to button elements */\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"]\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/* Replace pointer cursor in disabled elements */\n[disabled] {\n  cursor: default;\n}\n\n[type=\"number\"] {\n  width: auto; /* Firefox 36+ */\n}\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* Safari 8+ */\n}\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; /* Safari 8 */\n}\n\ntextarea {\n  overflow: auto; /* Internet Explorer 11+ */\n  resize: vertical; /* Specify textarea resizability */\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* Specify font inheritance of form elements */\n}\n\noptgroup {\n  font-weight: bold; /* Restore the font weight unset by the previous rule. */\n}\n\nbutton {\n  overflow: visible; /* Address `overflow` set to `hidden` in IE 8/9/10/11 */\n}\n\n/* Remove inner padding and border in Firefox 4+ */\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: 0;\n  padding: 0;\n}\n\n/* Replace focus style removed in the border reset above */\nbutton:-moz-focusring,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  outline: 0;\n  border: 0;\n}\n\nbutton,\nhtml [type=\"button\"], /* Prevent a WebKit bug where (2) destroys native `audio` and `video`controls in Android 4 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */\n}\n\nbutton,\nselect {\n  text-transform: none; /* Firefox 40+, Internet Explorer 11- */\n}\n\n/* Remove the default button styling in all browsers */\nbutton,\ninput,\nselect,\ntextarea {\n  background-color: transparent;\n  border-style: none;\n  color: inherit;\n}\n\n/* Style select like a standard input */\nselect {\n  -moz-appearance: none; /* Firefox 36+ */\n  -webkit-appearance: none; /* Chrome 41+ */\n}\n\nselect::-ms-expand {\n  display: none; /* Internet Explorer 11+ */\n}\n\nselect::-ms-value {\n  color: currentColor; /* Internet Explorer 11+ */\n}\n\nlegend {\n  border: 0; /* Correct `color` not being inherited in IE 8/9/10/11 */\n  color: inherit; /* Correct the color inheritance from `fieldset` elements in IE */\n  display: table; /* Correct the text wrapping in Edge and IE */\n  max-width: 100%; /* Correct the text wrapping in Edge and IE */\n  white-space: normal; /* Correct the text wrapping in Edge and IE */\n}\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS and Safari */\n  font: inherit; /* Change font properties to `inherit` in Chrome and Safari */\n}\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */\n  outline-offset: -2px; /* Correct the outline style in Safari */\n}\n\n/* # =================================================================\n   # Specify media element style\n   # ================================================================= */\n\nimg {\n  border-style: none; /* Remove border when inside `a` element in IE 8/9/10 */\n}\n\n/* Add the correct vertical alignment in Chrome, Firefox, and Opera */\nprogress {\n  vertical-align: baseline;\n}\n\nsvg:not(:root) {\n  overflow: hidden; /* Internet Explorer 11- */\n}\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; /* Internet Explorer 11+, Windows Phone 8.1+ */\n}\n\n/* # =================================================================\n   # Acessibility\n   # ================================================================= */\n\n/* Hide content from screens but not screenreaders */\n@media screen {\n  [hidden~=\"screen\"] {\n    display: inherit;\n  }\n  [hidden~=\"screen\"]:not(:active):not(:focus):not(:target) {\n    position: absolute !important;\n    clip: rect(0 0 0 0) !important;\n  }\n}\n\n/* Specify the progress cursor of updating elements */\n[aria-busy=\"true\"] {\n  cursor: progress;\n}\n\n/* Specify the pointer cursor of trigger elements */\n[aria-controls] {\n  cursor: pointer;\n}\n\n/* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */\n[aria-disabled] {\n  cursor: default;\n}\n\n/* # =================================================================\n   # Selection\n   # ================================================================= */\n\n/* Specify text selection background color and omit drop shadow */\n\n::-moz-selection {\n  background-color: #b3d4fc; /* Required when declaring ::selection */\n  color: #000;\n  text-shadow: none;\n}\n\n::selection {\n  background-color: #b3d4fc; /* Required when declaring ::selection */\n  color: #000;\n  text-shadow: none;\n}\n","transition-default()\n  &-enter-active,\n  &-leave-active\n    transition: $primary-transition\n\n  &-move\n    transition: transform .6s\n\n// Component specific transitions\n.bottom-sheet-transition\n  &-enter\n    transform: translateY(100%)\n\n  &-leave-to\n    transform: translateY(100%)\n\n.carousel-transition\n  &-enter\n    transform: translate(100%, 0)\n\n  &-leave, &-leave-to\n    position: absolute\n    top: 0\n    transform: translate(-100%, 0)\n\n.carousel-reverse-transition\n  &-enter\n    transform: translate(-100%, 0)\n\n  &-leave, &-leave-to\n    position: absolute\n    top: 0\n    transform: translate(100%, 0)\n\n.dialog-transition\n  &-enter, &-leave-to\n    transform: scale(0.5)\n    opacity: 0\n\n  &-enter-to, &-leave\n    opacity: 1\n\n.dialog-bottom-transition\n  &-enter, &-leave-to\n    transform: translateY(100%)\n\n.picker-transition,\n.picker-reverse-transition\n  &-enter-active,\n  &-leave-active\n    transition: .3s $transition.linear-out-slow-in\n\n  &-enter,\n  &-leave-to\n    opacity: 0\n\n  &-leave,\n  &-leave-active,\n  &-leave-to\n    position: absolute !important\n\n.picker-transition\n  &-enter\n    transform: translate(0, 100%)\n\n  &-leave-to\n    transform: translate(0, -100%)\n\n.picker-reverse-transition\n  &-enter\n    transform: translate(0, -100%)\n\n  &-leave-to\n    transform: translate(0, 100%)\n\n.picker-title-transition\n  &-enter-to,\n  &-leave\n    transform: translate(0, 0)\n\n  &-enter\n    transform: translate(-100%, 0)\n\n  &-leave-to\n    opacity: 0\n    transform: translate(100%, 0)\n\n  &-leave,\n  &-leave-to,\n  &-leave-active\n    position: absolute !important\n\n.tab-transition\n  &-enter\n    transform: translate(100%, 0)\n\n  &-leave, &-leave-active\n    position: absolute\n    top: 0\n\n  &-leave-to\n    position: absolute\n    transform: translate(-100%, 0)\n\n.tab-reverse-transition\n  &-enter\n    transform: translate(-100%, 0)\n\n  &-leave, &-leave-to\n    top: 0\n    position: absolute\n    transform: translate(100%, 0)\n\n// Generic transitions\n.expand-transition\n  transition-default()\n\n.expand-x-transition\n  transition-default()\n\n.scale-transition\n  transition-default()\n\n  &-enter, &-leave, &-leave-to\n    opacity: 0\n    transform: scale(0)\n\n.message-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n    transform: translateY(-15px)\n\n  &-leave, &-leave-active\n    position: absolute\n\n.slide-y-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n    transform: translateY(-15px)\n\n.slide-y-reverse-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n    transform: translateY(15px)\n\n.scroll-y-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n\n  &-enter\n    transform: translateY(-15px)\n\n  &-leave-to\n    transform: translateY(15px)\n\n.scroll-y-reverse-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n\n  &-enter\n    transform: translateY(15px)\n\n  &-leave-to\n    transform: translateY(-15px)\n\n.scroll-x-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n\n  &-enter\n    transform: translateX(-15px)\n\n  &-leave-to\n    transform: translateX(15px)\n\n.scroll-x-reverse-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n\n  &-enter\n    transform: translateX(15px)\n\n  &-leave-to\n    transform: translateX(-15px)\n\n.slide-x-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n    transform: translateX(-15px)\n\n.slide-x-reverse-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n    transform: translateX(15px)\n\n.fade-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    opacity: 0\n\n.fab-transition\n  transition-default()\n\n  &-enter, &-leave-to\n    transform: scale(0) rotate(-45deg)\n",".blockquote\n  padding: $spacers.three.y 0 $spacers.three.y $spacers.four.x\n  font-size: 18px\n  font-weight: 300","code, kbd\n  display: inline-block\n  border-radius: 3px\n  white-space: pre-wrap\n  font-size: 85%\n  font-weight: 900\n\n  &:after,\n  &:before\n    content: \"\\00a0\"\n    letter-spacing: -1px\n\ncode\n  background-color: $grey.lighten-4\n  color: #bd4147\n  elevation(1)\n\nkbd\n  background: $grey.darken-2\n  color: #fff\n","html\n  font-size: $font-size-root\n  overflow-x: hidden\n  text-rendering: optimizeLegibility\n  -webkit-font-smoothing: antialiased\n  -moz-osx-font-smoothing: grayscale\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0)\n\n.application\n  font-family: $body-font-family\n  line-height: $line-height-root\n\n::-ms-clear\n::-ms-reveal\n  display: none\n","ul, ol\n  padding-left: $spacers.four.x\n",".display-4\n  font-size: $headings.h1.size !important\n  font-weight: $headings.h1.weight\n  line-height: $headings.h1.line-height !important\n  letter-spacing: $headings.h1.letter-spacing !important\n  font-family: $headings.h1.font-family !important\n\n.display-3\n  font-size: $headings.h2.size !important\n  font-weight: $headings.h2.weight\n  line-height: $headings.h2.line-height !important\n  letter-spacing: $headings.h2.letter-spacing !important\n  font-family: $headings.h2.font-family !important\n\n.display-2\n  font-size: $headings.h3.size !important\n  font-weight: $headings.h3.weight\n  line-height: $headings.h3.line-height !important\n  letter-spacing: $headings.h3.letter-spacing !important\n  font-family: $headings.h3.font-family !important\n\n.display-1\n  font-size: $headings.h4.size !important\n  font-weight: $headings.h4.weight\n  line-height: $headings.h4.line-height !important\n  letter-spacing: $headings.h4.letter-spacing !important\n  font-family: $headings.h4.font-family !important\n\n.headline\n  font-size: $headings.h5.size !important\n  font-weight: $headings.h5.weight\n  line-height: $headings.h5.line-height !important\n  letter-spacing: $headings.h5.letter-spacing !important\n  font-family: $headings.h5.font-family !important\n\n.title\n  font-size: $headings.h6.size !important\n  font-weight: $headings.h6.weight\n  line-height: $headings.h6.line-height !important\n  letter-spacing: $headings.h6.letter-spacing !important\n  font-family: $headings.h6.font-family !important\n\n.subheading\n  font-size: $headings.subheading.size !important\n  font-weight: $headings.subheading.weight\n\n.body-2\n  font-size: $headings.body-2.size !important\n  font-weight: $headings.body-2.weight\n\n.body-1\n  font-size: $headings.body-1.size !important\n  font-weight: $headings.body-1.weight\n\n.caption\n  font-size: $headings.caption.size !important\n  font-weight: $headings.caption.weight\n\np\n  margin-bottom: $spacers.three.y\n","for $size, $media_query in $display-breakpoints\n  .hidden\n    &-{$size}\n      @media $media_query\n        display: none !important\n\n.overflow-hidden\n  overflow: hidden\n\n.overflow-x-hidden\n  overflow-x: hidden\n\n.overflow-y-hidden\n  overflow-y: hidden\n",".right\n  float: right !important\n  \n.left\n  float: left !important",".ma-auto\n  margin-top: auto !important\n  margin-right: auto !important\n  margin-bottom: auto !important\n  margin-left: auto !important\n\n.my-auto\n  margin-top: auto !important\n  margin-bottom: auto !important\n\n.mx-auto\n  margin-left: auto !important\n  margin-right: auto !important\n\n.mt-auto\n  margin-top: auto !important\n\n.mr-auto\n  margin-right: auto !important\n\n.mb-auto\n  margin-bottom: auto !important\n\n.ml-auto\n  margin-left: auto !important\n\n$i = 0\nfor $level, $spacer in $spacers\n  .ma-{$i}\n    margin: $spacer.y $spacer.x !important\n  .my-{$i}\n    margin-top: $spacer.y !important\n    margin-bottom: $spacer.y !important\n  .mx-{$i}\n    margin-left: $spacer.x !important\n    margin-right: $spacer.x !important\n  .mt-{$i}\n    margin-top: $spacer.y !important\n  .mr-{$i}\n    margin-right: $spacer.x !important\n  .mb-{$i}\n    margin-bottom: $spacer.y !important\n  .ml-{$i}\n    margin-left: $spacer.x !important\n\n  .pa-{$i}\n    padding: $spacer.y $spacer.x !important\n  .py-{$i}\n    padding-top: $spacer.y !important\n    padding-bottom: $spacer.y !important\n  .px-{$i}\n    padding-left: $spacer.x !important\n    padding-right: $spacer.x !important\n  .pt-{$i}\n    padding-top: $spacer.y !important\n  .pr-{$i}\n    padding-right: $spacer.x !important\n  .pb-{$i}\n    padding-bottom: $spacer.y !important\n  .pl-{$i}\n    padding-left: $spacer.x !important\n\n  $i = $i + 1\n","for $size, $width in $grid-breakpoints\n  @media all and (min-width: $width)\n    .text-{$size}-left\n      text-align: left !important\n\n    .text-{$size}-center\n      text-align: center !important\n\n    .text-{$size}-right\n      text-align: right !important\n\n    .text-{$size}-justify\n      text-align: justify !important\n\nfor $name, $weight in $font-weights\n  .font-weight\n    &-{$name}\n      font-weight: $weight !important\n\n.font-italic\n  font-style: italic !important\n\n.text-capitalize\n  text-transform: capitalize !important\n\n.text-lowercase\n  text-transform: lowercase !important\n\n.text-none\n  text-transform: none !important\n\n.text-uppercase\n  text-transform: uppercase !important\n\n.text-no-wrap\n  white-space: nowrap !important\n\n.text-truncate\n  white-space: nowrap !important\n  overflow: hidden !important\n  text-overflow: ellipsis !important\n  line-height: 1.1 !important\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
